(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6748],{

/***/ 79696:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SensorConfigEnums"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"units"},"name":{"kind":"Name","value":"__type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"Unit","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"units"},"name":{"kind":"Name","value":"enumValues"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"analogInputRanges"},"name":{"kind":"Name","value":"__type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"AnalogInputRange","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"analogInputRanges"},"name":{"kind":"Name","value":"enumValues"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sensorTypes"},"name":{"kind":"Name","value":"__type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"SensorType","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"sensorTypes"},"name":{"kind":"Name","value":"enumValues"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":379}}');
    doc.loc.source = JSON.parse('{"body":"fragment SensorConfigEnums on Query {\\n  units: __type(name: \\"Unit\\") {\\n    units: enumValues {\\n      name\\n      description\\n    }\\n  }\\n  analogInputRanges: __type(name: \\"AnalogInputRange\\") {\\n    analogInputRanges: enumValues {\\n      name\\n      description\\n    }\\n  }\\n  sensorTypes: __type(name: \\"SensorType\\") {\\n    sensorTypes: enumValues {\\n      name\\n      description\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 71449:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SensorConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SensorConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"findStops"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"energyMeter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopRegisterThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopValueThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataMultiplier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validatedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analogOffset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analogInputRange"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensorUnit"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"accumulatorConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetsOnPowerOff"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rolloverValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rolloverThreshold"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"discreteConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onStates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offStates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultState"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"kpiConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayKPIs"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"validatedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"publishRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sampleRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"triggerIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataAlarm"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationFrequency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updateBuffer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"repeatNotification"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"chartTimeScale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chart"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataFilter"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":727}}');
    doc.loc.source = JSON.parse('{"body":"fragment SensorConfig on SensorConfig {\\n  type\\n  stopThreshold\\n  findStops\\n  energyMeter\\n  stopRegisterThreshold\\n  stopValueThreshold\\n  dataMultiplier\\n  validatedSpeed\\n  expectedSpeed\\n  analogOffset\\n  analogInputRange\\n  sensorUnit {\\n    unit\\n    label\\n  }\\n  accumulatorConfig {\\n    resetsOnPowerOff\\n    rolloverValue\\n    rolloverThreshold\\n  }\\n  discreteConfig {\\n    onStates\\n    offStates\\n    defaultState\\n  }\\n  kpiConfig {\\n    displayKPIs\\n  }\\n  validatedSpeed\\n  expectedSpeed\\n  publishRate\\n  sampleRate\\n  triggerIndex\\n  dataAlarm {\\n    subscribers {\\n      type\\n      value\\n      languageCode\\n    }\\n    notificationFrequency\\n    updateBuffer\\n    repeatNotification\\n  }\\n  chartTimeScale\\n  chart {\\n    scale\\n    dataFilter\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 1111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StopCauseCategories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StopCauseCategory"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ownerType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopCauses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StopCause"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":205}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/stop-cause.gql\'\\n\\nfragment StopCauseCategories on StopCauseCategory {\\n  _id\\n  id\\n  name\\n  ownerType\\n  stopCauses {\\n    ...StopCause\\n  }\\n  meta {\\n    name\\n    languageCode\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(16634).definitions)));


      module.exports = doc;
    


/***/ }),

/***/ 64956:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StopCauseMapping"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StopCauseMapping"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peripheralIdTarget"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralIdEvent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopCauseId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buffer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lookForward"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lookBack"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"regPriority"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"split"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":169}}');
    doc.loc.source = JSON.parse('{"body":"fragment StopCauseMapping on StopCauseMapping {\\n  peripheralIdTarget\\n  peripheralIdEvent\\n  value\\n  stopCauseId\\n  buffer\\n  lookForward\\n  lookBack\\n  regPriority\\n  split\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 16634:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StopCause"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StopCause"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requireInitials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requireComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableCountermeasure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetSetup"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constantTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parameterTimes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parameter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unlessParameter"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":335}}');
    doc.loc.source = JSON.parse('{"body":"fragment StopCause on StopCause {\\n  _id\\n  id\\n  name\\n  description\\n  categoryName\\n  meta {\\n    name\\n    description\\n    languageCode\\n  }\\n  languageCode\\n  stopType\\n  requireInitials\\n  requireComment\\n  enableCountermeasure\\n  targetSetup {\\n    constantTime\\n    parameterTimes {\\n      parameter\\n      time\\n      unlessParameter\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 10859:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPeripheral"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"softwareId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePeripheralInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"initialGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPeripheral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"softwareId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"softwareId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"initialGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"initialGroups"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":268}}');
    doc.loc.source = JSON.parse('{"body":"mutation createPeripheral($softwareId: ID!, $input: CreatePeripheralInput!, $initialGroups: [ID!]) {\\n  createPeripheral(softwareId: $softwareId, input: $input, initialGroups: $initialGroups) {\\n    _id\\n    peripheralId\\n    peripheralType\\n    name\\n    description\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.createPeripheral = oneQuery(doc, "createPeripheral");
        


/***/ }),

/***/ 65053:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePeripheral"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePeripheral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peripheralId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}}}],"directives":[]}]}}],"loc":{"start":0,"end":98}}');
    doc.loc.source = JSON.parse('{"body":"mutation deletePeripheral($peripheralId: ID!) {\\n  deletePeripheral(peripheralId: $peripheralId)\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.deletePeripheral = oneQuery(doc, "deletePeripheral");
        


/***/ }),

/***/ 4929:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deviceAttachCamera"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sensorPeripheralId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachCamera"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peripheralId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sensorPeripheralId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sensorPeripheralId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachedSensors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"index"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":313}}');
    doc.loc.source = JSON.parse('{"body":"mutation deviceAttachCamera($peripheralId: ID!, $sensorPeripheralId: ID!) {\\n  attachCamera(peripheralId: $peripheralId, sensorPeripheralId: $sensorPeripheralId) {\\n    _id\\n    peripheralId\\n    attachedSensors {\\n      _id\\n      peripheralId\\n      peripheralType\\n      index\\n      name\\n      description\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.deviceAttachCamera = oneQuery(doc, "deviceAttachCamera");
        


/***/ }),

/***/ 9936:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deviceDetachCamera"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sensorPeripheralId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"detachCamera"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peripheralId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sensorPeripheralId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sensorPeripheralId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachedSensors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"index"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":313}}');
    doc.loc.source = JSON.parse('{"body":"mutation deviceDetachCamera($peripheralId: ID!, $sensorPeripheralId: ID!) {\\n  detachCamera(peripheralId: $peripheralId, sensorPeripheralId: $sensorPeripheralId) {\\n    _id\\n    peripheralId\\n    attachedSensors {\\n      _id\\n      peripheralId\\n      peripheralType\\n      index\\n      name\\n      description\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.deviceDetachCamera = oneQuery(doc, "deviceDetachCamera");
        


/***/ }),

/***/ 68912:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deviceUpdateDevice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"meta"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceMetaInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDevice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"meta"},"value":{"kind":"Variable","name":{"kind":"Name","value":"meta"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hardwareId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":165}}');
    doc.loc.source = JSON.parse('{"body":"mutation deviceUpdateDevice($uuid: ID!, $meta: DeviceMetaInput) {\\n  updateDevice(uuid: $uuid, meta: $meta) {\\n    _id\\n    uuid\\n    hardwareId\\n    type\\n    name\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.deviceUpdateDevice = oneQuery(doc, "deviceUpdateDevice");
        


/***/ }),

/***/ 92590:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deviceUpdateNetworkSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeneralNetworkSettingsInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeviceNetworkSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[]}]}}],"loc":{"start":0,"end":149}}');
    doc.loc.source = JSON.parse('{"body":"mutation deviceUpdateNetworkSettings($uuid: ID!, $input: GeneralNetworkSettingsInput!) {\\n  updateDeviceNetworkSettings(uuid: $uuid, input: $input)\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.deviceUpdateNetworkSettings = oneQuery(doc, "deviceUpdateNetworkSettings");
        


/***/ }),

/***/ 54223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deviceUpdatePeripheral"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"meta"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PeripheralMetaInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConfigInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePeripheral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peripheralId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}}},{"kind":"Argument","name":{"kind":"Name","value":"meta"},"value":{"kind":"Variable","name":{"kind":"Name","value":"meta"}}},{"kind":"Argument","name":{"kind":"Name","value":"config"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Sensor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":394}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n\\nmutation deviceUpdatePeripheral($peripheralId: ID!, $meta: PeripheralMetaInput, $config: UpdateConfigInput) {\\n  updatePeripheral(peripheralId: $peripheralId, meta: $meta, config: $config) {\\n    _id\\n    id\\n    peripheralId\\n    peripheralType\\n    name\\n    description\\n    ... on Sensor {\\n      config {\\n        ...SensorConfig\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.deviceUpdatePeripheral = oneQuery(doc, "deviceUpdatePeripheral");
        


/***/ }),

/***/ 83199:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deviceUpdateStopCauseMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createStopCauseMapping"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StopCauseMappingInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteStopCauseMapping"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StopCauseMappingInput"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateStopCauseMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peripheralId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createStopCauseMapping"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createStopCauseMapping"}}},{"kind":"Argument","name":{"kind":"Name","value":"deleteStopCauseMapping"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteStopCauseMapping"}}}],"directives":[]}]}}],"loc":{"start":0,"end":338}}');
    doc.loc.source = JSON.parse('{"body":"mutation deviceUpdateStopCauseMapping(\\n  $peripheralId: ID!\\n  $createStopCauseMapping: [StopCauseMappingInput!]!\\n  $deleteStopCauseMapping: [StopCauseMappingInput!]!\\n) {\\n  updateStopCauseMapping(\\n    peripheralId: $peripheralId\\n    createStopCauseMapping: $createStopCauseMapping\\n    deleteStopCauseMapping: $deleteStopCauseMapping\\n  )\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.deviceUpdateStopCauseMapping = oneQuery(doc, "deviceUpdateStopCauseMapping");
        


/***/ }),

/***/ 18374:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"forgetWiFi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgetWiFi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[]}]}}],"loc":{"start":0,"end":90}}');
    doc.loc.source = JSON.parse('{"body":"mutation forgetWiFi($uuid: ID!, $input: ID!) {\\n  forgetWiFi(uuid: $uuid, input: $input)\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.forgetWiFi = oneQuery(doc, "forgetWiFi");
        


/***/ }),

/***/ 51645:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertWiFi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NetworkInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertWiFi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[]}]}}],"loc":{"start":0,"end":100}}');
    doc.loc.source = JSON.parse('{"body":"mutation upsertWiFi($uuid: ID!, $input: NetworkInput!) {\\n  upsertWiFi(uuid: $uuid, input: $input)\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.upsertWiFi = oneQuery(doc, "upsertWiFi");
        


/***/ }),

/***/ 91353:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"administrationDevicePeripherals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hardwareId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmwareVersions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"application"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bootloader"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wifi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cellular"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"hardwareVersion"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"network"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wifi"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"networks"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ssid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"password"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reported"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"networks"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ssid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"password"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"general"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallback"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"reported"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallback"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"peripherals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"index"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offlineStatus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastReceived"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":895}}');
    doc.loc.source = JSON.parse('{"body":"query administrationDevicePeripherals($uuid: ID!) {\\n  device(uuid: $uuid) {\\n    _id\\n    uuid\\n    hardwareId\\n    type\\n    name\\n    owner\\n    status {\\n      firmwareVersions {\\n        application\\n        bootloader\\n        wifi\\n        cellular\\n      }\\n      hardwareVersion\\n    }\\n    network {\\n      wifi {\\n        desired {\\n          enabled\\n          networks {\\n            id\\n            ssid\\n            password\\n          }\\n        }\\n        reported {\\n          enabled\\n          networks {\\n            id\\n            ssid\\n            password\\n          }\\n        }\\n      }\\n      general {\\n        desired {\\n          fallback\\n        }\\n        reported {\\n          fallback\\n        }\\n      }\\n    }\\n    peripherals {\\n      _id\\n      name\\n      index\\n      peripheralId\\n      peripheralType\\n      description\\n      offlineStatus {\\n        expiration\\n        lastReceived\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.administrationDevicePeripherals = oneQuery(doc, "administrationDevicePeripherals");
        


/***/ }),

/***/ 50936:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"devicesSimple"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devices"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripherals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"index"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Sensor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Camera"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streamURL"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachedSensors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"index"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":674}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n\\n# TODO: These two requests should be rewritten to one, where the samples part is\\n# @defer. Maybe with a directive for server based pagination on the time Field?\\n\\nquery devicesSimple {\\n  devices {\\n    _id\\n    uuid\\n    type\\n    peripherals {\\n      _id\\n      index\\n      peripheralId\\n      name\\n      description\\n      peripheralType\\n      ... on Sensor {\\n        config {\\n          ...SensorConfig\\n        }\\n      }\\n      ... on Camera {\\n        streamURL\\n        attachedSensors {\\n          _id\\n          peripheralId\\n          peripheralType\\n          index\\n          name\\n          description\\n        }\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.devicesSimple = oneQuery(doc, "devicesSimple");
        


/***/ }),

/***/ 55199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sensorSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peripheralByID"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peripheralId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"peripheralId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Sensor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralInformation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"line"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SensorConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wiring"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reported"},"arguments":[],"directives":[]}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Camera"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachedSensors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfigEnums"},"directives":[]}]}}],"loc":{"start":0,"end":783}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n#import \'@/graphql/fragments/sensor-config-enums.gql\'\\n\\nquery sensorSettings($peripheralId: ID!) {\\n  peripheralByID(peripheralId: $peripheralId) {\\n    name\\n    _id\\n    peripheralId\\n    peripheralType\\n    name\\n    owner\\n    description\\n    ... on Sensor {\\n      id\\n      peripheralInformation {\\n        node {\\n          type\\n        }\\n        line {\\n          id\\n          name\\n        }\\n      }\\n      config {\\n        ...SensorConfig\\n        ... on SensorConfig {\\n          wiring {\\n            desired\\n            reported\\n          }\\n        }\\n      }\\n    }\\n    ... on Camera {\\n      attachedSensors {\\n        _id\\n        peripheralId\\n        peripheralType\\n        name\\n        description\\n      }\\n    }\\n  }\\n  ...SensorConfigEnums\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(79696).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.sensorSettings = oneQuery(doc, "sensorSettings");
        


/***/ }),

/***/ 70130:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"stopCauseMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"index"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"index"},"value":{"kind":"Variable","name":{"kind":"Name","value":"index"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopCauseCategories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StopCauseCategories"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stopCauseMappings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StopCauseMapping"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":399}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/stop-cause-categories.gql\'\\n#import \'@/graphql/fragments/stop-cause-mapping.gql\'\\n\\nquery stopCauseMapping($uuid: ID!, $index: ID!) {\\n  device(uuid: $uuid) {\\n    uuid\\n    owner\\n    _id\\n    sensor(index: $index) {\\n      _id\\n      id\\n      stopCauseCategories {\\n        ...StopCauseCategories\\n      }\\n      stopCauseMappings {\\n        ...StopCauseMapping\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(1111).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(64956).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.stopCauseMapping = oneQuery(doc, "stopCauseMapping");
        


/***/ }),

/***/ 36415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VW": function() { return /* binding */ containsPipeSymbol; },
/* harmony export */   "XF": function() { return /* binding */ isValidFloatNumber; },
/* harmony export */   "mG": function() { return /* binding */ isValidSensorTagName; },
/* harmony export */   "vV": function() { return /* binding */ isValidEmail; },
/* harmony export */   "yf": function() { return /* binding */ isValidPhoneNumber; }
/* harmony export */ });
var isValidEmail = function(email) {
    var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email.toLowerCase());
};
var isValidPhoneNumber = function(phoneNumber) {
    //The number starts with +, contains numbers, is of length between 1  and 14
    var regex = /^\+[1-9]{1}[0-9]{1,14}$/;
    return regex.test(phoneNumber);
};
var isValidSensorTagName = function(tagName) {
    var regex = /^[a-zA-Z0-9\.\_]{1,}$/;
    return regex.test(tagName);
};
var containsPipeSymbol = function(text) {
    var regex = /[|]/;
    return regex.test(text);
};
var isValidFloatNumber = function(text) {
    var regex = /^-?\d+\.?\d*$/;
    return regex.test(text);
};


/***/ }),

/***/ 33228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ create_peripheral_dialog; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(36712);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(32382);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(55537);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(50544);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.5.3/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(76398);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/index.js
var client = __webpack_require__(62523);
// EXTERNAL MODULE: ../../modules/common/dist/es/data-validator.js
var data_validator = __webpack_require__(36415);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/CheckBox.js
var CheckBox = __webpack_require__(76379);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/CheckBoxOutlineBlank.js
var CheckBoxOutlineBlank = __webpack_require__(87892);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(41828);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Accordion/Accordion.js
var Accordion = __webpack_require__(62734);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(77161);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(87746);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(6203);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(3908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(53563);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(97591);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(53189);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(30810);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(1827);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Autocomplete/Autocomplete.js
var Autocomplete = __webpack_require__(41791);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(84074);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_react@17.0.2/node_modules/tss-react/esm/mui.js
var mui = __webpack_require__(71601);
// EXTERNAL MODULE: ./components/dialogs/dialog-header.tsx
var dialog_header = __webpack_require__(69538);
// EXTERNAL MODULE: ./components/loading/loading-or-error.tsx
var loading_or_error = __webpack_require__(67223);
// EXTERNAL MODULE: ./graphql/mutations/create-peripheral.gql
var create_peripheral = __webpack_require__(10859);
var create_peripheral_default = /*#__PURE__*/__webpack_require__.n(create_peripheral);
// EXTERNAL MODULE: ./graphql/queries/administration-detailed-groups.gql
var administration_detailed_groups = __webpack_require__(89867);
var administration_detailed_groups_default = /*#__PURE__*/__webpack_require__.n(administration_detailed_groups);
// EXTERNAL MODULE: ./helpers/helper-functions.ts
var helper_functions = __webpack_require__(51843);
// EXTERNAL MODULE: ./helpers/input.tsx
var input = __webpack_require__(49301);
;// CONCATENATED MODULE: ./components/dialogs/create-peripheral/create-peripheral-content.tsx



































var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        createSensor: {
            marginTop: "10px",
            left: "70%",
            width: "150px"
        },
        moveToRight: {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            position: "absolute",
            right: "80px",
            top: "auto"
        },
        accordion: {
            marginBottom: "2px",
            boxShadow: "1px 2px 4px 1px #888888"
        },
        accordionDetails: {
            display: "flex",
            flexDirection: "column"
        },
        topPadding: {
            paddingTop: theme.spacing(3)
        }
    };
});
var CreatePeripheralContent = function(param) {
    var softwareId = param.softwareId, onClose = param.onClose, onDone = param.onDone, device = param.device, groups = param.groups;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var classes = useStyles().classes;
    var ref1 = (0,react.useState)(null), selectedPort = ref1[0], setSelectedPort = ref1[1];
    var ref2 = (0,react.useState)(""), tagName = ref2[0], setTagName = ref2[1];
    var ref3 = (0,react.useState)(""), name = ref3[0], setName = ref3[1];
    var ref4 = (0,react.useState)(""), description = ref4[0], setDescription = ref4[1];
    var ref5 = (0,react.useState)([]), searchValue = ref5[0], setSearchValue = ref5[1];
    var ref6 = (0,react.useState)([]), createdPeripherals = ref6[0], setCreatedPeripherals = ref6[1];
    // FIXME: Backend relies on client supplying the super and readonly groups
    var superGroupId = (0,react.useMemo)(function() {
        var ref;
        return (ref = groups.find(function(group) {
            return group.name.toLowerCase() === "super";
        })) === null || ref === void 0 ? void 0 : ref.id;
    }, [
        groups
    ]);
    var readonlyGroupId = (0,react.useMemo)(function() {
        var ref;
        return (ref = groups.find(function(group) {
            return group.name.toLowerCase() === "read-only";
        })) === null || ref === void 0 ? void 0 : ref.id;
    }, [
        groups
    ]);
    var loading = !groups || !softwareId || !(device === null || device === void 0 ? void 0 : device.type) || !(device === null || device === void 0 ? void 0 : device.peripherals);
    var addedGroups = (0,react.useMemo)(function() {
        var newGroupIds = [];
        searchValue.forEach(function(sv) {
            if ((0,input/* isSearchValueType */.o)(sv)) {
                newGroupIds.push(sv.id);
            }
        });
        return newGroupIds;
    }, [
        searchValue
    ]);
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((create_peripheral_default()), {
        onCompleted: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var createdPeripheral;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    createdPeripheral = data.createPeripheral;
                    if (createdPeripheral) {
                        setCreatedPeripherals((0,_to_consumable_array/* default */.Z)(createdPeripherals).concat([
                            createdPeripheral
                        ]));
                    }
                    setTagName("");
                    setName("");
                    setDescription("");
                    setSearchValue([]);
                    return [
                        2
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }()
    }), 2), createPeripheralMutation = ref7[0], ref8 = ref7[1], loadingCreatePeripheral = ref8.loading;
    var onIndexChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(setTagName), []);
    var onNameChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(setName), []);
    var onDescriptionChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(setDescription), []);
    var onCreatePeripheral = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!softwareId) {
                            console.error("Missing software id!");
                            return [
                                2
                            ];
                        }
                        if (!superGroupId || !readonlyGroupId) {
                            console.error("Missing super group or read-only group!");
                        }
                        return [
                            4,
                            createPeripheralMutation({
                                variables: {
                                    softwareId: softwareId,
                                    input: {
                                        index: tagName,
                                        name: name,
                                        description: description
                                    },
                                    // FIXME: Backend requires super and read-only group to be supplied, this is a tenmporary fix and should not rely on FE to supply this
                                    initialGroups: superGroupId && readonlyGroupId ? [
                                        superGroupId,
                                        readonlyGroupId
                                    ].concat((0,_to_consumable_array/* default */.Z)(addedGroups)) : (0,_to_consumable_array/* default */.Z)(addedGroups)
                                },
                                // Refetches the latest peripheral information - updates the list
                                refetchQueries: [
                                    {
                                        query: (administration_detailed_groups_default())
                                    }
                                ],
                                awaitRefetchQueries: true
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onCreatePeripheral() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSelectedPortChange = function(selectedPort) {
        return function(event, isExpanded) {
            setTagName("");
            setName("");
            setDescription("");
            setSelectedPort(isExpanded ? selectedPort : null);
        };
    };
    // FIXME: This piece could be simplified a great deal. We should really just
    // have a predefined mapping with proper translation keys.
    //
    // The code below is essentially just a filter and we can terminate early to
    // avoid several loops by checking type !== 'plc' at the very start.
    var renderSetupSensorPorts = function() {
        if (!(device === null || device === void 0 ? void 0 : device.type) || !(device === null || device === void 0 ? void 0 : device.peripherals)) {
            return;
        }
        var portTagNames = portsFromDeviceType(device);
        var isUnknownPortLength = portTagNames.length === 0;
        if (isUnknownPortLength) {
            return renderNewPeripheralPort("0", false);
        }
        var alreadySetupPorts = portTagNames.map(function(tagName) {
            var isBBDevice = device.type !== "plc";
            return createdPeripherals.some(function(p) {
                return getTagName(p.peripheralId, isBBDevice) === (isBBDevice ? incrementString(tagName) : tagName);
            }) || (device === null || device === void 0 ? void 0 : device.peripherals.some(function(p) {
                return (p === null || p === void 0 ? void 0 : p.index) === tagName;
            }));
        });
        var peripheralsToRender = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = portTagNames.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), index = _value[0], name = _value[1];
                if (!alreadySetupPorts[index]) {
                    // Only possible for Blackbird managed devices
                    peripheralsToRender.push(renderNewPeripheralPort(name, true));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return peripheralsToRender.length === 0 && createdPeripherals.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            children: t([
                "shared:noAvailablePorts"
            ], {
                defaultValue: "No available ports - all ports already set up"
            })
        }) : peripheralsToRender;
    };
    // IndexIsTagName is true only for fbduo for now
    var renderNewPeripheralPort = function(portIndex, indexIsTagName) {
        var nameKey = "name-".concat(portIndex);
        var indexKey = "index-".concat(portIndex);
        var descriptionKey = "description-".concat(portIndex);
        if (indexIsTagName && tagName !== portIndex && selectedPort === portIndex) {
            setTagName(portIndex);
        }
        var tagNameError = !indexIsTagName && !tagName.length || !(0,data_validator/* isValidSensorTagName */.mG)(tagName);
        var sensorNameError = !name.length;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
            onChange: onSelectedPortChange(portIndex),
            expanded: selectedPort === portIndex,
            className: classes.accordion,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                    expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                    "aria-controls": "panel1a-content",
                    id: "panel1a-header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: indexIsTagName ? "Port - ".concat(incrementString(portIndex)) : t([
                            "shared:addSensor"
                        ], {
                            defaultValue: "Add new sensor"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionDetails/* default */.Z, {
                    className: "".concat(classes.accordionDetails),
                    children: [
                        indexIsTagName ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            value: indexIsTagName ? portIndex : tagName,
                            id: indexKey,
                            label: t([
                                "shared:tagName"
                            ], {
                                defaultValue: "Tag name"
                            }),
                            variant: "outlined",
                            fullWidth: true,
                            disabled: indexIsTagName,
                            error: tagNameError,
                            helperText: tagNameError ? t([
                                "shared:tagNameHelper"
                            ], {
                                defaultValue: "Please enter value using valid characters such as: a-z, 0-9, _ or ."
                            }) : " ",
                            required: true,
                            onChange: onIndexChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            id: nameKey,
                            label: t([
                                "shared:name"
                            ], {
                                defaultValue: "Name"
                            }),
                            variant: "outlined",
                            value: name,
                            onChange: onNameChange,
                            fullWidth: true,
                            required: true,
                            error: sensorNameError,
                            helperText: sensorNameError ? t([
                                "shared:fieldIsRequired"
                            ], {
                                defaultValue: "This field is required"
                            }) : " "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            id: descriptionKey,
                            label: t([
                                "shared:description"
                            ], {
                                defaultValue: "Description"
                            }),
                            variant: "outlined",
                            value: description,
                            helperText: " ",
                            fullWidth: true,
                            onChange: onDescriptionChange,
                            required: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                            isOptionEqualToValue: function(option, value) {
                                return (0,input/* isSearchValueType */.o)(option) && (0,input/* isSearchValueType */.o)(value) ? option.id === value.id : option === value;
                            },
                            value: searchValue,
                            multiple: true,
                            disableCloseOnSelect: true,
                            renderTags: function(tagValue, getTagProps) {
                                return tagValue.map(function(option, index) {
                                    return /*#__PURE__*/ (0,react.createElement)(Chip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        label: (0,input/* isSearchValueType */.o)(option) ? option.label : option
                                    }, getTagProps({
                                        index: index
                                    })), {
                                        key: "chip-".concat((0,input/* isSearchValueType */.o)(option) ? option.label : option),
                                        disabled: (0,input/* isSearchValueType */.o)(option) && isLockedGroup(option.label)
                                    }));
                                });
                            },
                            getOptionDisabled: function(option) {
                                return (0,input/* isSearchValueType */.o)(option) && isLockedGroup(option.label);
                            },
                            renderOption: function(props, option, state) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxOutlineBlank/* default */.Z, {
                                                fontSize: "small"
                                            }),
                                            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* default */.Z, {
                                                fontSize: "small"
                                            }),
                                            checked: state.selected || (0,input/* isSearchValueType */.o)(option) && isLockedGroup(option.label)
                                        }),
                                        (0,input/* isSearchValueType */.o)(option) ? option.label : option
                                    ]
                                }));
                            },
                            onChange: function(event, value) {
                                return setSearchValue(value);
                            },
                            id: "combo-box-demo",
                            getOptionLabel: function(option) {
                                return (0,input/* isSearchValueType */.o)(option) ? option.label : option;
                            },
                            options: generateLabels(groups),
                            renderInput: function(params) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                    variant: "outlined",
                                    focused: true,
                                    label: t("administration:permittedGroups", {
                                        defaultValue: "Permitted Groups"
                                    }),
                                    placeholder: addedGroups.length > 0 ? "" : t([
                                        "administration:additionalGroupAccessForEntry"
                                    ], {
                                        defaultValue: "Select additional groups that may access this {{entry}}",
                                        entry: t("shared:sensor").toLowerCase()
                                    })
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: classes.createSensor,
                            onClick: onCreatePeripheral,
                            disabled: !(tagName || tagName.length) || !name.length || loadingCreatePeripheral,
                            color: "primary",
                            children: loadingCreatePeripheral ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {}) : t([
                                "iam:createPeripheral"
                            ], {
                                defaultValue: "Create Sensor"
                            })
                        })
                    ]
                })
            ]
        }, portIndex);
    };
    var renderCreatedSensorPorts = function() {
        return createdPeripherals.map(function(peripheral) {
            return renderCreatedPeripheralPort(peripheral);
        });
    };
    var renderCreatedPeripheralPort = function(peripheral) {
        if (!peripheral) {
            return null;
        }
        var readablePeripheralId = getTagName(peripheral.peripheralId, (device === null || device === void 0 ? void 0 : device.type) === "fbduo");
        var portIndex = readablePeripheralId;
        var nameKey = "name-".concat(portIndex);
        var indexKey = "index-".concat(portIndex);
        var descriptionKey = "description-".concat(portIndex);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
            onChange: onSelectedPortChange(portIndex),
            expanded: selectedPort === portIndex,
            className: "".concat(classes.accordion),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionSummary/* default */.Z, {
                    expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                    "aria-controls": "panel1a-content",
                    id: "panel1a-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: "Port - ".concat(readablePeripheralId)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            className: classes.moveToRight,
                            label: "Created",
                            variant: "outlined",
                            size: "small"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionDetails/* default */.Z, {
                    className: "".concat(classes.accordionDetails),
                    color: "green",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            id: indexKey,
                            helperText: " ",
                            label: t([
                                "shared:tagName"
                            ], {
                                defaultValue: "Tag name"
                            }),
                            variant: "outlined",
                            value: readablePeripheralId,
                            fullWidth: true,
                            disabled: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            id: nameKey,
                            helperText: " ",
                            label: t([
                                "shared:name"
                            ], {
                                defaultValue: "Name"
                            }),
                            variant: "outlined",
                            value: peripheral.name,
                            fullWidth: true,
                            disabled: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            id: descriptionKey,
                            helperText: " ",
                            label: t([
                                "shared:description"
                            ], {
                                defaultValue: "Description"
                            }),
                            variant: "outlined",
                            value: peripheral.description || " ",
                            fullWidth: true,
                            disabled: true
                        })
                    ]
                })
            ]
        }, portIndex);
    };
    return loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_header/* default */.Z, {
                title: t([
                    "shared:setupSensor"
                ], {
                    defaultValue: "Set up sensor"
                }),
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                loading: loading
            }),
            " "
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_header/* default */.Z, {
                title: t([
                    "shared:setupSensor"
                ], {
                    defaultValue: "Set up sensor"
                }),
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                className: classes.topPadding,
                children: [
                    renderCreatedSensorPorts(),
                    renderSetupSensorPorts()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: onDone,
                    disabled: createdPeripherals.length === 0,
                    color: "primary",
                    children: t([
                        "shared:done"
                    ], {
                        defaultValue: "Done"
                    })
                })
            })
        ]
    });
};
var isLockedGroup = function(groupName) {
    var groupNameLowercase = groupName.toLowerCase();
    return groupNameLowercase === "super" || groupNameLowercase === "read-only";
};
var getTagName = function(peripheralId, isBBDevice) {
    var ref = (0,_to_array/* default */.Z)(peripheralId.split("-")), splitPeripheralId = ref.slice(1);
    var tagName = splitPeripheralId.join("-");
    return isBBDevice ? incrementString(tagName) : tagName;
};
var parseSemVer = function(input) {
    var version = [
        0,
        0,
        0
    ];
    var sliced = input.split(".");
    if (sliced.length !== 3) {
        return null;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = input.split(".").entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), index = _value[0], slice = _value[1];
            var numeric = parseInt(slice, 10);
            if (isNaN(numeric)) {
                return null;
            }
            version[index] = numeric;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return version;
};
var portsFromDeviceType = function(device) {
    switch(device.type){
        case "fbduo":
            var ref, ref1;
            var firmwareVersionParsed = (device === null || device === void 0 ? void 0 : (ref = device.status) === null || ref === void 0 ? void 0 : (ref1 = ref.firmwareVersions) === null || ref1 === void 0 ? void 0 : ref1.application) ? parseSemVer(device.status.firmwareVersions.application) : null;
            if (firmwareVersionParsed && firmwareVersionParsed[0] >= 3) {
                if (device.status.hardwareVersion === "v2") {
                    return [
                        "p1_1",
                        "p2_1"
                    ];
                } else if (device.status.hardwareVersion === "v1" || !device.status.hardwareVersion) {
                    return [
                        "p1",
                        "p2"
                    ];
                } else {
                    console.error("Failed to get ports for duo hardware version", device.status.hardwareVersion);
                    return [];
                }
            } else {
                return [
                    "0",
                    "1"
                ];
            }
        case "fb":
            return [
                "0"
            ];
        case "fbview":
        case "fbpro":
            return [];
        default:
            console.error("ERROR! Could not map port! Device type: ", device.type);
            return [];
    }
};
var incrementString = function(numberString) {
    // We only increment for the old tag format
    var numeric = parseInt(numberString, 10);
    if (isNaN(numeric)) {
        return numberString;
    } else {
        return (numeric + 1).toString();
    }
};
var generateLabels = function(groups) {
    return groups.map(function(group) {
        return {
            label: group.name,
            id: group.id
        };
    });
};
/* harmony default export */ var create_peripheral_content = (CreatePeripheralContent);

;// CONCATENATED MODULE: ./components/dialogs/create-peripheral/create-peripheral-dialog.tsx






var CreatePeripheralDialog = function(props) {
    var theme = (0,useTheme/* default */.Z)();
    var fullScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        fullScreen: fullScreen,
        open: props.open,
        onClose: props.onClose,
        fullWidth: true,
        maxWidth: "sm",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(create_peripheral_content, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var create_peripheral_dialog = (CreatePeripheralDialog);


/***/ }),

/***/ 43162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Clear__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55165);
/* harmony import */ var _mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77797);
/* harmony import */ var _mui_material_Avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36762);
/* harmony import */ var _mui_material_CardHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68368);
/* harmony import */ var _mui_material_Divider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74112);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49692);
/* harmony import */ var _mui_material_InputBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78511);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55537);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);










var SimpleSearch = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), searchValue = ref[0], setSearchValue = ref[1];
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var updateValue = function(event) {
        var newValue = event.target.value.toLowerCase();
        setSearchValue(newValue);
        props.setSearch(newValue);
    };
    var handleKeySubmit = function(event) {
        if (event && event.key && event.key !== "Enter") {
            return;
        }
        props.setSearch(searchValue);
    };
    var handleClickSubmit = function() {
        return props.setSearch(searchValue);
    };
    var clearState = function() {
        setSearchValue("");
        props.setSearch("");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    id: "search-field",
                    onKeyPress: handleKeySubmit,
                    onChange: updateValue,
                    placeholder: props.placeholder,
                    value: searchValue,
                    fullWidth: true
                }),
                avatar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    sx: {
                        marginTop: -theme.spacing(),
                        backgroundColor: theme.palette.primary.main
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                }),
                action: searchValue ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    onClick: clearState,
                    size: "large",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Clear__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    onClick: handleClickSubmit,
                    size: "large",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                }),
                sx: {
                    padding: theme.spacing()
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Divider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleSearch);


/***/ }),

/***/ 51843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ millisAsmmss; },
/* harmony export */   "HN": function() { return /* binding */ localDayWithTimezoneOffset; },
/* harmony export */   "KB": function() { return /* binding */ convertPcsPerTimeToWantedUnit; },
/* harmony export */   "MI": function() { return /* binding */ timeFormatVariable; },
/* harmony export */   "Ob": function() { return /* binding */ timeFormatyyyyMMMddhhmmsstimezone; },
/* harmony export */   "Ox": function() { return /* binding */ timeFormatdMMMMhmm; },
/* harmony export */   "Ud": function() { return /* binding */ guardedCallbackString; },
/* harmony export */   "_D": function() { return /* binding */ evaluateWeekSpan; },
/* harmony export */   "_t": function() { return /* binding */ isBrowserLocale24h; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "j0": function() { return /* binding */ toHHMMSS; },
/* harmony export */   "l8": function() { return /* binding */ DateTimeLabelFormatBasedOnBrowserLocale; },
/* harmony export */   "mc": function() { return /* binding */ xDateFormatBasedOnBrowserLocale; },
/* harmony export */   "pU": function() { return /* binding */ timeFormathhmm; },
/* harmony export */   "rr": function() { return /* binding */ timeFormatyyyyMMdd; },
/* harmony export */   "tI": function() { return /* binding */ timeFormatdMMMMyyyyhhmm; },
/* harmony export */   "td": function() { return /* binding */ timeFormatyyyyMMdhmm; },
/* harmony export */   "vw": function() { return /* binding */ guardedCallback; },
/* harmony export */   "wQ": function() { return /* binding */ mod; },
/* harmony export */   "xQ": function() { return /* binding */ excelReadableDateFormat; },
/* harmony export */   "zs": function() { return /* binding */ timeFormatyyyyMMdhmmss; }
/* harmony export */ });
/* unused harmony exports guardedCallbackNumber, timeFormatyyyyMMMMdhmmss, isNewFeature */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88149);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99758);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5213);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56871);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21134);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15506);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48578);





// TODO: Drop the use of this function, it's too simple to keep :p Excel does
// the formatting for us.
var excelReadableDateFormat = function(date) {
    if (!date) {
        return "";
    }
    return new Date(date);
};
var localDayWithTimezoneOffset = function(date) {
    var localDay = new Date(date.getTime() - date.getTimezoneOffset() * 1..minutes);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(localDay.toISOString().split("T"), 1), calendarDay = ref[0];
    return calendarDay;
};
var guardedCallbackNumber = function(callback) {
    return function(param) {
        var value = param.target.value;
        var parsedValue = Number(value);
        if (Number.isNaN(parsedValue)) {
            return;
        }
        return callback(parsedValue);
    };
};
var guardedCallbackString = function(callback) {
    return function(param) {
        var value = param.target.value;
        if (typeof value !== "string") {
            return;
        }
        return callback(value);
    };
};
var guardedCallback = guardedCallbackString;
var mod = function(n, m) {
    return (n % m + m) % m;
};
/**
 * Time Formatting 7/3/2021 13:00 or 3/7/2021 1:00 PM
 * @param time
 */ var timeFormatyyyyMMdhmm = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
function millisAsmmss(ms) {
    var minutes = Math.floor(ms / (60 * 1000));
    var minutesms = ms % (60 * 1000);
    var sec = Math.floor(minutesms / 1000);
    return "".concat(minutes.toLocaleString(undefined, {
        minimumIntegerDigits: 2
    }), ":").concat(sec.toLocaleString(undefined, {
        minimumIntegerDigits: 2
    }));
}
/**
 * Time Formatting 7/3/2021 13:00:00 or 3/7/2021 1:00:00 PM
 * @param time
 */ var timeFormatyyyyMMdhmmss = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7. marts 13:00 or March 7, 1:00 PM
 * @param time
 */ var timeFormatdMMMMhmm = function(time, locale) {
    var genericTimeFormat = {
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 13:00 or 1:00 PM
 * @param time
 */ var timeFormathhmm = function(time, locale) {
    var genericTimeFormat = {
        // month: 'long',
        // day: 'numeric',
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7. marts 2021 13:00 or March 7, 2021, 1:00 PM
 * @param time
 */ var timeFormatdMMMMyyyyhhmm = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7/3/2021 or 3/7/2021
 * @param time
 */ var timeFormatyyyyMMdd = function(time, locale) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(time, Date) === false || isNaN(time.getTime())) {
        console.error("!Error: Parameter time was not an instane of date!");
        return "Invalid Date!";
    }
    var genericTimeFormat = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7/3/2021 13:00:00 or 3/7/2021 1:00:00 PM
 * @param time
 */ var timeFormatyyyyMMMMdhmmss = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "short",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    };
    return intlFormat(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting:
 * Wed, 7. Mar, 2021, 13:00:00 Central European Standard time
 * or
 * Wed, Mar 7, 2021, 1:00:00 PM Central European Standard time
 * @param time
 */ var timeFormatyyyyMMMddhhmmsstimezone = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "long"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
var isBrowserLocale24hCache = {};
/**
 * return true if locale in browser is 24h format
 */ var isBrowserLocale24h = function(language) {
    if (isBrowserLocale24hCache.hasOwnProperty(language)) {
        return isBrowserLocale24hCache[language];
    } else {
        var res = !new Intl.DateTimeFormat(language || navigator.language, {
            hour: "numeric"
        }).format(0).match(/AM|PM/);
        isBrowserLocale24hCache[language] = res;
        return res;
    }
};
/**
 * Time Formatting Monday, 15. Mar, 2021 - 13:00:00.000 or Monday, Mar 15, 2021 - 01:00:00.000 PM
 */ var xDateFormatBasedOnBrowserLocale = function(language) {
    if (isBrowserLocale24h(language)) {
        return "%A, %b %e, %Y - %H:%M:%S.%L";
    }
    return "%A, %e. %b, %Y - %I:%M:%S.%L%p";
};
/**
 * Time Formatting adds AM/PM formatting if browser locale is AM/PM
 */ var DateTimeLabelFormatBasedOnBrowserLocale = function(language) {
    var formats = {};
    if (isBrowserLocale24h(language)) {
        formats = {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H:%M",
            day: "%e. %b",
            week: "%e. %b",
            month: "%e. %b",
            year: "%b"
        };
    } else {
        formats = {
            millisecond: "%I:%M:%S.%L%p",
            second: "%I:%M:%S%p",
            minute: "%I:%M%p",
            hour: "%I:%M%p",
            day: "%b %e",
            week: "%b %e",
            month: "%b %e",
            year: "%b"
        };
    }
    return formats;
};
/**
 * Note: Format this way, instead of using date-fns, because date-fns format is timezone aware,
 * resulting in format(0, 'HH:mm:ss') = '01:00:00' for GMT+1.
 */ var toHHMMSS = function(v) {
    var secNum = Math.abs(Math.floor(v / 1000));
    var hours = Math.floor(secNum / 3600);
    var minutes = Math.floor((secNum - hours * 3600) / 60);
    var seconds = secNum - hours * 3600 - minutes * 60;
    hours = hours === 0 || isNaN(hours) ? "00" : (hours < 10 ? "0" : "") + "".concat(hours);
    minutes = minutes === 0 || isNaN(minutes) ? "00" : (minutes < 10 ? "0" : "") + "".concat(minutes);
    seconds = seconds === 0 || isNaN(seconds) ? "00" : (seconds < 10 ? "0" : "") + "".concat(seconds);
    var fs = hours + ":" + minutes + ":" + seconds;
    return v < 0 ? "-".concat(fs) : "".concat(fs);
};
/**
 * if i=14 it returns 14:00 or 2:00 PM depending on browser locale
 * @param i
 */ var timeFormatVariable = function(i, language) {
    if (isBrowserLocale24h(language)) {
        return i + ":00";
    } else {
        var timeString = "";
        if (i % 12 !== 0) {
            timeString = (i % 12).toString();
        } else {
            timeString = 12..toString();
        }
        if (i > 11) {
            timeString = timeString + ":00 PM";
        } else {
            timeString = timeString + ":00 AM";
        }
        return timeString;
    }
};
/**
 * turns number of pcs per time into wanted time unit (min/hour/day)
 */ var convertPcsPerTimeToWantedUnit = function(noOfPcs, currentUnit, wantedUnit) {
    var pcsPerMin = 0;
    //Convert pcs/currentUnit into pcs/min
    switch(currentUnit){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.DAY */ .cW.DAY:
            pcsPerMin = noOfPcs / 60 / 24;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            pcsPerMin = noOfPcs / 60;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.MINUTE */ .cW.MINUTE:
            pcsPerMin = noOfPcs;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_4__/* .assertUnreachable */ .U(currentUnit);
            break;
    }
    //Convert pcs/min into pcs/wantedUnit
    var pcsPerWantedUnit = 0;
    switch(wantedUnit){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.DAY */ .cW.DAY:
            pcsPerWantedUnit = pcsPerMin * 60 * 24;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            pcsPerWantedUnit = pcsPerMin * 60;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.MINUTE */ .cW.MINUTE:
            pcsPerWantedUnit = pcsPerMin;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_4__/* .assertUnreachable */ .U(wantedUnit);
            break;
    }
    return pcsPerWantedUnit;
};
var isNewFeature = function(releaseTime) {
    var age = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 7..days;
    return Date.now() <= new Date(releaseTime).getTime() + age;
};
function sleep(milliseconds) {
    return new Promise(function(r) {
        return setTimeout(r, milliseconds);
    });
}
var evaluateWeekSpan = function(date) {
    var dateCopy = new Date(date);
    dateCopy.setHours(0, 0, 0, 0);
    var monday = (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(dateCopy, 1);
    var mondayNextWeek = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(monday);
    return [
        monday,
        mondayNextWeek
    ];
};


/***/ }),

/***/ 49301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isSearchValueType; }
/* harmony export */ });
var isSearchValueType = function(searchValue) {
    return searchValue.label !== undefined;
};


/***/ }),

/***/ 62900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nr": function() { return /* binding */ isCamera; },
/* harmony export */   "e$": function() { return /* binding */ has; },
/* harmony export */   "rq": function() { return /* binding */ isSensor; }
/* harmony export */ });
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15506);

var has = function(obj, property) {
    return property in obj;
};
var isSensor = function(peripheral) {
    var ref;
    return ((ref = peripheral === null || peripheral === void 0 ? void 0 : peripheral.peripheralType) !== null && ref !== void 0 ? ref : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .PeripheralType.SENSOR */ .Ti.SENSOR) === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .PeripheralType.SENSOR */ .Ti.SENSOR;
};
var isCamera = function(peripheral) {
    var ref;
    return ((ref = peripheral === null || peripheral === void 0 ? void 0 : peripheral.peripheralType) !== null && ref !== void 0 ? ref : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .PeripheralType.SENSOR */ .Ti.SENSOR) === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .PeripheralType.CAMERA */ .Ti.CAMERA;
};


/***/ }),

/***/ 18193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ SyncBadge; },
  "Z": function() { return /* binding */ device_config_card; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/CheckCircle.js
var CheckCircle = __webpack_require__(13971);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/WatchLater.js
var WatchLater = __webpack_require__(2157);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(53888);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(35192);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardHeader/CardHeader.js
var CardHeader = __webpack_require__(68368);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(60945);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-web-tabs@1.0.1_prop-types@15.8.1_react-dom@17.0.2_react@17.0.2/node_modules/react-web-tabs/es/index.js + 10 modules
var es = __webpack_require__(32914);
// EXTERNAL MODULE: ../../node_modules/.pnpm/semver@7.5.4/node_modules/semver/index.js
var semver = __webpack_require__(50595);
var semver_default = /*#__PURE__*/__webpack_require__.n(semver);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_react@17.0.2/node_modules/tss-react/esm/mui.js
var mui = __webpack_require__(71601);
// EXTERNAL MODULE: ./hooks/use-translation.tsx
var use_translation = __webpack_require__(17094);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.5.3/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(76398);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/index.js
var client = __webpack_require__(62523);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@c9566f0d83afefd50891e539ddcd310845ce514c_@emotion+react_fkvzwtw37n666fdzuv4pangbii/node_modules/@blackbird/ui-base/dist/es/index.js + 8 modules
var dist_es = __webpack_require__(74486);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@c9566f0d83afefd50891e539ddcd310845ce514c_@emotion+react_fkvzwtw37n666fdzuv4pangbii/node_modules/@blackbird/ui-base/dist/es/link/index.js + 2 modules
var es_link = __webpack_require__(88457);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@devexpress+dx-react-grid@4.0.2_@devexpress+dx-core@4.0.2_@devexpress+dx-react-core@4.0.2_react-dom@17.0.2_react@17.0.2/node_modules/@devexpress/dx-react-grid/dist/dx-react-grid.es.js
var dx_react_grid_es = __webpack_require__(70748);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@devexpress+dx-react-grid-material-ui@4.0.2_@devexpress+dx-grid-core@4.0.2_@devexpress+dx-rea_qcz23fvf6q462qm4gj2awpwhxa/node_modules/@devexpress/dx-react-grid-material-ui/dist/dx-react-grid-material-ui.es.js
var dx_react_grid_material_ui_es = __webpack_require__(16569);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/AddCircle.js
var AddCircle = __webpack_require__(32249);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Delete.js
var Delete = __webpack_require__(70333);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/OpenInBrowser.js
var OpenInBrowser = __webpack_require__(23399);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/SettingsApplications.js
var SettingsApplications = __webpack_require__(52115);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(6203);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(49692);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(51804);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(21406);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(1827);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ./components/dialogs/confirm-dialog.tsx
var confirm_dialog = __webpack_require__(82509);
// EXTERNAL MODULE: ./components/dialogs/create-peripheral/create-peripheral-dialog.tsx + 1 modules
var create_peripheral_dialog = __webpack_require__(33228);
// EXTERNAL MODULE: ./graphql/mutations/delete-peripheral.gql
var delete_peripheral = __webpack_require__(65053);
var delete_peripheral_default = /*#__PURE__*/__webpack_require__.n(delete_peripheral);
// EXTERNAL MODULE: ./graphql/queries/administration-detailed-groups.gql
var administration_detailed_groups = __webpack_require__(89867);
var administration_detailed_groups_default = /*#__PURE__*/__webpack_require__.n(administration_detailed_groups);
// EXTERNAL MODULE: ./graphql/queries/administration-device-peripherals.gql
var administration_device_peripherals = __webpack_require__(91353);
var administration_device_peripherals_default = /*#__PURE__*/__webpack_require__.n(administration_device_peripherals);
// EXTERNAL MODULE: ./hooks/use-url-query.ts
var use_url_query = __webpack_require__(90485);
// EXTERNAL MODULE: ./types/helper-types.ts
var helper_types = __webpack_require__(48578);
// EXTERNAL MODULE: ./views/dialogs/sensor-settings/sensor-settings-dialog.tsx + 14 modules
var sensor_settings_dialog = __webpack_require__(72928);
;// CONCATENATED MODULE: ./views/administration/device/config/sensor-config-tab.tsx

































var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    var _obj;
    return {
        tab: (_obj = {
            background: "transparent",
            border: 0,
            fontFamily: theme.typography.fontFamily,
            display: "inline-block",
            textAlign: "left",
            fontSize: "inherit",
            padding: "0.8rem 2rem",
            margin: "0.2rem 0",
            transition: "background 0.3s cubic-bezier(0.22, 0.61, 0.36, 1)"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
            padding: "0.8rem"
        }), (0,_define_property/* default */.Z)(_obj, "&:focus", {
            outline: 0,
            backgroundColor: "#f4f4f4"
        }), (0,_define_property/* default */.Z)(_obj, '&[aria-selected="false"]:hover', {
            outline: 0,
            backgroundColor: "#f4f4f4"
        }), (0,_define_property/* default */.Z)(_obj, '&[aria-selected="true"]', {
            position: "relative",
            "&:after": {
                content: '""',
                position: "absolute",
                right: "-1px",
                top: 0,
                height: "100%",
                borderRight: "3px solid ".concat(theme.palette.primary.main)
            }
        }), _obj),
        invalidTab: {
            borderLeft: "2px",
            borderColor: "red",
            borderStyle: "solid"
        },
        tabPanel: {
            padding: "0px 20px",
            height: "100%",
            width: "100%"
        },
        denseTable: {
            "& th": {
                padding: "6px 24px 6px 16px !important"
            },
            "& td": {
                padding: "6px 24px 6px 16px !important"
            }
        },
        densePager: {
            padding: "0px"
        },
        denseToolbar: {
            "& > div": {
                marginLeft: "0px !important"
            },
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: theme.spacing()
        },
        iconMargin: {
            marginRight: theme.spacing()
        }
    };
});
var DenseTableComponent = function(props) {
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_material_ui_es/* Table.Table */.cO.Table, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: classes.denseTable
    }));
};
var DenseToolbarComponent = function(props) {
    var classes = useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)([
        "device"
    ]), 1), t = ref[0];
    var children = props.children, onClickAdd = props.onClickAdd, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "children",
        "onClickAdd"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dx_react_grid_material_ui_es/* Toolbar.Root */.o8.Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        className: classes.denseToolbar,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginRight: "auto"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                title: t([
                    "device:addSensorTooltip"
                ], {
                    defaultValue: "Add a new sensor for this device"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    color: "primary",
                    "aria-label": "add",
                    onClick: onClickAdd,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCircle/* default */.Z, {
                            className: classes.iconMargin
                        }),
                        t([
                            "device:addSensor"
                        ], {
                            defaultValue: "Add Sensor"
                        })
                    ]
                })
            })
        ]
    }));
};
var DensePagingPanel = function(props) {
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_material_ui_es/* PagingPanel.Container */.U6.Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: classes.densePager
    }));
};
var Tab = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)([
        "shared"
    ]), 1), t = ref[0];
    var classes = useStyles().classes;
    // TODO: This is left here to make validation easy in the next PR, when there
    // will be fields that can actually be invalid (IP address setup)
    var isValid = true;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Tab */.OK, {
        className: isValid ? classes.tab : "".concat(classes.tab, " ").concat(classes.invalidTab),
        tabFor: "sensors",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "button",
            children: t([
                "device:sensors"
            ], {
                defaultValue: "Sensors"
            })
        })
    });
};
var TabPanel = function(props) {
    var classes = useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)(), 1), t = ref[0];
    var ref1 = (0,use_url_query/* useURLQuery */.m)(), _softwareId = ref1.softwareId, softwareId = _softwareId === void 0 ? "" : _softwareId;
    var snackbar = (0,react.useContext)(dist_es/* Context.Snackbar */._y.A9);
    var columns = (0,react.useMemo)(function() {
        return [
            {
                name: "index",
                title: t([
                    "shared:tagName"
                ], {
                    defaultValue: "Tag name"
                })
            },
            {
                name: "name",
                title: t([
                    "shared:name"
                ], {
                    defaultValue: "Name"
                })
            },
            {
                name: "description",
                title: t([
                    "shared:description"
                ], {
                    defaultValue: "Description"
                })
            },
            {
                name: "actionButtons",
                title: t([
                    "shared:actions"
                ], {
                    defaultValue: "Actions"
                })
            }, 
        ];
    }, []);
    var ref2 = (0,react.useState)([
        {
            columnName: "actionButtons",
            align: "right",
            width: 125
        }, 
    ]), tableColumnExtensions = ref2[0];
    var ref3 = (0,react.useState)([
        {
            columnName: "index",
            direction: "asc"
        }
    ]), sorting = ref3[0], setSorting = ref3[1];
    var ref4 = (0,react.useState)([
        5,
        10,
        25,
        50
    ]), pageSizes = ref4[0];
    var ref5 = (0,react.useState)(""), searchValue = ref5[0], setSearchState = ref5[1];
    var ref6 = (0,react.useState)(false), createPeripheralsDialogOpen = ref6[0], setCreatePeripheralsDialogOpen = ref6[1];
    var ref7 = (0,react.useState)(false), showConfirmDeleteDialog = ref7[0], setShowConfirmDeleteDialog = ref7[1];
    var ref8 = (0,react.useState)(undefined), peripheralIdToDelete = ref8[0], setPeripheralIdToDelete = ref8[1];
    var ref9 = (0,react.useState)({
        open: false,
        peripheralId: null
    }), sensorSettingsState = ref9[0], setSensorSettingsState = ref9[1];
    var ref10 = (0,client.useQuery)((administration_detailed_groups_default()), {
        ssr: false
    }), groupsData = ref10.data;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((delete_peripheral_default()), {
        onError: function(error) {
            return snackbar.spawn(error.message, "error");
        },
        onCompleted: function() {
            props.refetchPeripherals();
        }
    }), 1), deletePeripheralMutation = ref11[0];
    var openDialog = (0,react.useCallback)(function() {
        setCreatePeripheralsDialogOpen(true);
    }, [
        setCreatePeripheralsDialogOpen
    ]);
    var closeDialog = (0,react.useCallback)(function() {
        props.refetchPeripherals();
        setCreatePeripheralsDialogOpen(false);
    }, [
        setCreatePeripheralsDialogOpen
    ]);
    var handleSensorSettingsOpen = function(peripheralId) {
        if (typeof peripheralId === "undefined") {
            return;
        }
        setSensorSettingsState({
            open: true,
            peripheralId: peripheralId
        });
    };
    var onClickDeletePeripheral = function(peripheralId) {
        setShowConfirmDeleteDialog(true);
        setPeripheralIdToDelete(peripheralId);
    };
    var onConfirmDeletePeripheral = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!peripheralIdToDelete) {
                            console.error("Missing peripheral ID!");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            deletePeripheralMutation({
                                variables: {
                                    peripheralId: peripheralIdToDelete
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        setShowConfirmDeleteDialog(false);
                        setPeripheralIdToDelete(undefined);
                        return [
                            2
                        ];
                }
            });
        });
        return function onConfirmDeletePeripheral() {
            return _ref.apply(this, arguments);
        };
    }();
    var rows = (props.peripherals || []).filter(helper_types/* isTruthy */.f).map(function(peripheral) {
        var actionButtons = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                    href: {
                        pathname: "/sensor",
                        query: {
                            peripheralId: "".concat(peripheral.peripheralId),
                            tab: "live"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: t([
                            "line:openSensor"
                        ], {
                            defaultValue: "Open Sensor"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInBrowser/* default */.Z, {
                                fontSize: "inherit"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: t([
                        "iam:configureThisSensor"
                    ], {
                        defaultValue: "Configure this sensor"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        size: "small",
                        onClick: function() {
                            handleSensorSettingsOpen(peripheral.peripheralId);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsApplications/* default */.Z, {
                            fontSize: "inherit"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: "Delete peripheral",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        size: "small",
                        onClick: function() {
                            return onClickDeletePeripheral(peripheral.peripheralId);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {
                            fontSize: "inherit"
                        })
                    })
                })
            ]
        });
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, peripheral), {
            actionButtons: actionButtons
        });
    });
    var i18nMessages = {
        noData: props.loading ? t([
            "shared:loading"
        ], {
            defaultValue: "Loading..."
        }) : t([
            "shared:noSensors"
        ], {
            defaultValue: "No sensors"
        })
    };
    var toolbarRootComponent = (0,react.useCallback)(function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DenseToolbarComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            onClickAdd: openDialog
        }));
    }, [
        openDialog
    ]);
    var _groups;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* TabPanel */.x4, {
        className: classes.tabPanel,
        tabId: "sensors",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                component: Paper/* default */.Z,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dx_react_grid_material_ui_es/* Grid */.rj, {
                    rows: rows,
                    columns: columns,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_es/* SearchState */.po, {
                            value: searchValue,
                            onValueChange: setSearchState
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_es/* IntegratedFiltering */.Eb, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_es/* SortingState */.tU, {
                            sorting: sorting,
                            onSortingChange: setSorting
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_es/* IntegratedSorting */.qf, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_es/* PagingState */.MD, {
                            defaultCurrentPage: 0,
                            defaultPageSize: 5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_es/* IntegratedPaging */.qC, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_material_ui_es/* Table */.cO, {
                            messages: i18nMessages,
                            tableComponent: DenseTableComponent,
                            columnExtensions: tableColumnExtensions
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_material_ui_es/* TableHeaderRow */.KA, {
                            showSortingControls: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_material_ui_es/* Toolbar */.o8, {
                            rootComponent: toolbarRootComponent
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_material_ui_es/* SearchPanel */.EG, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dx_react_grid_material_ui_es/* PagingPanel */.U6, {
                            pageSizes: pageSizes,
                            containerComponent: DensePagingPanel
                        })
                    ]
                })
            }),
            createPeripheralsDialogOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(create_peripheral_dialog/* default */.Z, {
                companyId: groupsData === null || groupsData === void 0 ? void 0 : groupsData.company.id,
                groups: (_groups = groupsData === null || groupsData === void 0 ? void 0 : groupsData.company.groups) !== null && _groups !== void 0 ? _groups : [],
                onDone: closeDialog,
                softwareId: softwareId,
                open: createPeripheralsDialogOpen,
                onClose: closeDialog,
                device: props.device
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sensor_settings_dialog/* default */.Z, {
                dialogOpen: sensorSettingsState.open,
                peripheralId: sensorSettingsState.peripheralId,
                handleDialogChange: function(open) {
                    return setSensorSettingsState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sensorSettingsState), {
                        open: open
                    }));
                },
                refetchQueries: [
                    {
                        query: (administration_device_peripherals_default()),
                        variables: {
                            uuid: softwareId
                        }
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* default */.Z, {
                open: showConfirmDeleteDialog,
                onClose: function() {
                    return setShowConfirmDeleteDialog(false);
                },
                onConfirm: onConfirmDeletePeripheral,
                title: t([
                    "device:deletePeripheral"
                ], {
                    defaultValue: "Delete peripheral"
                }),
                content: t([
                    "device:confirmPeripheralDelete"
                ], {
                    defaultValue: "Are you sure you want to delete this peripheral?"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Visibility.js
var Visibility = __webpack_require__(53701);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Info.js
var Info = __webpack_require__(84905);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(23181);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(26793);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(27908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Switch/Switch.js
var Switch = __webpack_require__(28307);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Table/Table.js
var Table = __webpack_require__(64882);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableBody/TableBody.js
var TableBody = __webpack_require__(71864);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableCell/TableCell.js
var TableCell = __webpack_require__(66361);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableHead/TableHead.js
var TableHead = __webpack_require__(16166);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableRow/TableRow.js
var TableRow = __webpack_require__(35483);
// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(15506);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keyBy.js
var keyBy = __webpack_require__(64038);
var keyBy_default = /*#__PURE__*/__webpack_require__.n(keyBy);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/merge.js
var merge = __webpack_require__(88469);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/values.js
var values = __webpack_require__(31682);
var values_default = /*#__PURE__*/__webpack_require__.n(values);
// EXTERNAL MODULE: ./graphql/mutations/device-update-device.gql
var device_update_device = __webpack_require__(68912);
var device_update_device_default = /*#__PURE__*/__webpack_require__.n(device_update_device);
// EXTERNAL MODULE: ./graphql/mutations/forget-wifi.gql
var forget_wifi = __webpack_require__(18374);
var forget_wifi_default = /*#__PURE__*/__webpack_require__.n(forget_wifi);
// EXTERNAL MODULE: ./graphql/mutations/device-update-network-settings.gql
var device_update_network_settings = __webpack_require__(92590);
var device_update_network_settings_default = /*#__PURE__*/__webpack_require__.n(device_update_network_settings);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(2651);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(426);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(36712);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(97591);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(53189);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(30810);
// EXTERNAL MODULE: ./components/dialogs/dialog-header.tsx
var dialog_header = __webpack_require__(69538);
// EXTERNAL MODULE: ./graphql/mutations/upsert-wifi.gql
var upsert_wifi = __webpack_require__(51645);
var upsert_wifi_default = /*#__PURE__*/__webpack_require__.n(upsert_wifi);
// EXTERNAL MODULE: ./hocs/with-width.tsx
var with_width = __webpack_require__(83126);
// EXTERNAL MODULE: ./hooks/use-width.ts
var use_width = __webpack_require__(31906);
;// CONCATENATED MODULE: ./views/administration/device/config/edit-wifi-dialog.tsx





















var edit_wifi_dialog_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        icon: {
            marginRight: theme.spacing(),
            marginTop: "-3px"
        }
    };
});
var EditWiFiDialog = function(props) {
    var open = props.open, initialState = props.initialState, handleOpenClose = props.handleOpenClose, refetch = props.refetch;
    var ref = (0,use_url_query/* useURLQuery */.m)(), _softwareId = ref.softwareId, softwareId = _softwareId === void 0 ? "" : _softwareId;
    var classes = edit_wifi_dialog_useStyles().classes;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)([
        "shared"
    ]), 1), t = ref1[0];
    var width = (0,use_width/* useWidth */.z)();
    var ref2, ref3;
    var ref4 = (0,react.useState)({
        id: (initialState === null || initialState === void 0 ? void 0 : initialState.id) || undefined,
        ssid: (ref2 = initialState === null || initialState === void 0 ? void 0 : initialState.ssid) !== null && ref2 !== void 0 ? ref2 : "",
        password: (ref3 = initialState === null || initialState === void 0 ? void 0 : initialState.password) !== null && ref3 !== void 0 ? ref3 : ""
    }), state = ref4[0], setState = ref4[1];
    var onWiFiSSIDChange = (0,react.useCallback)(function(e) {
        var value = e.target.value.toString();
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            ssid: value
        }));
    }, [
        state
    ]);
    var onWiFiPassphraseChange = (0,react.useCallback)(function(e) {
        var value = e.target.value.toString();
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            password: value
        }));
    }, [
        state
    ]);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((upsert_wifi_default())), 1), upsertWiFiMut = ref5[0];
    var discard = function() {
        handleOpenClose(false);
    };
    var save = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        upsertWiFiMut({
                            variables: {
                                uuid: softwareId,
                                input: state
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        refetch()
                    ];
                case 2:
                    _state.sent();
                    handleOpenClose(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        upsertWiFiMut,
        state,
        softwareId
    ]);
    var title = initialState ? t([
        "shared:viewWifiConn"
    ], {
        defaultValue: "View WiFi Connection"
    }) : t([
        "shared:addWifiConn"
    ], {
        defaultValue: "Add WiFi Connection"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: open,
        onClose: discard,
        scroll: "body",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_header/* default */.Z, {
                title: title,
                onClose: discard
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle2",
                        children: t("device:wifiCaseSensitive", {
                            defaultValue: "Beware that both Wifi name (SSID) and password is case-sensitive."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "30px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                autoFocus: true,
                                type: "text",
                                name: "ssid",
                                label: t("shared:wifiName", {
                                    defaultValue: "Wifi name (SSID)"
                                }),
                                onChange: onWiFiSSIDChange,
                                variant: "filled",
                                style: {
                                    marginBottom: "30px"
                                },
                                value: state.ssid,
                                disabled: !!initialState
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                type: "text",
                                name: "password",
                                disabled: !!initialState,
                                // FIXME: translation keys
                                helperText: t("device:passwordWillBeVisibleUntilNextPowerCycle", "The password will be visible until the next power cycle of the device"),
                                label: t([
                                    "shared:password"
                                ], {
                                    defaultValue: "Password"
                                }),
                                onChange: onWiFiPassphraseChange,
                                onFocus: function() {
                                    return setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                        password: ""
                                    }));
                                },
                                style: {
                                    marginBottom: "30px"
                                },
                                variant: "filled",
                                value: state.password
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        color: "primary",
                        "data-skip": true,
                        onClick: discard,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                className: classes.icon
                            }),
                            (0,with_width/* isWidthUp */.yJ)("md", width) ? t([
                                "shared:cancel"
                            ], {
                                defaultValue: "Cancel"
                            }) : ""
                        ]
                    }),
                    !initialState && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        color: "primary",
                        "data-skip": true,
                        onClick: save,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                className: classes.icon
                            }),
                            (0,with_width/* isWidthUp */.yJ)("md", width) ? t([
                                "shared:save"
                            ], {
                                defaultValue: "Save"
                            }) : ""
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var edit_wifi_dialog = (EditWiFiDialog);

;// CONCATENATED MODULE: ./views/administration/device/config/wifi-config-tab.tsx








































var wifi_config_tab_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    var _obj;
    return {
        tab: (_obj = {
            background: "transparent",
            border: 0,
            fontFamily: theme.typography.fontFamily,
            display: "inline-block",
            textAlign: "left",
            fontSize: "inherit",
            padding: "0.8rem 2rem",
            margin: "0.2rem 0",
            transition: "background 0.3s cubic-bezier(0.22, 0.61, 0.36, 1)"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
            padding: "0.8rem"
        }), (0,_define_property/* default */.Z)(_obj, "&:focus", {
            outline: 0,
            backgroundColor: "#f4f4f4"
        }), (0,_define_property/* default */.Z)(_obj, '&[aria-selected="false"]:hover', {
            outline: 0,
            backgroundColor: "#f4f4f4"
        }), (0,_define_property/* default */.Z)(_obj, '&[aria-selected="true"]', {
            position: "relative",
            "&:after": {
                content: '""',
                position: "absolute",
                right: "-1px",
                top: 0,
                height: "100%",
                borderRight: "3px solid ".concat(theme.palette.primary.main)
            }
        }), _obj),
        invalidTab: {
            borderLeft: "2px",
            borderColor: "red",
            borderStyle: "solid"
        },
        tabPanel: {
            padding: "0px 20px",
            height: "100%",
            width: "100%"
        },
        headerContainer: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: theme.spacing()
        },
        iconMargin: {
            marginRight: theme.spacing()
        },
        invalidatedNetwork: {
            backgroundColor: theme.palette.grey[300]
        }
    };
});
var wifi_config_tab_Tab = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)([
        "shared"
    ]), 1), t = ref3[0];
    var ref4 = wifi_config_tab_useStyles(), classes = ref4.classes, cx = ref4.cx;
    // No wifi settings available, so don't show the wifi config tab
    if (!((ref = props.network) === null || ref === void 0 ? void 0 : ref.wifi)) {
        return null;
    }
    var isValid = true;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Tab */.OK, {
        className: isValid ? classes.tab : cx(classes.tab, classes.invalidTab),
        tabFor: "wifi",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
            badgeContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(SyncBadge, {
                pendingChanges: !!((ref1 = props.network) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.wifi) === null || ref2 === void 0 ? void 0 : ref2.desired)
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "button",
                children: t([
                    "device:wifi"
                ], {
                    defaultValue: "WiFi"
                })
            })
        })
    });
};
var isUsingFallback = function() {
    var fallback = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).fallback;
    switch(fallback){
        case undefined:
        case null:
            return null;
        case schema/* NetworkFallbackStrategy.FALLBACK_TO_CELLULAR */.SL.FALLBACK_TO_CELLULAR:
            return true;
        default:
            console.error("Failed to determine fallback strategy");
        case schema/* NetworkFallbackStrategy.NEVER */.SL.NEVER:
            return false;
    }
};
var wifi_config_tab_TabPanel = function(_param) {
    var network = _param.network, props = (0,_object_without_properties/* default */.Z)(_param, [
        "network"
    ]);
    var ref, ref1;
    var ref2 = wifi_config_tab_useStyles(), classes = ref2.classes, cx = ref2.cx;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)(), 1), t = ref3[0];
    var ref4 = (0,use_url_query/* useURLQuery */.m)(), _softwareId = ref4.softwareId, softwareId = _softwareId === void 0 ? "" : _softwareId;
    var reportedWifi = network === null || network === void 0 ? void 0 : (ref = network.wifi) === null || ref === void 0 ? void 0 : ref.reported;
    var desiredWifi = network === null || network === void 0 ? void 0 : (ref1 = network.wifi) === null || ref1 === void 0 ? void 0 : ref1.desired;
    var desiredNetworks = (desiredWifi === null || desiredWifi === void 0 ? void 0 : desiredWifi.networks) || [];
    var networks = values_default()(merge_default()(keyBy_default()((reportedWifi === null || reportedWifi === void 0 ? void 0 : reportedWifi.networks) || [], "id"), keyBy_default()(desiredNetworks, "id")));
    var ref5 = (0,react.useState)((desiredWifi === null || desiredWifi === void 0 ? void 0 : desiredWifi.enabled) || (reportedWifi === null || reportedWifi === void 0 ? void 0 : reportedWifi.enabled) || false), wifiEnabled = ref5[0], setWifiEnabled = ref5[1];
    (0,react.useEffect)(function() {
        setWifiEnabled((desiredWifi === null || desiredWifi === void 0 ? void 0 : desiredWifi.enabled) || (reportedWifi === null || reportedWifi === void 0 ? void 0 : reportedWifi.enabled) || false);
    }, [
        desiredWifi === null || desiredWifi === void 0 ? void 0 : desiredWifi.enabled,
        reportedWifi === null || reportedWifi === void 0 ? void 0 : reportedWifi.enabled
    ]);
    var ref6;
    // We set the toggle on by default if it has been enabled
    var ref7 = (0,react.useState)((ref6 = isUsingFallback(network === null || network === void 0 ? void 0 : network.general.desired)) !== null && ref6 !== void 0 ? ref6 : false), fallbackToggeled = ref7[0], setFallbackToggled = ref7[1];
    var fallbackSupport = (0,react.useMemo)(function() {
        if (props.applicationVersion === null || semver_default().lt(props.applicationVersion, "3.5.0")) {
            return "Too old";
        }
        if (wifiEnabled === false) {
            return "Wifi disabled";
        }
        return "Supported";
    }, [
        props.applicationVersion,
        network,
        wifiEnabled
    ]);
    var ref8 = (0,react.useState)({
        open: false,
        networkId: null
    }), editting = ref8[0], setEditDialog = ref8[1];
    var ref9 = (0,react.useState)(false), showConfirmDialog = ref9[0], setShowConfirmDialog = ref9[1];
    var ref10 = (0,react.useState)({}), confirmDialogProps = ref10[0], setConfirmDialogProps = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((device_update_device_default())), 2), updateDevice = ref11[0], ref12 = ref11[1], deviceLoading = ref12.loading;
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((forget_wifi_default())), 2), forgetWiFiMut = ref13[0], ref14 = ref13[1], noWifiLoading = ref14.loading;
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((device_update_network_settings_default())), 2), updateNetworkSettings = ref15[0], ref16 = ref15[1], networkSettingLoading = ref16.loading;
    var loading = props.loading || deviceLoading || noWifiLoading || networkSettingLoading;
    // No wifi settings available, so don't show the wifi config tab
    if (!(network === null || network === void 0 ? void 0 : network.wifi)) {
        return null;
    }
    var onClickEdit = function(value) {
        return function() {
            setEditDialog({
                open: true,
                networkId: value
            });
        };
    };
    var onClickForget = function(value) {
        return function() {
            var ref;
            setConfirmDialogProps({
                onConfirm: function() {
                    return onConfirmForget(value);
                },
                title: t([
                    "device:forgetWiFi"
                ], {
                    defaultValue: "Forget network"
                }),
                content: t([
                    "device:confirmForgetWiFi"
                ], {
                    defaultValue: 'Are you sure you want to forget "{{ networkName }}?"',
                    networkName: ((ref = networks.find(function(n) {
                        return n.id === value;
                    })) === null || ref === void 0 ? void 0 : ref.ssid) || "Unknown"
                })
            });
            setShowConfirmDialog(true);
        };
    };
    var onConfirmForget = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            forgetWiFiMut({
                                variables: {
                                    uuid: softwareId,
                                    input: value
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            refetchData()
                        ];
                    case 2:
                        _state.sent();
                        setShowConfirmDialog(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function onConfirmForget(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleWifiEnabled = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_event, checked) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setWifiEnabled(checked);
                        return [
                            4,
                            updateDevice({
                                variables: {
                                    uuid: softwareId,
                                    meta: {
                                        wifiEnabled: checked
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            refetchData()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleWifiEnabled(_event, checked) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleFallback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_, checked) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setFallbackToggled(checked);
                        return [
                            4,
                            updateNetworkSettings({
                                variables: {
                                    uuid: softwareId,
                                    input: {
                                        fallback: checked ? schema/* NetworkFallbackStrategy.FALLBACK_TO_CELLULAR */.SL.FALLBACK_TO_CELLULAR : schema/* NetworkFallbackStrategy.NEVER */.SL.NEVER
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            refetchData()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleFallback(_, checked) {
            return _ref.apply(this, arguments);
        };
    }();
    var refetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            props.refetch()
                        ];
                    case 1:
                        _state.sent();
                        setTimeout(function() {
                            return props.refetch();
                        }, 5000);
                        return [
                            2
                        ];
                }
            });
        });
        return function refetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* TabPanel */.x4, {
        className: classes.tabPanel,
        tabId: "wifi",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.headerContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        alignItems: "center",
                        display: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                                    disabled: loading,
                                    checked: wifiEnabled,
                                    onChange: handleWifiEnabled,
                                    color: "primary"
                                }),
                                label: t([
                                    "device:enableWifi"
                                ], {
                                    defaultValue: "Enable WiFi"
                                })
                            }),
                            fallbackSupport === "Supported" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                                            disabled: loading,
                                            checked: fallbackToggeled,
                                            onChange: toggleFallback,
                                            color: "primary"
                                        }),
                                        label: t("device:enableFallback", {
                                            defaultValue: "Fallback to cellular"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        title: t("device:enableFallbackTooltip", {
                                            defaultValue: "When enabled, the Factbird Duo will automatically use the cellular connection if internet over WiFi stops working.\n\n When disabled, the cellular module will be turned off and only the WiFi module will be able to access the internet."
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: t([
                            "device:addConnectionTooltip"
                        ], {
                            defaultValue: "Add a new WiFi connection"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            color: "primary",
                            "aria-label": "add",
                            onClick: onClickEdit(null),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCircle/* default */.Z, {
                                    className: classes.iconMargin
                                }),
                                t([
                                    "device:addConnection"
                                ], {
                                    defaultValue: "Add Connection"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                component: Paper/* default */.Z,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        children: t("shared:wifiName", {
                                            defaultValue: "Wifi name (SSID)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "right",
                                        children: t([
                                            "shared:security"
                                        ], {
                                            defaultValue: "Security"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "right",
                                        children: t([
                                            "shared:actions"
                                        ], {
                                            defaultValue: "Actions"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                            children: networks.map(function(network) {
                                var invalidatedNetwork = !!desiredWifi && !desiredNetworks.some(function(n) {
                                    return n.id === network.id;
                                });
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    className: cx((0,_define_property/* default */.Z)({}, classes.invalidatedNetwork, invalidatedNetwork)),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            component: "th",
                                            scope: "row",
                                            children: network.ssid
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            align: "right",
                                            children: network.password ? "WPA2" : "None"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                            align: "right",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: t([
                                                        "shared:edit"
                                                    ], {
                                                        defaultValue: "Edit"
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        "aria-label": "edit",
                                                        size: "small",
                                                        onClick: onClickEdit(network.id),
                                                        disabled: invalidatedNetwork,
                                                        className: classes.iconMargin,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {
                                                            fontSize: "inherit"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: t([
                                                        "shared:forget"
                                                    ], {
                                                        defaultValue: "Forget"
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        disabled: invalidatedNetwork,
                                                        edge: "end",
                                                        "aria-label": "forget",
                                                        size: "small",
                                                        onClick: onClickForget(network.id),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {
                                                            fontSize: "inherit"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, network.id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* default */.Z, (0,_object_spread/* default */.Z)({
                open: showConfirmDialog,
                onClose: function() {
                    return setShowConfirmDialog(false);
                }
            }, confirmDialogProps)),
            editting.open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(edit_wifi_dialog, {
                refetch: refetchData,
                open: editting.open,
                handleOpenClose: function() {
                    return setEditDialog({
                        open: false,
                        networkId: null
                    });
                },
                initialState: networks.find(function(n) {
                    return n.id === editting.networkId;
                }) || null
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./views/administration/device/config/device-config-card.tsx














var device_config_card_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        card: {
            "& > div > div > div > div > table > colgroup > col:nth-child(6)": {
                width: "150px"
            },
            "& > div > div > div > div > table > colgroup > col:nth-child(5)": {
                width: "130px"
            },
            "& > div > div > div > div > table > colgroup > col:nth-child(4)": {
                width: "100px"
            },
            height: "100%"
        },
        flexRow: {
            display: "flex",
            padding: theme.spacing()
        },
        tabs: {
            '&[data-rwt-vertical="true"]': {
                display: "flex"
            },
            display: "inline-block",
            height: "100%"
        },
        tabList: {
            '&[aria-orientation="vertical"]': {
                display: "flex",
                flexDirection: "column",
                flexShrink: 0,
                flexGrow: 0,
                borderRight: "1px solid #ddd",
                marginRight: "1rem"
            }
        },
        status: {
            marginLeft: theme.spacing(3),
            height: "20px"
        },
        pending: {
            color: "orange"
        },
        sync: {
            color: "green"
        }
    };
});
var SyncBadge = function(param) {
    var pendingChanges = param.pendingChanges;
    var ref = device_config_card_useStyles(), classes = ref.classes, cx = ref.cx;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)(), 1), t = ref1[0];
    if (pendingChanges) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
            title: t([
                "device:configPending"
            ], {
                defaultValue: "Changes will be applied next time the device is online"
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WatchLater/* default */.Z, {
                className: cx(classes.status, classes.pending)
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        title: t([
            "device:configInSync"
        ], {
            defaultValue: "Configuration in sync with device"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
            className: cx(classes.status, classes.sync)
        })
    });
};
var DeviceConfigCard = function(param) {
    var device = param.device, refetchPeripherals = param.refetchPeripherals, loading = param.loading;
    var ref, ref1, ref2;
    var classes = device_config_card_useStyles().classes;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)(), 1), t = ref3[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        elevation: 1,
        className: classes.card,
        style: {
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                title: t([
                    "shared:deviceConfig"
                ], {
                    defaultValue: "Device Config"
                }),
                titleTypographyProps: {
                    variant: "h6",
                    className: classes.flexRow
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                style: {
                    flexGrow: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Tabs */.mQ, {
                    vertical: true,
                    className: classes.tabs,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* TabList */.td, {
                            className: classes.tabList,
                            selection: {
                                isVertical: function() {
                                    return true;
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {}),
                                (device === null || device === void 0 ? void 0 : (ref = device.network) === null || ref === void 0 ? void 0 : ref.wifi) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(wifi_config_tab_Tab, {
                                    network: device.network
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                            refetchPeripherals: refetchPeripherals,
                            peripherals: (device === null || device === void 0 ? void 0 : device.peripherals) || [],
                            loading: loading,
                            device: device !== null && device !== void 0 ? device : undefined
                        }),
                        (device === null || device === void 0 ? void 0 : (ref1 = device.network) === null || ref1 === void 0 ? void 0 : ref1.wifi) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(wifi_config_tab_TabPanel, {
                            loading: loading,
                            refetch: refetchPeripherals,
                            network: device.network,
                            applicationVersion: semver_default().parse((ref2 = device.status.firmwareVersions) === null || ref2 === void 0 ? void 0 : ref2.application)
                        }) : null
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var device_config_card = (DeviceConfigCard);


/***/ }),

/***/ 65783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapRequiredFieldsDescriptionComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1827);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82672);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71601);






var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        requiredFieldDesc: {
            fontSize: "11px",
            color: "rgba(0, 0, 0, 0.54)",
            margin: "10px"
        }
    };
});
function WrapRequiredFieldsDescriptionComponent(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)(), 1), t = ref[0];
    var classes = useStyles().classes;
    var ref1;
    var title = (ref1 = props === null || props === void 0 ? void 0 : props.overrideTitle) !== null && ref1 !== void 0 ? ref1 : t([
        "shared:requiredFieldDesc"
    ], {
        defaultValue: "All fields marked with an asterisk (*) are required."
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: classes.requiredFieldDesc,
            children: title
        })
    });
}


/***/ }),

/***/ 72928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sensor_settings_dialog; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.5.3/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(76398);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/index.js
var client = __webpack_require__(62523);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@c9566f0d83afefd50891e539ddcd310845ce514c_@emotion+react_fkvzwtw37n666fdzuv4pangbii/node_modules/@blackbird/ui-base/dist/es/link/index.js + 2 modules
var es_link = __webpack_require__(88457);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(2651);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(426);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(6203);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(36712);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(97591);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(53189);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tab/Tab.js
var Tab = __webpack_require__(84029);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tabs/Tabs.js + 2 modules
var Tabs = __webpack_require__(43040);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(12512);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(55537);
// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(15506);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.22.5_react-dom@17.0.2_react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(95840);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-form-validator-core@0.6.5_react-dom@17.0.2_react@17.0.2/node_modules/react-form-validator-core/lib/index.js
var lib = __webpack_require__(8081);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_react@17.0.2/node_modules/tss-react/esm/mui.js
var mui = __webpack_require__(71601);
// EXTERNAL MODULE: ./components/buttons/mutation-button.tsx
var mutation_button = __webpack_require__(24024);
// EXTERNAL MODULE: ./components/dialogs/dialog-header.tsx
var dialog_header = __webpack_require__(69538);
// EXTERNAL MODULE: ./components/dialogs/discard-changes-dialog.tsx
var discard_changes_dialog = __webpack_require__(49153);
// EXTERNAL MODULE: ./graphql/mutations/device-update-peripheral.gql
var device_update_peripheral = __webpack_require__(54223);
var device_update_peripheral_default = /*#__PURE__*/__webpack_require__.n(device_update_peripheral);
// EXTERNAL MODULE: ./graphql/queries/sensor-settings.gql
var sensor_settings = __webpack_require__(55199);
var sensor_settings_default = /*#__PURE__*/__webpack_require__.n(sensor_settings);
// EXTERNAL MODULE: ./hocs/with-width.tsx
var with_width = __webpack_require__(83126);
// EXTERNAL MODULE: ./hooks/use-translation.tsx
var use_translation = __webpack_require__(17094);
// EXTERNAL MODULE: ./hooks/use-width.ts
var use_width = __webpack_require__(31906);
// EXTERNAL MODULE: ./hooks/use-iam.tsx
var use_iam = __webpack_require__(87325);
// EXTERNAL MODULE: ./hooks/use-url-query.ts
var use_url_query = __webpack_require__(90485);
// EXTERNAL MODULE: ./types/guards.ts
var guards = __webpack_require__(62900);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@c9566f0d83afefd50891e539ddcd310845ce514c_@emotion+react_fkvzwtw37n666fdzuv4pangbii/node_modules/@blackbird/ui-base/dist/es/index.js + 8 modules
var es = __webpack_require__(74486);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(15509);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(98242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__(89309);
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/startCase.js
var startCase = __webpack_require__(59659);
var startCase_default = /*#__PURE__*/__webpack_require__.n(startCase);
// EXTERNAL MODULE: ./components/validators-forms/input-validator.tsx
var input_validator = __webpack_require__(70537);
// EXTERNAL MODULE: ./views/common-components/wrap-required-fileds-description.tsx
var wrap_required_fileds_description = __webpack_require__(65783);
;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/basic-info.tsx










var TabProps = {
    isValid: function(state) {
        var ref, ref1;
        return state.name.length > 0 && (state.peripheralType !== "SENSOR" || (state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.type) !== undefined);
    },
    label: function(t) {
        return t("device:basicInformation", {
            defaultValue: "Basic information"
        });
    }
};
var TabPanel = function(param) {
    var handleChange = param.handleChange, enumTypes = param.enumTypes, state = param.state, invalidFormMessage = param.invalidFormMessage, classes = param.classes, t = param.t;
    var ref, ref1;
    var onNameChange = function(e) {
        return handleChange({}, {
            name: e.target.value
        });
    };
    var onDescChange = function(e) {
        handleChange({}, {
            description: e.target.value
        });
    };
    var ref2 = react.useContext(es/* Context.Snackbar */._y.A9), spawnSnackbar = ref2.spawn;
    var onTypeChange = function(e) {
        var ref, ref1;
        var type = e.target.value;
        var newState = {
            sensor: {
                type: type
            }
        };
        // The only sensor types that support energyMeter is Counter and CounterAccumulate, so if energy meter is enabled and we switch away from that type, we disable energyMeter since the toggle will disapear.
        if (((ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.energyMeter) && type !== schema/* SensorType.COUNTER */.dE.COUNTER && type !== schema/* SensorType.COUNTER_ACCUMULATE */.dE.COUNTER_ACCUMULATE) {
            newState.sensor.energyMeter = false;
            spawnSnackbar(t("shared:energyMeterWasDisabled", {
                defaultValue: "Energy Meter has been disabled since it is only supported for 'Counter' and 'Counter Accumulate' sensor types."
            }), "info");
        }
        handleChange(newState);
    };
    var ref3;
    var sensorTypes = (ref3 = enumTypes === null || enumTypes === void 0 ? void 0 : enumTypes.sensorTypes) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                name: "name",
                label: t([
                    "device:sensorName"
                ], {
                    defaultValue: "Sensor name"
                }),
                validators: [
                    "required",
                    "isString"
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    }),
                    t([
                        "shared:mustBeString"
                    ], {
                        defaultValue: "must be a string"
                    }), 
                ],
                value: state.name,
                onChange: onNameChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                name: "description",
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t([
                        "device:sensorDescription"
                    ], {
                        defaultValue: "Sensor description"
                    })
                }),
                validators: [
                    "isString"
                ],
                errorMessages: [
                    t([
                        "shared:mustBeString"
                    ], {
                        defaultValue: "must be a string"
                    })
                ],
                value: state.description,
                onChange: onDescChange
            }),
            state.peripheralType === schema/* PeripheralType.SENSOR */.Ti.SENSOR ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_validator/* SelectValidator */.$y, {
                        className: classes.selectFields,
                        containerClass: classes.containerClass,
                        name: "type",
                        variant: "filled",
                        label: "".concat(t([
                            "device:sensorType"
                        ], {
                            defaultValue: "Sensor type"
                        }), " *"),
                        value: ((ref4 = state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.type) !== null && ref4 !== void 0 ? ref4 : undefined) || "",
                        validators: [
                            "required"
                        ],
                        errorMessages: [
                            t([
                                "shared:fieldIsRequired"
                            ], {
                                defaultValue: "this field is required"
                            })
                        ],
                        onChange: onTypeChange,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                style: {
                                    height: "auto"
                                },
                                value: "",
                                disabled: true,
                                children: t([
                                    "device:selectSensorType"
                                ], {
                                    defaultValue: "Select sensor type"
                                })
                            }, "disabled"),
                            sensorTypes.map(function(sensorType) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    style: {
                                        height: "auto"
                                    },
                                    value: sensorType.name,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                        primary: startCase_default()(sensorType.name.toLowerCase()),
                                        secondary: t([
                                            "device:".concat(camelCase_default()("sensorType".concat(sensorType.name.toLowerCase(), "Desc")))
                                        ], {
                                            defaultValue: sensorType.description
                                        })
                                    })
                                }, sensorType.name);
                            })
                        ]
                    })
                ]
            }) : null,
            invalidFormMessage,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {})
        ]
    });
};

;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/camera.tsx





var isShown = function(state) {
    // Do we need this check if it just goes && false?
    return state.peripheralType === schema/* PeripheralType.CAMERA */.Ti.CAMERA && false;
};
var camera_TabProps = {
    isShown: isShown,
    label: function(t) {
        return t("device:cameraSettings", {
            defaultValue: "Camera"
        });
    }
};
var camera_TabPanel = function(param) {
    var handleChange = param.handleChange, state = param.state, invalidFormMessage = param.invalidFormMessage, classes = param.classes, t = param.t;
    if (!isShown(state)) {
        return null;
    }
    var onNameChange = function(e) {
        return handleChange({}, {
            name: e.target.value
        });
    };
    var onDescChange = function(e) {
        return handleChange({}, {
            description: e.target.value
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                name: "name",
                label: t([
                    "device:sensorName"
                ], {
                    defaultValue: "Sensor name"
                }),
                validators: [
                    "required",
                    "isString"
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    }),
                    t([
                        "shared:mustBeString"
                    ], {
                        defaultValue: "must be a string"
                    }), 
                ],
                value: state.name,
                onChange: onNameChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                name: "description",
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t([
                        "device:sensorDescription"
                    ], {
                        defaultValue: "Sensor description"
                    })
                }),
                validators: [
                    "isString"
                ],
                errorMessages: [
                    t([
                        "shared:mustBeString"
                    ], {
                        defaultValue: "must be a string"
                    })
                ],
                value: state.description,
                onChange: onDescChange
            }),
            invalidFormMessage,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {})
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(16047);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Delete.js
var Delete = __webpack_require__(70333);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(74112);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/List/List.js
var List = __webpack_require__(93676);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/ListItem/ListItem.js
var ListItem = __webpack_require__(14636);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/ListItemSecondaryAction/ListItemSecondaryAction.js
var ListItemSecondaryAction = __webpack_require__(69547);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Menu/Menu.js
var Menu = __webpack_require__(65897);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(1827);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/red.js
var red = __webpack_require__(88665);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ./graphql/mutations/device-attach-camera.gql
var device_attach_camera = __webpack_require__(4929);
var device_attach_camera_default = /*#__PURE__*/__webpack_require__.n(device_attach_camera);
// EXTERNAL MODULE: ./graphql/mutations/device-detach-camera.gql
var device_detach_camera = __webpack_require__(9936);
var device_detach_camera_default = /*#__PURE__*/__webpack_require__.n(device_detach_camera);
// EXTERNAL MODULE: ./graphql/queries/devices-simple.gql
var devices_simple = __webpack_require__(50936);
var devices_simple_default = /*#__PURE__*/__webpack_require__.n(devices_simple);
// EXTERNAL MODULE: ./types/helper-types.ts
var helper_types = __webpack_require__(48578);
;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/camera-attachment.tsx
// tslint:disable:react-hooks-nesting

























var camera_attachment_isShown = function(peripheralType) {
    return peripheralType === schema/* PeripheralType.CAMERA */.Ti.CAMERA;
};
var camera_attachment_TabProps = {
    isShown: function(s) {
        return camera_attachment_isShown(s.peripheralType);
    },
    label: function(t) {
        return t("device:cameraSensors", {
            defaultValue: "Attached sensors"
        });
    }
};
var useStyles = (0,mui/* makeStyles */.ZL)()(function() {
    return {
        cameraAttachementContainer: {
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "20px",
            paddingRight: "20px",
            marginTop: "10px"
        },
        cameraAttachementHeader: {
            fontWeight: 500,
            marginBottom: "5px"
        },
        iconButton: {
            padding: "12px"
        }
    };
});
var camera_attachment_TabPanel = function(_param) {
    var invalidFormMessage = _param.invalidFormMessage, classes = _param.classes, props = (0,_object_without_properties/* default */.Z)(_param, [
        "invalidFormMessage",
        "classes"
    ]);
    var ref = useStyles(), internalClasses = ref.classes;
    var t = (0,useTranslation/* useTranslation */.$)([
        "device"
    ]).t;
    var ref1 = (0,react.useState)(props.peripheral), peripheral = ref1[0], setPeripheral = ref1[1];
    var ref2 = (0,react.useState)(null), attachSensorMenuAnchor = ref2[0], setAttachSensorMenuAnchor = ref2[1];
    var ref3 = (0,react.useState)(null), detachState = ref3[0], setDetachState = ref3[1];
    var attachedSensors = peripheral.attachedSensors, peripheralId = peripheral.peripheralId;
    var actualAttachedSensors = (attachedSensors || []).filter(helper_types/* isTruthy */.f);
    var data = (0,client.useQuery)((devices_simple_default())).data;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((device_attach_camera_default())), 2), attachCamera = ref4[0], ref5 = ref4[1], attachLoading = ref5.loading;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((device_detach_camera_default())), 2), detachCamera = ref6[0], ref7 = ref6[1], detachLoading = ref7.loading;
    if (peripheral.peripheralType && !camera_attachment_isShown(peripheral.peripheralType)) {
        return null;
    }
    var attachCam = function(sensor) {
        return function() {
            if (!peripheralId) {
                return;
            }
            attachCamera({
                variables: {
                    peripheralId: peripheralId,
                    sensorPeripheralId: sensor.peripheralId
                }
            });
            setAttachSensorMenuAnchor(null);
            var newAttachedSensorMap = actualAttachedSensors.concat([
                {
                    _id: null,
                    peripheralId: sensor.peripheralId,
                    name: sensor.name,
                    peripheralType: sensor.peripheralType,
                    description: sensor.description
                }, 
            ]);
            setPeripheral((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, peripheral), {
                attachedSensors: newAttachedSensorMap
            }));
        };
    };
    var detachCam = function(sensor) {
        return function() {
            if (!peripheralId) {
                return;
            }
            setDetachState(sensor.peripheralId);
            detachCamera({
                variables: {
                    peripheralId: peripheralId,
                    sensorPeripheralId: sensor.peripheralId
                }
            });
            var newAttachedSensorMap = actualAttachedSensors.filter(function(row) {
                return row.peripheralId !== sensor.peripheralId;
            });
            setPeripheral((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, peripheral), {
                attachedSensors: newAttachedSensorMap
            }));
        };
    };
    var handleMenuClick = function(e) {
        return setAttachSensorMenuAnchor(e.currentTarget);
    };
    var handleMenuClose = function() {
        return setAttachSensorMenuAnchor(null);
    };
    var ref8, ref9;
    var sensors = ((ref8 = data === null || data === void 0 ? void 0 : data.devices) !== null && ref8 !== void 0 ? ref8 : []).reduce(function(acc, cur) {
        return acc.concat(((ref9 = cur === null || cur === void 0 ? void 0 : cur.peripherals) !== null && ref9 !== void 0 ? ref9 : []).filter(guards/* isSensor */.rq).filter(function(p) {
            return !actualAttachedSensors.some(function(param) {
                var peripheralId = param.peripheralId;
                return peripheralId === p.peripheralId;
            });
        }));
    }, []);
    var sorted = false;
    if (!sorted) {
        sensors.sort(function(l, r) {
            return l.name.localeCompare(r.name);
        });
        sorted = true;
    }
    var menuItems = sensors.length ? sensors.map(function(sensor) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
            onClick: attachCam(sensor),
            children: sensor.name
        }, sensor.peripheralId);
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
        children: t([
            "device:appearsNoMoreSensors"
        ], {
            defaultValue: "It appears you dont have access to any more sensors"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: internalClasses.cameraAttachementContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                className: internalClasses.cameraAttachementHeader,
                                children: t([
                                    "device:sensorsAttached"
                                ], {
                                    defaultValue: "Sensors attached to this camera"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mutation_button/* MutationIconButton */.t, {
                                "aria-label": t([
                                    "shared:add"
                                ], {
                                    defaultValue: "Add"
                                }),
                                loading: attachLoading,
                                className: internalClasses.iconButton,
                                onClick: handleMenuClick,
                                tooltipMsg: t([
                                    "device:attachCameraToSensor"
                                ], {
                                    defaultValue: "Attach camera to sensor"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    color: "primary"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        dense: true,
                        children: actualAttachedSensors.map(function(sensor, index, arr) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                primary: sensor.name,
                                                secondary: sensor.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemSecondaryAction/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mutation_button/* MutationIconButton */.t, {
                                                    "aria-label": t([
                                                        "shared:remove"
                                                    ], {
                                                        defaultValue: "Remove"
                                                    }),
                                                    loading: detachLoading && detachState === sensor.peripheralId,
                                                    className: internalClasses.iconButton,
                                                    onClick: detachCam(sensor),
                                                    loadingColor: red/* default.500 */.Z[500],
                                                    tooltipMsg: t([
                                                        "device:dettachCameraToSensor"
                                                    ], {
                                                        defaultValue: "Detach camera from sensor"
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {})
                                                })
                                            })
                                        ]
                                    }),
                                    index < arr.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}) : null
                                ]
                            }, sensor.peripheralId);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                        id: "simple-menu",
                        anchorEl: attachSensorMenuAnchor,
                        open: Boolean(attachSensorMenuAnchor),
                        onClose: handleMenuClose,
                        PaperProps: {
                            style: {
                                maxHeight: "300px"
                            }
                        },
                        children: menuItems
                    })
                ]
            }),
            invalidFormMessage
        ]
    });
};

;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/data.tsx












var data_isShown = function(state) {
    var ref, ref1, ref2, ref3;
    return state.peripheralType === "SENSOR" && ((ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.type) !== schema/* SensorType.EVENT */.dE.EVENT && ((ref2 = state.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : ref3.type) !== schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS;
};
var isValid = function(state) {
    var ref, ref1;
    switch((ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.type){
        case schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT:
            var ref2, ref3, ref4, ref5, ref6, ref7;
            return (state === null || state === void 0 ? void 0 : (ref2 = state.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sensorUnit) === null || ref4 === void 0 ? void 0 : ref4.label) && (state === null || state === void 0 ? void 0 : (ref5 = state.config) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.sensor) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sensorUnit) === null || ref7 === void 0 ? void 0 : ref7.unit) ? true : false;
        default:
            return true;
    }
};
var data_TabProps = {
    isShown: data_isShown,
    isValid: isValid,
    label: function(t) {
        return t("device:dataSetup", {
            defaultValue: "Data"
        });
    }
};
var _obj;
var filterTranslationKeys = (_obj = {}, (0,_define_property/* default */.Z)(_obj, schema/* DataFilter.AVERAGE_SPEED */.Zv.AVERAGE_SPEED, [
    "shared:averageSpeed",
    "Average speed"
]), (0,_define_property/* default */.Z)(_obj, schema/* DataFilter.SPEED */.Zv.SPEED, [
    "shared:speed",
    "Speed"
]), (0,_define_property/* default */.Z)(_obj, schema/* DataFilter.NONE */.Zv.NONE, [
    "shared:none",
    "None"
]), (0,_define_property/* default */.Z)(_obj, schema/* DataFilter.UPTIME */.Zv.UPTIME, [
    "shared:uptime",
    "Uptime"
]), _obj);
var _obj1;
var filterDescriptionTranslationKeys = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, schema/* DataFilter.AVERAGE_SPEED */.Zv.AVERAGE_SPEED, [
    "shared:averageSpeedFilterDescription",
    "Displays the average speed over the selected scale", 
]), (0,_define_property/* default */.Z)(_obj1, schema/* DataFilter.SPEED */.Zv.SPEED, [
    "shared:speedFilterDescription",
    "Displays the speed between each impulse of produced units", 
]), (0,_define_property/* default */.Z)(_obj1, schema/* DataFilter.NONE */.Zv.NONE, [
    "shared:noneFilterDescription",
    "Displays impulses of produced units in evenly distributed intervals", 
]), (0,_define_property/* default */.Z)(_obj1, schema/* DataFilter.UPTIME */.Zv.UPTIME, [
    "shared:uptimeFilterDescription",
    "Displays the impulses of produced units in two values, 1 for when there is production activity and 0 for when there is not", 
]), _obj1);
var filterOptions = Object.keys(schema/* DataFilter */.Zv).sort();
var data_TabPanel = function(param) {
    var state = param.state, handleChange = param.handleChange, t = param.t, enumTypes = param.enumTypes, classes = param.classes, invalidFormMessage = param.invalidFormMessage;
    if (!data_isShown(state)) {
        return null;
    }
    var config = state.config;
    var sensor = (config || {}).sensor;
    var ref = sensor || {}, type = ref.type, sensorUnit = ref.sensorUnit, chart = ref.chart, chartTimeScale = ref.chartTimeScale;
    var unit = (sensorUnit === null || sensorUnit === void 0 ? void 0 : sensorUnit.unit) ? sensorUnit === null || sensorUnit === void 0 ? void 0 : sensorUnit.unit : "None";
    var label = (sensorUnit === null || sensorUnit === void 0 ? void 0 : sensorUnit.label) || t("units:piecesShort", "pcs");
    var dataFilter = (chart === null || chart === void 0 ? void 0 : chart.dataFilter) || schema/* DataFilter.AVERAGE_SPEED */.Zv.AVERAGE_SPEED;
    var scale = (chart === null || chart === void 0 ? void 0 : chart.scale) || chartTimeScale || schema/* ChartTimeScale.MINUTE */.cW.MINUTE;
    var onSensorUnitChange = function(param) {
        var value = param.target.value;
        if (!sensorUnit) {
            return;
        }
        handleChange({
            sensor: {
                sensorUnit: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sensorUnit), {
                    unit: value === "None" ? null : value
                })
            }
        });
    };
    var onSensorUnitLabelChange = function(param) {
        var value = param.target.value;
        if (!sensorUnit) {
            return;
        }
        handleChange({
            sensor: {
                sensorUnit: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sensorUnit), {
                    label: value === "None" ? null : value
                })
            }
        });
    };
    var onDataFilterChange = function(param) {
        var value = param.target.value;
        handleChange({
            sensor: {
                chart: {
                    dataFilter: value
                }
            }
        });
    };
    var onChartTimeScaleChange = function(param) {
        var value = param.target.value;
        handleChange({
            sensor: {
                chartTimeScale: value,
                chart: {
                    dataFilter: dataFilter,
                    scale: value
                }
            }
        });
    };
    var units = enumTypes.units;
    var validators = [];
    var errorMessages = [];
    if (type === schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT || type === schema/* SensorType.EVENT */.dE.EVENT) {
        validators.push("required");
        errorMessages.push(t([
            "shared:fieldIsRequired"
        ], {
            defaultValue: "this field is required"
        }));
    }
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_validator/* SelectValidator */.$y, {
                className: classes.selectFields,
                containerClass: classes.containerClass,
                name: "type",
                variant: "filled",
                label: "".concat(t([
                    "device:dataUnit"
                ], {
                    defaultValue: "Data unit"
                }), " *"),
                value: unit,
                helperText: type === schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT && !unit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: red/* default.500 */.Z[500]
                    },
                    children: t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    })
                }) : "",
                validators: [
                    "required"
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    })
                ],
                onChange: onSensorUnitChange,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        value: "",
                        disabled: true,
                        children: t([
                            "device:selectDataUnit"
                        ], {
                            defaultValue: "Select data unit"
                        })
                    }, "disabled"),
                    type !== schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        value: "None",
                        children: t([
                            "shared:none"
                        ], {
                            defaultValue: "None"
                        })
                    }, "none"),
                    units === null || units === void 0 ? void 0 : units.map(function(unit) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: unit.name,
                            children: startCase_default()(unit.name.toLowerCase())
                        }, unit.name);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            typeof unit === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                name: "dataLabel",
                label: t([
                    "device:dataLabel"
                ], {
                    defaultValue: "Label of the data unit"
                }),
                validators: (0,_to_consumable_array/* default */.Z)(validators).concat([
                    "isString"
                ]),
                errorMessages: (0,_to_consumable_array/* default */.Z)(errorMessages).concat([
                    t([
                        "shared:mustBeString"
                    ], {
                        defaultValue: "must be a string"
                    })
                ]),
                value: (ref1 = sensorUnit === null || sensorUnit === void 0 ? void 0 : sensorUnit.label) !== null && ref1 !== void 0 ? ref1 : "",
                onChange: onSensorUnitLabelChange
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            type !== schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT && type !== schema/* SensorType.EVENT */.dE.EVENT ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* SelectValidator */.$y, {
                        className: classes.selectFields,
                        containerClass: classes.containerClass,
                        name: "type",
                        variant: "filled",
                        label: t([
                            "device:chartDataFilter"
                        ], {
                            defaultValue: "Chart data filter"
                        }),
                        value: dataFilter,
                        validators: (0,_to_consumable_array/* default */.Z)(validators),
                        errorMessages: (0,_to_consumable_array/* default */.Z)(errorMessages),
                        onChange: onDataFilterChange,
                        children: filterOptions.map(function(filterType) {
                            var translation = filterType in filterTranslationKeys ? t.apply(void 0, (0,_to_consumable_array/* default */.Z)(filterTranslationKeys[filterType])) : filterType;
                            var description = filterType in filterDescriptionTranslationKeys ? t.apply(void 0, (0,_to_consumable_array/* default */.Z)(filterDescriptionTranslationKeys[filterType])) : filterType;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: filterType,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: translation,
                                    secondary: description
                                })
                            }, filterType);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_validator/* SelectValidator */.$y, {
                        className: classes.selectFields,
                        containerClass: classes.containerClass,
                        name: "type",
                        variant: "filled",
                        label: t([
                            "device:chartSpeedScale"
                        ], {
                            defaultValue: "Chart speed scale"
                        }),
                        value: scale,
                        validators: (0,_to_consumable_array/* default */.Z)(validators),
                        errorMessages: (0,_to_consumable_array/* default */.Z)(errorMessages),
                        onChange: onChartTimeScaleChange,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: schema/* ChartTimeScale.MINUTE */.cW.MINUTE,
                                children: t([
                                    "units:unitPerMinute"
                                ], {
                                    defaultValue: "[{unit}]/min",
                                    unit: label
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: schema/* ChartTimeScale.HOUR */.cW.HOUR,
                                children: t([
                                    "units:unitPerHour"
                                ], {
                                    defaultValue: "{{unit}}/hour",
                                    unit: label
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: schema/* ChartTimeScale.DAY */.cW.DAY,
                                children: t([
                                    "units:unitPerDay"
                                ], {
                                    defaultValue: "{{unit}}/day",
                                    unit: label
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            invalidFormMessage
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/OpenInBrowser.js
var OpenInBrowser = __webpack_require__(23399);
;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/line.tsx






var line_isShown = function(peripheral) {
    // NOTE: Until this is functional, we hide this from the user.
    return guards/* isSensor */.rq(peripheral) && peripheral && peripheral.peripheralInformation !== undefined;
};
var line_TabProps = {
    isShown: function(_, p) {
        return !!p && line_isShown(p);
    },
    label: function(t) {
        return t("device:lineSetup", {
            defaultValue: "Line"
        });
    }
};
var line_TabPanel = function(param) {
    var peripheral = param.peripheral, classes = param.classes, invalidFormMessage = param.invalidFormMessage, t = param.t;
    if (!line_isShown(peripheral)) {
        return null;
    }
    var existingLine = guards/* isSensor */.rq(peripheral) && peripheral && peripheral.peripheralInformation && peripheral.peripheralInformation.line;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.centeredContainer,
                children: !existingLine ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                    href: {
                        pathname: "/lines",
                        query: {
                            action: "create",
                            device: "".concat(peripheral && peripheral.peripheralId)
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        color: "primary",
                        variant: "contained",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInBrowser/* default */.Z, {
                                style: {
                                    paddingRight: "5px"
                                }
                            }),
                            t([
                                "line:createLine"
                            ], {
                                defaultValue: "Create line"
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                    href: {
                        pathname: "/line",
                        query: {
                            lineId: existingLine.id,
                            tab: "live"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        color: "primary",
                        variant: "contained",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInBrowser/* default */.Z, {
                                style: {
                                    paddingRight: "5px"
                                }
                            }),
                            t([
                                "line:goToLine"
                            ], {
                                defaultValue: "Go to line"
                            })
                        ]
                    })
                })
            }),
            invalidFormMessage
        ]
    });
};

// EXTERNAL MODULE: ../../modules/common/dist/es/data-validator.js
var data_validator = __webpack_require__(36415);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(3908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(26793);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(27908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(49692);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(30810);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(77179);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/missing-alarms.tsx






















var missing_alarms_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    var _obj;
    return {
        tabPanel: (_obj = {
            padding: "20px",
            minHeight: "350px",
            width: "100%"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
            width: "70%"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
            width: "60%"
        }), _obj),
        textFields: {
            width: "100%"
        },
        checkboxField: {
            marginLeft: "0px"
        },
        topMargin: {
            marginTop: "16px"
        }
    };
});
var subscriberTypesObj = schema/* SubscriberType */.V0;
var missing_alarms_TabProps = {
    isValid: function(state) {
        var ref, ref1;
        return state.name.length > 0 && !!(state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.type);
    },
    label: function(t) {
        return t("device:missingDataAlarms", {
            defaultValue: "Missing data alarms"
        });
    }
};
var missing_alarms_TabPanel = function(props) {
    var ref, ref1, ref2;
    var handleChange = props.handleChange, stateConfigInput = props.stateConfigInput, invalidFormMessage = props.invalidFormMessage;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref3[0];
    var classes = missing_alarms_useStyles().classes;
    var ref4;
    var alarmConfigData = (0,_object_spread/* default */.Z)({}, (ref4 = stateConfigInput === null || stateConfigInput === void 0 ? void 0 : stateConfigInput.dataAlarm) !== null && ref4 !== void 0 ? ref4 : {});
    var addItem = function() {
        var subscribers = alarmConfigData.subscribers ? alarmConfigData.subscribers : [];
        var newSubscriber = {
            type: subscriberTypesObj.EMAIL,
            value: "",
            languageCode: "en"
        };
        handleChange({
            sensor: {
                dataAlarm: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, alarmConfigData), {
                    subscribers: (0,_to_consumable_array/* default */.Z)(subscribers).concat([
                        newSubscriber
                    ])
                })
            }
        });
    };
    var removeItem = function(index) {
        return function() {
            var ref = (0,_object_spread/* default */.Z)({}, alarmConfigData), _subscribers = ref.subscribers, subscribers = _subscribers === void 0 ? [] : _subscribers;
            var newSubscribers = subscribers.filter(function(item, i) {
                if (i !== index) {
                    return item;
                }
            });
            handleChange({
                sensor: {
                    dataAlarm: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, alarmConfigData), {
                        subscribers: newSubscribers
                    })
                }
            });
        };
    };
    var onDataAlarmChange = function(e) {
        var dataAlarm = (0,_object_spread/* default */.Z)({}, alarmConfigData || {});
        var name = e.target.name;
        var value = e.target.value;
        if (dataAlarm && name === "updateBuffer") {
            dataAlarm.updateBuffer = parseInt(value, 10).seconds;
        } else if (dataAlarm && name === "notificationFrequency") {
            dataAlarm.notificationFrequency = parseInt(value, 10).seconds;
        } else if (dataAlarm && name === "repeatNotification" && "checked" in e.target) {
            dataAlarm.repeatNotification = e.target.checked;
        }
        handleChange({
            sensor: {
                dataAlarm: dataAlarm
            }
        });
    };
    var onDataAlarmSubscriberChange = function(index) {
        return function(event) {
            var updatedSubscribers = cloneDeep_default()(alarmConfigData.subscribers);
            var name = event.target.name;
            var value = event.target.value;
            if (name === "type") {
                updatedSubscribers[index].type = value;
            } else if (name === "value") {
                updatedSubscribers[index].value = value;
            }
            handleChange({
                sensor: {
                    dataAlarm: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, alarmConfigData), {
                        subscribers: updatedSubscribers
                    })
                }
            });
        };
    };
    var alarmSubscriptionValid = function(type, value) {
        switch(type){
            case schema/* SubscriberType.EMAIL */.V0.EMAIL:
                return (0,data_validator/* isValidEmail */.vV)(value);
            case schema/* SubscriberType.SMS */.V0.SMS:
                return (0,data_validator/* isValidPhoneNumber */.yf)(value);
            default:
                console.error("Unrecognized subscriber type");
                return false;
        }
    };
    var SubscriberInput = function(subscriber, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            spacing: 1,
            alignItems: "center",
            container: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        select: true,
                        onChange: onDataAlarmSubscriberChange(index),
                        variant: "filled",
                        className: classes.textFields,
                        name: "type",
                        label: t([
                            "device:subscriptionType"
                        ], {
                            defaultValue: "Subscription type"
                        }),
                        value: subscriber.type || schema/* SubscriberType.EMAIL */.V0.EMAIL,
                        helperText: " ",
                        required: true,
                        children: AlarmTypes()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        className: classes.textFields,
                        variant: "filled",
                        name: "value",
                        type: "text",
                        label: t([
                            "device:subscriptionValue"
                        ], {
                            defaultValue: "Email/Phone No"
                        }),
                        required: true,
                        value: subscriber.value ? subscriber.value : "",
                        onChange: onDataAlarmSubscriberChange(index),
                        error: !alarmSubscriptionValid(subscriber.type, subscriber.value),
                        helperText: !alarmSubscriptionValid(subscriber.type, subscriber.value) ? subscriberTypeToErrorMeesage(subscriber.type) : " "
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: removeItem(index),
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    })
                })
            ]
        });
    };
    var subscriberTypeToErrorMeesage = function(subType) {
        switch(subType){
            case schema/* SubscriberType.EMAIL */.V0.EMAIL:
                return t([
                    "shared:emailNotValid"
                ], {
                    defaultValue: "Not a valid e-mail"
                });
            case schema/* SubscriberType.SMS */.V0.SMS:
                return t([
                    "shared:phoneNotValid"
                ], {
                    defaultValue: "Not a valid phone number. Note: must contain country code!"
                });
            default:
                console.error("Unrecognized SubscriptionType! ", subType);
                return "Error";
        }
    };
    var AlarmTypes = function() {
        var menuItems = [];
        for(var key in subscriberTypesObj){
            if (subscriberTypesObj.hasOwnProperty(key)) {
                menuItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                    value: key,
                    children: key
                }, key));
            }
        }
        return menuItems;
    };
    var Subscribers = alarmConfigData && alarmConfigData.subscribers && alarmConfigData.subscribers.length > 0 && alarmConfigData.subscribers.map(function(subscriber, index) {
        return SubscriberInput(subscriber, index);
    });
    var updateBufferHasValue = !!stateConfigInput && !!stateConfigInput.dataAlarm && !!stateConfigInput.dataAlarm.updateBuffer;
    var updateBufferValue = updateBufferHasValue ? stateConfigInput.dataAlarm.updateBuffer / 1000 : "";
    var updateBufferHasError = updateBufferHasValue && +updateBufferValue < 0;
    var notificationFrequencyHasValue = !!stateConfigInput && !!((ref = stateConfigInput.dataAlarm) === null || ref === void 0 ? void 0 : ref.notificationFrequency);
    var notificationFrequencyValue = notificationFrequencyHasValue ? stateConfigInput.dataAlarm.notificationFrequency / 1000 : "";
    var notificationFrequencyHasError = notificationFrequencyHasValue && +notificationFrequencyValue < 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                className: classes.textFields,
                fullWidth: true,
                variant: "filled",
                name: "updateBuffer",
                type: "number",
                label: updateBufferHasError ? t([
                    "shared:mustBePositive"
                ], {
                    defaultValue: "Must be a positive number"
                }) : t([
                    "device:offlineDurationSeconds"
                ], {
                    defaultValue: "Offline duration (seconds)"
                }),
                helperText: t([
                    "device:offlineDurationHelperText"
                ], {
                    defaultValue: "The time in seconds the sensor should be offline before you want to receive an alarm"
                }),
                value: updateBufferValue,
                error: updateBufferHasError,
                onChange: onDataAlarmChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                className: "".concat(classes.textFields, " "),
                variant: "filled",
                fullWidth: true,
                name: "notificationFrequency",
                type: "number",
                label: t([
                    "alarms:alarmThreshold"
                ], {
                    defaultValue: "Notification threshold (seconds)"
                }),
                helperText: notificationFrequencyHasError ? t([
                    "shared:mustBePositive"
                ], {
                    defaultValue: "Must be a positive number"
                }) : t([
                    "alarms:alarmThresholdDescription"
                ], {
                    defaultValue: "Minimum amount of time before a new alarm notification can be sent"
                }),
                value: notificationFrequencyValue,
                error: notificationFrequencyHasError,
                onChange: onDataAlarmChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                className: classes.checkboxField,
                name: "repeatNotification",
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    checked: !!(stateConfigInput === null || stateConfigInput === void 0 ? void 0 : (ref1 = stateConfigInput.dataAlarm) === null || ref1 === void 0 ? void 0 : ref1.repeatNotification),
                    onChange: onDataAlarmChange,
                    value: stateConfigInput === null || stateConfigInput === void 0 ? void 0 : (ref2 = stateConfigInput.dataAlarm) === null || ref2 === void 0 ? void 0 : ref2.repeatNotification,
                    color: "primary"
                }),
                label: "".concat(t([
                    "alarms:alarmRepeatDescription"
                ], {
                    defaultValue: "Repeat notification while alarm is ongoing (limited by the notification threshold)"
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.topMargin,
                children: Subscribers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: addItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                color: "primary",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {}),
                                    t([
                                        "alarms:addAlarmSubscriber"
                                    ], {
                                        defaultValue: "Add subscriber to alarm"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 8
                    })
                ]
            }),
            invalidFormMessage,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {})
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(88149);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(23181);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormControl/FormControl.js
var FormControl = __webpack_require__(39829);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Radio/Radio.js + 3 modules
var Radio = __webpack_require__(39261);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(15439);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Switch/Switch.js
var Switch = __webpack_require__(28307);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(84074);
;// CONCATENATED MODULE: ./components/validators-forms/discrete-states-validator.tsx








var DiscreteStates = function(props) {
    var onClickDelete = props.onClickDelete, value = props.value;
    var getOnDelete = function(stateValue) {
        return function() {
            return onClickDelete(stateValue);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            marginBottom: "10px",
            marginLeft: "10px"
        },
        children: value.map(function(stateValue) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                id: "".concat(stateValue),
                label: "".concat(stateValue),
                onDelete: getOnDelete(stateValue)
            }, "discrete-state-chip-".concat(stateValue));
        })
    });
};
var DiscreteStatesValidator = /*#__PURE__*/ function(ValidatorComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DiscreteStatesValidator, ValidatorComponent);
    var _super = (0,_create_super/* default */.Z)(DiscreteStatesValidator);
    function DiscreteStatesValidator() {
        (0,_class_call_check/* default */.Z)(this, DiscreteStatesValidator);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            isValid: true,
            value: []
        };
        return _this;
    }
    var _proto = DiscreteStatesValidator.prototype;
    _proto.render = function render() {
        /* eslint-disable no-unused-vars */ return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "filled",
            fullWidth: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscreteStates, {
                value: this.props.value,
                onClickDelete: this.props.onClickDelete
            })
        });
    };
    _proto.errorText = function errorText() {
        var isValid = this.state.isValid;
        return isValid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            color: "error",
            children: this.props.t([
                "sensor:sensorDiscreteStates"
            ], {
                defaultValue: "At least one off and on state required"
            })
        }) : null;
    };
    return DiscreteStatesValidator;
}(lib/* ValidatorComponent */.nE);

;// CONCATENATED MODULE: ./lib/config-helpers.ts

var convertMultiplierOffset = function(multiplier, offset, analogRange) {
    var unitMaxMin = parseAnalogRange(analogRange);
    var sensorMin = offset + multiplier * (unitMaxMin.min * 1000);
    var sensorMax = sensorMin + multiplier * (unitMaxMin.max * 1000 - unitMaxMin.min * 1000);
    return {
        sensorMin: sensorMin,
        sensorMax: sensorMax
    };
};
var convertSensorMinMax = function(sensorMin, sensorMax, analogRange) {
    var unitMaxMin = parseAnalogRange(analogRange);
    var dataMultiplier = ((sensorMax || 0) - (sensorMin || 0)) / (unitMaxMin.max * 1000 - unitMaxMin.min * 1000);
    return {
        dataMultiplier: dataMultiplier,
        analogOffset: (sensorMin || 0) - dataMultiplier * (unitMaxMin.min * 1000)
    };
};
var parseAnalogRange = function(range) {
    switch(range){
        case schema/* AnalogInputRange.NEGATIVE_TEN_TO_TEN_VOLTS */.wo.NEGATIVE_TEN_TO_TEN_VOLTS:
            return {
                min: -10,
                max: 10
            };
        case schema/* AnalogInputRange.ZERO_TO_TEN_VOLTS */.wo.ZERO_TO_TEN_VOLTS:
            return {
                min: 0,
                max: 10
            };
        case schema/* AnalogInputRange.ZERO_TO_FIVE_VOLTS */.wo.ZERO_TO_FIVE_VOLTS:
            return {
                min: 0,
                max: 5
            };
        case schema/* AnalogInputRange.NEGATIVE_FIVE_TO_FIVE_VOLTS */.wo.NEGATIVE_FIVE_TO_FIVE_VOLTS:
            return {
                min: -5,
                max: 5
            };
        case schema/* AnalogInputRange.ZERO_TO_TWENTY_MILLIAMPS */.wo.ZERO_TO_TWENTY_MILLIAMPS:
            return {
                min: 0,
                max: 20
            };
        case schema/* AnalogInputRange.ZERO_TO_TWENTYFOUR_MILLIAMPS */.wo.ZERO_TO_TWENTYFOUR_MILLIAMPS:
            return {
                min: 0,
                max: 24
            };
        case schema/* AnalogInputRange.FOUR_TO_TWENTY_MILLIAMPS */.wo.FOUR_TO_TWENTY_MILLIAMPS:
            return {
                min: 4,
                max: 20
            };
        case schema/* AnalogInputRange.NEGATIVE_TWENTYFIVE_TO_TWENTYFIVE_MILLIAMPS */.wo.NEGATIVE_TWENTYFIVE_TO_TWENTYFIVE_MILLIAMPS:
            return {
                min: -25,
                max: 25
            };
        default:
            // TODO: Removed the below assertion, as we actually can end up here when changing a sensor from another type to 'Measurement'.
            // Not sure if this should be handled differently
            // Types.assertUnreachable(range);
            return {
                min: 4,
                max: 20
            };
    }
};

// EXTERNAL MODULE: ./views/administration/device/config/device-config-card.tsx + 3 modules
var device_config_card = __webpack_require__(18193);
;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/sensor.tsx































var sensor_isShown = function(state) {
    var ref, ref1, ref2, ref3;
    return state.peripheralType === "SENSOR" && ((ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.type) !== schema/* SensorType.EVENT */.dE.EVENT && ((ref2 = state.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : ref3.type) !== schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS;
};
var hasOnState = function(state) {
    var ref, ref1, ref2, ref3;
    var ref4;
    return ((ref4 = state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discreteConfig) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.onStates) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref4 !== void 0 ? ref4 : 0) > 0;
};
var hasOffState = function(state) {
    var ref, ref1, ref2, ref3;
    var ref4;
    return ((ref4 = state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discreteConfig) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.offStates) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref4 !== void 0 ? ref4 : 0) > 0;
};
var hasDiscreteStates = function(state) {
    return hasOnState(state) && hasOffState(state);
};
var sensor_isValid = function(state) {
    var ref;
    var ref1;
    var ref2 = (ref1 = (ref = state.config) === null || ref === void 0 ? void 0 : ref.sensor) !== null && ref1 !== void 0 ? ref1 : {}, type = ref2.type, analogInputRange = ref2.analogInputRange, dataMultiplier = ref2.dataMultiplier, analogOffset = ref2.analogOffset;
    switch(type){
        case schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT:
            var useAnalogInputRange = !!analogInputRange;
            var useDataMultiplier = !analogInputRange && typeof dataMultiplier === "number" && typeof analogOffset === "number";
            return !useAnalogInputRange && useDataMultiplier || useAnalogInputRange && !useDataMultiplier;
        // TS does not have XOR :(
        case schema/* SensorType.DISCRETE */.dE.DISCRETE:
            return hasDiscreteStates(state) && typeof dataMultiplier === "number" && dataMultiplier > 0;
        default:
            return typeof dataMultiplier === "number" && dataMultiplier > 0;
    }
};
var formatAnalogRange = function(t, type) {
    return startCase_default()(type.toLowerCase());
};
var sensor_TabProps = {
    isShown: sensor_isShown,
    isValid: sensor_isValid,
    label: function(t) {
        return t([
            "device:sensorSetup"
        ], {
            defaultValue: "Sensor"
        });
    }
};
lib/* ValidatorForm.addValidationRule */.WS.addValidationRule("notZero", function(value) {
    return value !== 0;
});
lib/* ValidatorForm.addValidationRule */.WS.addValidationRule("notEmpty", function(value) {
    if ((0,_instanceof/* default */.Z)(value, Array)) {
        return value.length > 0;
    }
    return false;
});
var sensor_TabPanel = function(_param) {
    var enumTypes = _param.enumTypes, props = (0,_object_without_properties/* default */.Z)(_param, [
        "enumTypes"
    ]);
    var ref, ref1;
    if (!sensor_isShown(props.state)) {
        return null;
    }
    switch((ref = props.state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.type){
        case schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MeasurementContent, (0,_object_spread/* default */.Z)({
                enumTypes: enumTypes
            }, props));
        case schema/* SensorType.COUNTER_ACCUMULATE */.dE.COUNTER_ACCUMULATE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CounterAccContent, (0,_object_spread/* default */.Z)({}, props));
        case schema/* SensorType.DISCRETE */.dE.DISCRETE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscreteContent, (0,_object_spread/* default */.Z)({}, props));
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CounterContent, (0,_object_spread/* default */.Z)({}, props));
    }
};
var getPressEnterHandler = function(elementId, onPressEnter) {
    var handleAdd = getAddHandler(elementId, onPressEnter);
    return function(event) {
        if (!event || !event.key || event.key !== "Enter") {
            return;
        }
        event.preventDefault();
        handleAdd();
    };
};
var getAddHandler = function(elementId, onAdd) {
    return function() {
        var input = document.getElementById(elementId);
        var stateValue = parseInt(input.value, 10);
        if (!Number.isNaN(stateValue)) {
            onAdd(stateValue);
        }
        input.value = "";
    };
};
var wiringOptions = Object.keys(schema/* SensorWiring */.r5).sort();
var WiringSelection = function(param) {
    var wiring = param.wiring, classes = param.classes, handleChange = param.handleChange;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    if (!wiring) {
        return null;
    }
    var reportedWiring = wiring.reported || null;
    var desiredWiring = wiring.desired;
    var onWiringChange = function(param) {
        var value = param.target.value;
        handleChange({
            sensor: {
                wiring: {
                    reported: reportedWiring,
                    desired: value
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        variant: "filled",
        fullWidth: true,
        className: classes.formControl,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
            badgeContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(device_config_card/* SyncBadge */.z, {
                pendingChanges: reportedWiring !== desiredWiring
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* SelectValidator */.$y, {
                className: classes.selectFields,
                containerClass: classes.containerClass,
                name: "type",
                label: t([
                    "device:sensorWiring"
                ], {
                    defaultValue: "The type of wiring for the attached sensor"
                }),
                value: desiredWiring,
                onChange: onWiringChange,
                children: wiringOptions.map(function(wiringType) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        value: wiringType,
                        children: wiringType
                    }, wiringType);
                })
            })
        })
    });
};
var DiscreteContent = function(param) {
    var handleChange = param.handleChange, state = param.state, invalidFormMessage = param.invalidFormMessage, classes = param.classes, t = param.t;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var onDataMultiplierChange = function(e) {
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                dataMultiplier: val.trim().length ? parseFloat(val) : undefined
            }
        });
    };
    var discreteConfig = ((ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.discreteConfig) || {};
    var handleAddOnState = function(stateValue) {
        var _onStates;
        var currentOnStates = (_onStates = discreteConfig.onStates) !== null && _onStates !== void 0 ? _onStates : [];
        var _offStates;
        var currentOffStates = (_offStates = discreteConfig.offStates) !== null && _offStates !== void 0 ? _offStates : [];
        if (!currentOnStates.includes(stateValue)) {
            var index = currentOffStates.indexOf(stateValue);
            if (index >= 0) {
                handleChange({
                    sensor: {
                        discreteConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discreteConfig), {
                            onStates: (0,_to_consumable_array/* default */.Z)(currentOnStates).concat([
                                stateValue
                            ]),
                            offStates: currentOffStates.filter(function(_, i) {
                                return index !== i;
                            })
                        })
                    }
                });
            } else {
                handleChange({
                    sensor: {
                        discreteConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discreteConfig), {
                            onStates: (0,_to_consumable_array/* default */.Z)(currentOnStates).concat([
                                stateValue
                            ])
                        })
                    }
                });
            }
        }
    };
    var handleAddOffState = function(stateValue) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6;
        var currentOnStates = (ref6 = state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discreteConfig) === null || ref2 === void 0 ? void 0 : ref2.onStates) !== null && ref6 !== void 0 ? ref6 : [];
        var ref7;
        var currentOffStates = (ref7 = state === null || state === void 0 ? void 0 : (ref3 = state.config) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sensor) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.discreteConfig) === null || ref5 === void 0 ? void 0 : ref5.offStates) !== null && ref7 !== void 0 ? ref7 : [];
        if (!currentOffStates.includes(stateValue)) {
            var index = currentOnStates.indexOf(stateValue);
            if (index >= 0) {
                handleChange({
                    sensor: {
                        discreteConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discreteConfig), {
                            onStates: currentOnStates.filter(function(_, i) {
                                return index !== i;
                            }),
                            offStates: (0,_to_consumable_array/* default */.Z)(currentOffStates).concat([
                                stateValue
                            ])
                        })
                    }
                });
            } else {
                handleChange({
                    sensor: {
                        discreteConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discreteConfig), {
                            offStates: (0,_to_consumable_array/* default */.Z)(currentOffStates).concat([
                                stateValue
                            ])
                        })
                    }
                });
            }
        }
    };
    var handleDeleteState = function(stateValue) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6;
        var currentOnStates = (ref6 = state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discreteConfig) === null || ref2 === void 0 ? void 0 : ref2.onStates) !== null && ref6 !== void 0 ? ref6 : [];
        var ref7;
        var currentOffStates = (ref7 = state === null || state === void 0 ? void 0 : (ref3 = state.config) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sensor) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.discreteConfig) === null || ref5 === void 0 ? void 0 : ref5.offStates) !== null && ref7 !== void 0 ? ref7 : [];
        var onStateIndex = currentOnStates.indexOf(stateValue);
        var offStateIndex = currentOffStates.indexOf(stateValue);
        if (onStateIndex >= 0) {
            handleChange({
                sensor: {
                    discreteConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discreteConfig), {
                        onStates: currentOnStates.filter(function(_, i) {
                            return onStateIndex !== i;
                        })
                    })
                }
            });
        } else if (offStateIndex >= 0) {
            handleChange({
                sensor: {
                    discreteConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discreteConfig), {
                        offStates: currentOffStates.filter(function(_, i) {
                            return offStateIndex !== i;
                        })
                    })
                }
            });
        }
    };
    var onDefaultStateChange = function(e) {
        handleChange({
            sensor: {
                discreteConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discreteConfig), {
                    defaultState: e.target.value
                })
            }
        });
    };
    var ref19, ref20, ref21, ref22;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                            className: classes.textFields,
                            containerClass: classes.containerClass,
                            name: "dataMultiplier",
                            type: "number",
                            label: t([
                                "device:dataMultiplier"
                            ], {
                                defaultValue: "Data multiplier"
                            }),
                            validators: [
                                "required",
                                "isPositive",
                                "notZero"
                            ],
                            errorMessages: [
                                t([
                                    "shared:fieldIsRequired"
                                ], {
                                    defaultValue: "this field is required"
                                }),
                                t([
                                    "shared:mustBePositive"
                                ], {
                                    defaultValue: "must be a positive number"
                                }),
                                t([
                                    "shared:mustBePositive"
                                ], {
                                    defaultValue: "must be a positive number"
                                }), 
                            ],
                            value: state === null || state === void 0 ? void 0 : (ref2 = state.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : ref3.dataMultiplier,
                            helperText: !!(state === null || state === void 0 ? void 0 : (ref4 = state.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sensor) === null || ref5 === void 0 ? void 0 : ref5.dataMultiplier) && (state === null || state === void 0 ? void 0 : (ref6 = state.config) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sensor) === null || ref7 === void 0 ? void 0 : ref7.dataMultiplier) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t([
                                    "device:configurationDataMultiplierExplanation"
                                ], {
                                    defaultValue: "Future incoming data from the sensor will be multiplied by {{dataMultiplier}}. Old data will not be affected. If you change this value, remember to change target line speeds for your batches / products as well",
                                    dataMultiplier: (ref19 = state === null || state === void 0 ? void 0 : (ref8 = state.config) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sensor) === null || ref9 === void 0 ? void 0 : ref9.dataMultiplier) !== null && ref19 !== void 0 ? ref19 : 1
                                })
                            }) : undefined,
                            onChange: onDataMultiplierChange
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.discreteContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        variant: "filled",
                                        id: "onStatesInput",
                                        name: "onStates",
                                        type: "number",
                                        label: t([
                                            "device:onStates"
                                        ], {
                                            defaultValue: "ON States"
                                        }),
                                        style: {
                                            flex: "1 1 auto"
                                        },
                                        error: !hasOnState(state),
                                        helperText: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t([
                                                "device:discreteStatesOnExplanation"
                                            ], {
                                                defaultValue: "Specify the sensor states that correspond to the line being on (remember to click the + to add the state)"
                                            })
                                        }),
                                        onKeyPress: getPressEnterHandler("onStatesInput", handleAddOnState)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: classes.discreteAddButton,
                                        onClick: getAddHandler("onStatesInput", handleAddOnState),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscreteStatesValidator, {
                                validators: [
                                    "notEmpty"
                                ],
                                t: t,
                                value: (ref20 = state === null || state === void 0 ? void 0 : (ref10 = state.config) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.sensor) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.discreteConfig) === null || ref12 === void 0 ? void 0 : ref12.onStates) !== null && ref20 !== void 0 ? ref20 : [],
                                onClickDelete: handleDeleteState
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.discreteContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        variant: "filled",
                                        id: "offStatesInput",
                                        name: "offStates",
                                        type: "number",
                                        label: t([
                                            "device:offStates"
                                        ], {
                                            defaultValue: "OFF States"
                                        }),
                                        style: {
                                            flex: "1 1 auto"
                                        },
                                        error: !hasOffState(state),
                                        helperText: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t([
                                                "device:discreteStatesOffExplanation"
                                            ], {
                                                defaultValue: "Specify the sensor states that correspond to the line being off (remember to click the + to add the state)"
                                            })
                                        }),
                                        onKeyPress: getPressEnterHandler("offStatesInput", handleAddOffState)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: classes.discreteAddButton,
                                        onClick: getAddHandler("offStatesInput", handleAddOffState),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscreteStatesValidator, {
                                validators: [
                                    "notEmpty"
                                ],
                                t: t,
                                value: (ref21 = state === null || state === void 0 ? void 0 : (ref13 = state.config) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.sensor) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.discreteConfig) === null || ref15 === void 0 ? void 0 : ref15.offStates) !== null && ref21 !== void 0 ? ref21 : [],
                                onClickDelete: handleDeleteState
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_validator/* SelectValidator */.$y, {
                            className: classes.selectFields,
                            containerClass: classes.containerClass,
                            name: "type",
                            label: "".concat(t([
                                "device:defaultState"
                            ], {
                                defaultValue: "Default state"
                            }), " *"),
                            helperText: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t([
                                    "device:discreteStatesDefaultExplanation"
                                ], {
                                    defaultValue: "If the value is not caught by either of the above states, it will fallback to the default state"
                                })
                            }),
                            value: (ref22 = state === null || state === void 0 ? void 0 : (ref16 = state.config) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.sensor) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.discreteConfig) === null || ref18 === void 0 ? void 0 : ref18.defaultState) !== null && ref22 !== void 0 ? ref22 : "OFF",
                            validators: [
                                "required"
                            ],
                            errorMessages: [
                                t([
                                    "shared:fieldIsRequired"
                                ], {
                                    defaultValue: "this field is required"
                                })
                            ],
                            onChange: onDefaultStateChange,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: "OFF",
                                    children: t([
                                        "shared:off"
                                    ], {
                                        defaultValue: "Off"
                                    })
                                }, "off"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: "ON",
                                    children: t([
                                        "shared:on"
                                    ], {
                                        defaultValue: "On"
                                    })
                                }, "on")
                            ]
                        })
                    })
                ]
            }),
            invalidFormMessage,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {})
        ]
    });
};
var CounterContent = function(param) {
    var handleChange = param.handleChange, state = param.state, invalidFormMessage = param.invalidFormMessage, classes = param.classes, t = param.t;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    lib/* ValidatorForm.addValidationRule */.WS.addValidationRule("notZero", function(value) {
        return value !== 0;
    });
    var onDataMultiplierChange = function(e) {
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                dataMultiplier: val.trim().length ? parseFloat(val) : undefined
            }
        });
    };
    var ref14, ref15;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                name: "dataMultiplier",
                type: "number",
                label: t([
                    "device:dataMultiplier"
                ], {
                    defaultValue: "Data multiplier"
                }),
                validators: [
                    "required",
                    "isPositive",
                    "notZero"
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }), 
                ],
                value: state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.dataMultiplier,
                helperText: !!(state === null || state === void 0 ? void 0 : (ref2 = state.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : ref3.dataMultiplier) && (state === null || state === void 0 ? void 0 : (ref4 = state.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sensor) === null || ref5 === void 0 ? void 0 : ref5.dataMultiplier) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t([
                        "device:configurationDataMultiplierExplanation"
                    ], {
                        defaultValue: "Future incoming data from the sensor will be multiplied by {{dataMultiplier}}. Old data will not be affected. If you change this value, remember to change target line speeds for your batches / products as well",
                        dataMultiplier: (ref14 = state === null || state === void 0 ? void 0 : (ref6 = state.config) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sensor) === null || ref7 === void 0 ? void 0 : ref7.dataMultiplier) !== null && ref14 !== void 0 ? ref14 : 1
                    })
                }) : undefined,
                onChange: onDataMultiplierChange
            }),
            invalidFormMessage,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WiringSelection, {
                handleChange: handleChange,
                classes: classes,
                wiring: ((ref8 = state.config) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sensor) === null || ref9 === void 0 ? void 0 : ref9.wiring) || null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {}),
            ((ref10 = state.config) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.sensor) === null || ref11 === void 0 ? void 0 : ref11.type) === schema/* SensorType.COUNTER */.dE.COUNTER ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.containerClass,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                                color: "primary",
                                checked: (ref15 = (ref12 = state.config) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.sensor) === null || ref13 === void 0 ? void 0 : ref13.energyMeter) !== null && ref15 !== void 0 ? ref15 : false,
                                onChange: function(e) {
                                    var ref, ref1;
                                    if (e.target.checked && ((ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.findStops)) {
                                        // Then we also disable findStops
                                        handleChange({
                                            sensor: {
                                                energyMeter: true,
                                                findStops: false
                                            }
                                        });
                                    } else {
                                        handleChange({
                                            sensor: {
                                                energyMeter: e.target.checked
                                            }
                                        });
                                    }
                                }
                            }),
                            label: t("device:energyMeter", {
                                defaultValue: "Energy Meter"
                            }),
                            className: classes.textFields
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {
                        overrideTitle: t("device:energyMeterDescription", {
                            defaultValue: "Enable if the sensor is an energy meter."
                        })
                    })
                ]
            }) : null
        ]
    });
};
lib/* ValidatorForm.addValidationRule */.WS.addValidationRule("notZero", function(value) {
    return value !== 0;
});
var CounterAccContent = function(param) {
    var handleChange = param.handleChange, state = param.state, invalidFormMessage = param.invalidFormMessage, classes = param.classes, t = param.t;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    var accumulatorConfig = ((ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.accumulatorConfig) || {};
    var onDataMultiplierChange = function(e) {
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                dataMultiplier: val.trim().length ? parseFloat(val) : undefined
            }
        });
    };
    var onRolloverValueChange = function(e) {
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                accumulatorConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulatorConfig), {
                    rolloverValue: val.trim().length ? parseFloat(val) : undefined
                })
            }
        });
    };
    var onPowerCheck = function(e) {
        return handleChange({
            sensor: {
                accumulatorConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulatorConfig), {
                    resetsOnPowerOff: e.target.checked
                })
            }
        });
    };
    var onRolloverThresholdChange = function(e) {
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                accumulatorConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulatorConfig), {
                    rolloverThreshold: val.trim().length ? parseFloat(val) : undefined
                })
            }
        });
    };
    var ref26, ref27, ref28, ref29;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                name: "dataMultiplier",
                type: "number",
                label: t([
                    "device:dataMultiplier"
                ], {
                    defaultValue: "Data multiplier"
                }),
                validators: [
                    "required",
                    "isPositive",
                    "notZero"
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }), 
                ],
                value: state === null || state === void 0 ? void 0 : (ref2 = state.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : ref3.dataMultiplier,
                helperText: !!(state === null || state === void 0 ? void 0 : (ref4 = state.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sensor) === null || ref5 === void 0 ? void 0 : ref5.dataMultiplier) && (state === null || state === void 0 ? void 0 : (ref6 = state.config) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sensor) === null || ref7 === void 0 ? void 0 : ref7.dataMultiplier) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t([
                        "device:configurationDataMultiplierExplanation"
                    ], {
                        defaultValue: "Future incoming data from the sensor will be multiplied by {{dataMultiplier}}. Old data will not be affected. If you change this value, remember to change target line speeds for your batches / products as well",
                        dataMultiplier: (ref26 = state === null || state === void 0 ? void 0 : (ref8 = state.config) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sensor) === null || ref9 === void 0 ? void 0 : ref9.dataMultiplier) !== null && ref26 !== void 0 ? ref26 : 1
                    })
                }) : undefined,
                onChange: onDataMultiplierChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WiringSelection, {
                handleChange: handleChange,
                classes: classes,
                wiring: ((ref10 = state.config) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.sensor) === null || ref11 === void 0 ? void 0 : ref11.wiring) || null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                name: "rolloverValue",
                type: "number",
                label: t([
                    "device:rolloverValue"
                ], {
                    defaultValue: "Rollover value"
                }),
                validators: [
                    "required",
                    "isPositive"
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }), 
                ],
                value: state === null || state === void 0 ? void 0 : (ref12 = state.config) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.sensor) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.accumulatorConfig) === null || ref14 === void 0 ? void 0 : ref14.rolloverValue,
                onChange: onRolloverValueChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        className: classes.checkboxField,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            checked: (ref27 = state === null || state === void 0 ? void 0 : (ref15 = state.config) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.sensor) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.accumulatorConfig) === null || ref17 === void 0 ? void 0 : ref17.resetsOnPowerOff) !== null && ref27 !== void 0 ? ref27 : false,
                            onChange: onPowerCheck,
                            value: "enabled",
                            color: "primary"
                        }),
                        label: "".concat(t([
                            "device:counterCanReset"
                        ], {
                            defaultValue: "Counter can reset (e.g. on power off or manually)"
                        }))
                    }),
                    ((ref28 = state === null || state === void 0 ? void 0 : (ref18 = state.config) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.sensor) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.accumulatorConfig) === null || ref20 === void 0 ? void 0 : ref20.resetsOnPowerOff) !== null && ref28 !== void 0 ? ref28 : false) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                        className: classes.textFields,
                        containerClass: classes.containerClassTwoColumns,
                        style: {
                            marginRight: 10
                        },
                        name: "rolloverThreshold",
                        type: "number",
                        label: t([
                            "device:rolloverThreshold"
                        ], {
                            defaultValue: "Rollover threshold"
                        }),
                        validators: [
                            "required",
                            "isPositive",
                            "notZero"
                        ],
                        errorMessages: [
                            t([
                                "shared:fieldIsRequired"
                            ], {
                                defaultValue: "this field is required"
                            }),
                            t([
                                "shared:mustBePositive"
                            ], {
                                defaultValue: "must be a positive number"
                            }),
                            t([
                                "shared:mustBePositive"
                            ], {
                                defaultValue: "must be a positive number"
                            }), 
                        ],
                        value: state === null || state === void 0 ? void 0 : (ref21 = state.config) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.sensor) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.accumulatorConfig) === null || ref23 === void 0 ? void 0 : ref23.rolloverThreshold,
                        onChange: onRolloverThresholdChange
                    }) : null
                ]
            }),
            invalidFormMessage,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.containerClass,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                        color: "primary",
                        checked: (ref29 = (ref24 = state.config) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.sensor) === null || ref25 === void 0 ? void 0 : ref25.energyMeter) !== null && ref29 !== void 0 ? ref29 : false,
                        onChange: function(e) {
                            var ref, ref1;
                            if (e.target.checked && ((ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.findStops)) {
                                // Then we also disable findStops
                                handleChange({
                                    sensor: {
                                        energyMeter: true,
                                        findStops: false
                                    }
                                });
                            } else {
                                handleChange({
                                    sensor: {
                                        energyMeter: e.target.checked
                                    }
                                });
                            }
                        }
                    }),
                    label: t("device:energyMeter", {
                        defaultValue: "Energy Meter"
                    }),
                    className: classes.textFields
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {
                overrideTitle: t("device:energyMeterDescription", {
                    defaultValue: "Enable if the sensor is an energy meter."
                })
            })
        ]
    });
};
var parseAnalogUnit = function(range) {
    var _AnalogInputRange = schema/* AnalogInputRange */.wo, NEGATIVE_FIVE_TO_FIVE_VOLTS = _AnalogInputRange.NEGATIVE_FIVE_TO_FIVE_VOLTS, ZERO_TO_FIVE_VOLTS = _AnalogInputRange.ZERO_TO_FIVE_VOLTS, ZERO_TO_TEN_VOLTS = _AnalogInputRange.ZERO_TO_TEN_VOLTS, NEGATIVE_TEN_TO_TEN_VOLTS = _AnalogInputRange.NEGATIVE_TEN_TO_TEN_VOLTS, ZERO_TO_TWENTY_MILLIAMPS = _AnalogInputRange.ZERO_TO_TWENTY_MILLIAMPS, ZERO_TO_TWENTYFOUR_MILLIAMPS = _AnalogInputRange.ZERO_TO_TWENTYFOUR_MILLIAMPS, FOUR_TO_TWENTY_MILLIAMPS = _AnalogInputRange.FOUR_TO_TWENTY_MILLIAMPS, NEGATIVE_TWENTYFIVE_TO_TWENTYFIVE_MILLIAMPS = _AnalogInputRange.NEGATIVE_TWENTYFIVE_TO_TWENTYFIVE_MILLIAMPS;
    switch(range){
        case ZERO_TO_FIVE_VOLTS:
        case ZERO_TO_TEN_VOLTS:
        case NEGATIVE_FIVE_TO_FIVE_VOLTS:
        case NEGATIVE_TEN_TO_TEN_VOLTS:
            return "V";
        case ZERO_TO_TWENTY_MILLIAMPS:
        case ZERO_TO_TWENTYFOUR_MILLIAMPS:
        case FOUR_TO_TWENTY_MILLIAMPS:
        case NEGATIVE_TWENTYFIVE_TO_TWENTYFIVE_MILLIAMPS:
        default:
            return "mA";
    }
};
var AnalogInputOrMultiplier;
(function(AnalogInputOrMultiplier) {
    AnalogInputOrMultiplier[AnalogInputOrMultiplier["UseAnalogInput"] = 0] = "UseAnalogInput";
    AnalogInputOrMultiplier[AnalogInputOrMultiplier["UseDataMultipler"] = 1] = "UseDataMultipler";
})(AnalogInputOrMultiplier || (AnalogInputOrMultiplier = {}));
var MeasurementContent = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var state = props.state, handleChange = props.handleChange, classes = props.classes, t = props.t, enumTypes = props.enumTypes, invalidFormMessage = props.invalidFormMessage;
    var ref24 = parseAnalogRange(state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.analogInputRange), rangeMin = ref24.min, rangeMax = ref24.max;
    var ref25;
    var ref26 = convertMultiplierOffset((ref25 = state === null || state === void 0 ? void 0 : (ref2 = state.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : ref3.dataMultiplier) !== null && ref25 !== void 0 ? ref25 : 1, (state === null || state === void 0 ? void 0 : (ref4 = state.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sensor) === null || ref5 === void 0 ? void 0 : ref5.analogOffset) || 0, state === null || state === void 0 ? void 0 : (ref6 = state.config) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sensor) === null || ref7 === void 0 ? void 0 : ref7.analogInputRange), sensorMin = ref26.sensorMin, sensorMax = ref26.sensorMax;
    var stringUnit = parseAnalogUnit(state === null || state === void 0 ? void 0 : (ref8 = state.config) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sensor) === null || ref9 === void 0 ? void 0 : ref9.analogInputRange);
    var onAnalogInputChange = function(e) {
        return handleChange({
            sensor: {
                analogInputRange: e.target.value
            }
        });
    };
    var onSensorMinChange = function(e) {
        var ref, ref1;
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        var newSensorMin = val.trim().length ? parseFloat(val) : 0;
        var ref2 = convertSensorMinMax(newSensorMin, sensorMax, state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.analogInputRange), dataMultiplier = ref2.dataMultiplier, analogOffset = ref2.analogOffset;
        handleChange({
            sensor: {
                dataMultiplier: dataMultiplier,
                analogOffset: analogOffset
            }
        });
    };
    var onSensorMaxChange = function(e) {
        var ref, ref1;
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        var newSensorMax = val.trim().length ? parseFloat(val) : 0;
        var ref2 = convertSensorMinMax(sensorMin, newSensorMax, state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.analogInputRange), dataMultiplier = ref2.dataMultiplier, analogOffset = ref2.analogOffset;
        handleChange({
            sensor: {
                dataMultiplier: dataMultiplier,
                analogOffset: analogOffset
            }
        });
    };
    var ref27 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), selectedAnalogInputOrMultiplierState = ref27[0], setSelectedAnalogInputOrMultiplierState = ref27[1];
    // only set value the first time
    if (selectedAnalogInputOrMultiplierState === null) {
        var ref28, ref29, ref30, ref31;
        if (state === null || state === void 0 ? void 0 : (ref28 = state.config) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.sensor) === null || ref29 === void 0 ? void 0 : ref29.analogInputRange) {
            setSelectedAnalogInputOrMultiplierState(AnalogInputOrMultiplier.UseAnalogInput);
        } else if (state === null || state === void 0 ? void 0 : (ref30 = state.config) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.sensor) === null || ref31 === void 0 ? void 0 : ref31.dataMultiplier) {
            setSelectedAnalogInputOrMultiplierState(AnalogInputOrMultiplier.UseDataMultipler);
        }
    }
    var analogInputOrMultiplier = /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        variant: "filled",
        component: "fieldset",
        style: {
            padding: "20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
            row: true,
            name: "row-radio-buttons-group",
            value: selectedAnalogInputOrMultiplierState === null || selectedAnalogInputOrMultiplierState === void 0 ? void 0 : selectedAnalogInputOrMultiplierState.toString(),
            onChange: function(event) {
                var val = +event.target.value;
                switch(val){
                    case AnalogInputOrMultiplier.UseAnalogInput:
                        handleChange({
                            sensor: {
                                dataMultiplier: null,
                                analogOffset: 0
                            }
                        });
                        break;
                    case AnalogInputOrMultiplier.UseDataMultipler:
                        handleChange({
                            sensor: {
                                analogInputRange: null
                            }
                        });
                        break;
                    default:
                        break;
                }
                setSelectedAnalogInputOrMultiplierState(val);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    value: AnalogInputOrMultiplier.UseAnalogInput.toString(),
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                    label: t([
                        "device:useAnalogInputRange"
                    ], {
                        defaultValue: "Use analog input range"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    value: AnalogInputOrMultiplier.UseDataMultipler.toString(),
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                    label: t([
                        "device:useDataMultiplier"
                    ], {
                        defaultValue: "Use data multiplier"
                    })
                })
            ]
        })
    });
    var _analogInputRanges;
    var analogInputRangeComponents = [
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_validator/* SelectValidator */.$y, {
            className: classes.selectFields,
            containerClass: classes.containerClass,
            name: "type",
            label: "".concat(t([
                "device:analogRange"
            ], {
                defaultValue: "Analog sensor range"
            }), " *"),
            value: (state === null || state === void 0 ? void 0 : (ref10 = state.config) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.sensor) === null || ref11 === void 0 ? void 0 : ref11.analogInputRange) || "",
            validators: [
                "required"
            ],
            errorMessages: [
                t([
                    "shared:fieldIsRequired"
                ], {
                    defaultValue: "this field is required"
                })
            ],
            helperText: !(state === null || state === void 0 ? void 0 : (ref12 = state.config) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.sensor) === null || ref13 === void 0 ? void 0 : ref13.analogInputRange) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    color: red/* default.500 */.Z[500]
                },
                children: t([
                    "shared:fieldIsRequired"
                ], {
                    defaultValue: "this field is required"
                })
            }) : "",
            onChange: onAnalogInputChange,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                    value: "",
                    disabled: true,
                    children: t([
                        "device:selectAnalogRange"
                    ], {
                        defaultValue: "Select analog sensor range"
                    })
                }, "disabled"),
                ((_analogInputRanges = enumTypes.analogInputRanges) !== null && _analogInputRanges !== void 0 ? _analogInputRanges : []).map(function(analogRange) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        style: {
                            paddingTop: "8px",
                            paddingBottom: "8px"
                        },
                        value: analogRange.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: formatAnalogRange(t, analogRange.name),
                            secondary: analogRange.description
                        })
                    }, analogRange.name);
                })
            ]
        }, 1),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, 2),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, 3),
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                justifyContent: "space-between"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                    className: classes.textFields,
                    containerClass: classes.containerClassTwoColumns,
                    type: "number",
                    name: "sensorMinimum",
                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            t([
                                "device:sensorMinimumValue"
                            ], {
                                defaultValue: "Sensor minimum ({{min}})",
                                min: "".concat(rangeMin, " ").concat(stringUnit)
                            }),
                            " ",
                            "*"
                        ]
                    }),
                    validators: [
                        "required"
                    ],
                    errorMessages: [
                        t([
                            "shared:fieldIsRequired"
                        ], {
                            defaultValue: "this field is required"
                        })
                    ],
                    value: sensorMin,
                    onChange: onSensorMinChange
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                    className: classes.textFields,
                    containerClass: classes.containerClassTwoColumns,
                    type: "number",
                    name: "sensorMaximum",
                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            t([
                                "device:sensorMaximumValue"
                            ], {
                                defaultValue: "Sensor maximum ({{max}})",
                                max: "".concat(rangeMax, " ").concat(stringUnit)
                            }),
                            " ",
                            "*"
                        ]
                    }),
                    validators: [
                        "required"
                    ],
                    errorMessages: [
                        t([
                            "shared:fieldIsRequired"
                        ], {
                            defaultValue: "this field is required"
                        })
                    ],
                    value: sensorMax,
                    onChange: onSensorMaxChange
                })
            ]
        }, 4), 
    ];
    var onDataMultiplierChange = function(e) {
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                analogOffset: 0,
                dataMultiplier: val.trim().length ? parseFloat(val) : undefined
            }
        });
    };
    var ref32;
    var dataMultiplierComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
        className: classes.textFields,
        containerClass: classes.containerClass,
        name: "dataMultiplier",
        type: "number",
        label: t([
            "device:dataMultiplier"
        ], {
            defaultValue: "Data multiplier"
        }),
        validators: [
            "required",
            "isPositive"
        ],
        errorMessages: [
            t([
                "shared:fieldIsRequired"
            ], {
                defaultValue: "this field is required"
            }),
            t([
                "shared:mustBePositive"
            ], {
                defaultValue: "must be a positive number"
            }), 
        ],
        value: state === null || state === void 0 ? void 0 : (ref14 = state.config) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.sensor) === null || ref15 === void 0 ? void 0 : ref15.dataMultiplier,
        helperText: !!(state === null || state === void 0 ? void 0 : (ref16 = state.config) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.sensor) === null || ref17 === void 0 ? void 0 : ref17.dataMultiplier) && (state === null || state === void 0 ? void 0 : (ref18 = state.config) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.sensor) === null || ref19 === void 0 ? void 0 : ref19.dataMultiplier) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: t([
                "device:configurationDataMultiplierExplanation"
            ], {
                defaultValue: "Future incoming data from the sensor will be multiplied by {{dataMultiplier}}. Old data will not be affected. If you change this value, remember to change target line speeds for your batches / products as well",
                dataMultiplier: (ref32 = state === null || state === void 0 ? void 0 : (ref20 = state.config) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.sensor) === null || ref21 === void 0 ? void 0 : ref21.dataMultiplier) !== null && ref32 !== void 0 ? ref32 : 1
            })
        }) : undefined,
        onChange: onDataMultiplierChange
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            analogInputOrMultiplier,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WiringSelection, {
                handleChange: handleChange,
                classes: classes,
                wiring: ((ref22 = state.config) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.sensor) === null || ref23 === void 0 ? void 0 : ref23.wiring) || null
            }),
            selectedAnalogInputOrMultiplierState === AnalogInputOrMultiplier.UseAnalogInput && analogInputRangeComponents,
            selectedAnalogInputOrMultiplierState === AnalogInputOrMultiplier.UseDataMultipler && dataMultiplierComponent,
            invalidFormMessage,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {})
        ]
    });
};

;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/speeds.tsx





var speeds_isShown = function(state) {
    var ref, ref1;
    var type = state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.type;
    return state.peripheralType === "SENSOR" && !!type && (type.startsWith("COUNTER") || type === schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS);
};
var round = function(value, decimals) {
    var num = Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals);
    return !isNaN(num) && num > 0 ? num : 0;
};
var speeds_TabProps = {
    isShown: function(s) {
        return speeds_isShown(s);
    },
    isValid: function(state) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
        return (state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.validatedSpeed) !== undefined && (state === null || state === void 0 ? void 0 : (ref2 = state.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : ref3.validatedSpeed) !== null && (state === null || state === void 0 ? void 0 : (ref4 = state.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sensor) === null || ref5 === void 0 ? void 0 : ref5.expectedSpeed) !== undefined && (state === null || state === void 0 ? void 0 : (ref6 = state.config) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sensor) === null || ref7 === void 0 ? void 0 : ref7.expectedSpeed) !== null && (state === null || state === void 0 ? void 0 : (ref8 = state.config) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sensor) === null || ref9 === void 0 ? void 0 : ref9.validatedSpeed) >= (state === null || state === void 0 ? void 0 : (ref10 = state.config) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.sensor) === null || ref11 === void 0 ? void 0 : ref11.expectedSpeed) && (state === null || state === void 0 ? void 0 : (ref12 = state.config) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.sensor) === null || ref13 === void 0 ? void 0 : ref13.expectedSpeed) > 0;
    },
    label: function(t) {
        return t("device:speeds", {
            defaultValue: "Speeds"
        });
    }
};
var speeds_TabPanel = function(param) {
    var handleChange = param.handleChange, state = param.state, invalidFormMessage = param.invalidFormMessage, t = param.t, classes = param.classes;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var sensorValidatedSpeedRef = react.useRef(null);
    var sensorExpectedSpeedRef = react.useRef(null);
    if (!speeds_isShown(state)) {
        return null;
    }
    var onValidatedSpeedChange = function(e) {
        var ref, ref1, ref2;
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                validatedSpeed: parseFloat(val)
            }
        });
        (ref = sensorExpectedSpeedRef.current) === null || ref === void 0 ? void 0 : ref.validate((ref1 = state.config) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sensor) === null || ref2 === void 0 ? void 0 : ref2.expectedSpeed);
    };
    var onExpectedSpeedChange = function(e) {
        var ref, ref1, ref2, ref3, ref4;
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                expectedSpeed: parseFloat(val),
                validatedSpeed: (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.validatedSpeed
            }
        });
        (ref2 = sensorValidatedSpeedRef.current) === null || ref2 === void 0 ? void 0 : ref2.validate((ref3 = state.config) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sensor) === null || ref4 === void 0 ? void 0 : ref4.validatedSpeed);
    };
    var ref16;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                ref: sensorValidatedSpeedRef,
                className: classes.textFields,
                containerClass: classes.containerClass,
                name: "validatedSpeed",
                type: "number",
                label: t([
                    "device:validatedSpeedInPcsPerMinute"
                ], {
                    defaultValue: "Validated speed in pcs per minute"
                }),
                validators: [
                    "required",
                    "isFloat",
                    "minNumber:" + (state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.expectedSpeed)
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }),
                    t([
                        "shared:mustNotBeLessThanExpectedSpeed"
                    ], {
                        defaultValue: "must not be less than expected speed"
                    }), 
                ],
                value: state === null || state === void 0 ? void 0 : (ref2 = state.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : ref3.validatedSpeed,
                helperText: !!(state === null || state === void 0 ? void 0 : (ref4 = state.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sensor) === null || ref5 === void 0 ? void 0 : ref5.validatedSpeed) && (state === null || state === void 0 ? void 0 : (ref6 = state.config) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sensor) === null || ref7 === void 0 ? void 0 : ref7.validatedSpeed) > 0 ? t([
                    "device:configurationValidatedSpeedExplanation"
                ], {
                    defaultValue: "The equipment is validated to run at {{validatedSpeed}} sec/pcs",
                    validatedSpeed: round(60 / ((state === null || state === void 0 ? void 0 : (ref8 = state.config) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sensor) === null || ref9 === void 0 ? void 0 : ref9.validatedSpeed) || 200), 2)
                }) : "",
                onChange: onValidatedSpeedChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                ref: sensorExpectedSpeedRef,
                className: classes.textFields,
                containerClass: classes.containerClass,
                type: "number",
                name: "expectedSpeed",
                label: t([
                    "device:expectedSpeedInPcsPerMinute"
                ], {
                    defaultValue: "Expected speed in pcs per minute"
                }),
                validators: [
                    "required",
                    "isFloat",
                    "minNumber:0.00001",
                    "maxNumber:" + (state === null || state === void 0 ? void 0 : (ref10 = state.config) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.sensor) === null || ref11 === void 0 ? void 0 : ref11.validatedSpeed)
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }),
                    t([
                        "shared:mustNotBeZero"
                    ], {
                        defaultValue: "must not be zero"
                    }),
                    t([
                        "shared:mustNotBeGreaterThanValidatedSpeed"
                    ], {
                        defaultValue: "must not be greater than validated speed"
                    }), 
                ],
                value: state === null || state === void 0 ? void 0 : (ref12 = state.config) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.sensor) === null || ref13 === void 0 ? void 0 : ref13.expectedSpeed,
                helperText: t([
                    "batches:expectedSpeedHelp"
                ], {
                    defaultValue: "The equipment is expected to run at {{expectedSpeed}} sec/pcs",
                    expectedSpeed: round(60 / ((ref16 = state === null || state === void 0 ? void 0 : (ref14 = state.config) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.sensor) === null || ref15 === void 0 ? void 0 : ref15.expectedSpeed) !== null && ref16 !== void 0 ? ref16 : 200), 2)
                }),
                onChange: onExpectedSpeedChange
            }),
            invalidFormMessage,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {})
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(50544);
// EXTERNAL MODULE: ./components/simple-search.tsx
var simple_search = __webpack_require__(43162);
// EXTERNAL MODULE: ./graphql/queries/stop-cause-mapping.gql
var stop_cause_mapping = __webpack_require__(70130);
var stop_cause_mapping_default = /*#__PURE__*/__webpack_require__.n(stop_cause_mapping);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(90918);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(79031);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Edit.js
var Edit = __webpack_require__(68870);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Flip.js
var Flip = __webpack_require__(38830);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Help.js
var Help = __webpack_require__(94618);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Table/Table.js
var Table = __webpack_require__(64882);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableBody/TableBody.js
var TableBody = __webpack_require__(71864);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableCell/TableCell.js
var TableCell = __webpack_require__(66361);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableHead/TableHead.js
var TableHead = __webpack_require__(16166);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableRow/TableRow.js
var TableRow = __webpack_require__(35483);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(60945);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/green.js
var green = __webpack_require__(51848);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ./graphql/mutations/device-update-stop-cause-mapping.gql
var device_update_stop_cause_mapping = __webpack_require__(83199);
var device_update_stop_cause_mapping_default = /*#__PURE__*/__webpack_require__.n(device_update_stop_cause_mapping);
// EXTERNAL MODULE: ./hocs/with-iam.tsx
var with_iam = __webpack_require__(67337);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(79857);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(55165);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/InputBase/InputBase.js
var InputBase = __webpack_require__(78511);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Select/Select.js + 1 modules
var Select = __webpack_require__(43281);
;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/stop-mapping/modify-stop-mapping.tsx

























var styles = function() {
    return {
        widest: {
            width: "50%"
        },
        secondWidest: {
            width: "20%"
        },
        selectPlaceholder: {
            color: "inherit",
            opacity: 0.46
        }
    };
};
var MAX_BUFFER_VALUE = 1..hours;
var NewStopMapping = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(NewStopMapping, _Component);
    var _super = (0,_create_super/* default */.Z)(NewStopMapping);
    function NewStopMapping(props) {
        (0,_class_call_check/* default */.Z)(this, NewStopMapping);
        var _this;
        _this = _super.call(this, props);
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.updateStopMapping = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _props, peripheralId, toMappingInput, updateStopCauseMapping, stopEditing, oldStopMap, newStopMap;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _props = _this1.props, peripheralId = _props.peripheralId, toMappingInput = _props.toMappingInput, updateStopCauseMapping = _props.updateStopCauseMapping, stopEditing = _props.stopEditing;
                        _this1.setState({
                            modifyingThis: true
                        });
                        if (!(_this1.props.mapping && _this1.checkForm())) return [
                            3,
                            2
                        ];
                        oldStopMap = toMappingInput(_this1.props.mapping);
                        newStopMap = toMappingInput(_this1.state.mapping);
                        return [
                            4,
                            updateStopCauseMapping({
                                variables: {
                                    peripheralId: peripheralId,
                                    deleteStopCauseMapping: [
                                        oldStopMap
                                    ],
                                    createStopCauseMapping: [
                                        newStopMap
                                    ]
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        stopEditing === null || stopEditing === void 0 ? void 0 : stopEditing();
                        _state.label = 2;
                    case 2:
                        _this1.setState({
                            modifyingThis: false
                        });
                        return [
                            2
                        ];
                }
            });
        });
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.createStopMapping = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _props, peripheralId, toMappingInput, updateStopCauseMapping, stopMap;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _props = _this2.props, peripheralId = _props.peripheralId, toMappingInput = _props.toMappingInput, updateStopCauseMapping = _props.updateStopCauseMapping;
                        _this2.setState({
                            modifyingThis: true
                        });
                        if (!_this2.checkForm()) return [
                            3,
                            2
                        ];
                        stopMap = toMappingInput(_this2.state.mapping);
                        return [
                            4,
                            updateStopCauseMapping({
                                variables: {
                                    peripheralId: peripheralId,
                                    deleteStopCauseMapping: [],
                                    createStopCauseMapping: [
                                        stopMap
                                    ]
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        _this2.setState({
                            modifyingThis: false
                        });
                        return [
                            2
                        ];
                }
            });
        });
        _this.checkForm = function() {
            var mapping = _this.state.mapping;
            var stopCauseName = mapping.stopCauseName === "" || mapping.stopCauseName === undefined;
            var stopCauseId = mapping.stopCauseId === "" || mapping.stopCauseId === undefined;
            var mappingTag = mapping.mappingTag === "" || mapping.mappingTag === undefined;
            var mappingValue = mapping.mappingValue === "" || mapping.mappingValue === undefined;
            var validPriority = 1 <= mapping.regPriority && mapping.regPriority <= 5;
            var validLookBack = 0 <= mapping.lookBack && mapping.lookBack < MAX_BUFFER_VALUE;
            var validLookForward = 0 <= mapping.lookForward && mapping.lookForward < MAX_BUFFER_VALUE;
            var error = stopCauseName || stopCauseId || mappingTag || mappingValue || !validPriority || !validLookBack || !validLookForward;
            _this.props.setError(error);
            return !error;
        };
        _this.handleTagChange = function(param) {
            var _target = param.target, mappingTag = _target.value;
            return _this.setState({
                mapping: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.mapping), {
                    mappingTag: mappingTag
                })
            });
        };
        _this.handleValueChange = function(param) {
            var _target = param.target, mappingValue = _target.value;
            return _this.setState({
                mapping: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.mapping), {
                    mappingValue: mappingValue
                })
            });
        };
        _this.handleStopCauseChange = function(param) {
            var _target = param.target, name = _target.value;
            var ref;
            if (typeof name !== "string") {
                return;
            }
            var id = ((ref = _this.props.stopCauses.find(function(stopCause) {
                return stopCause.name === name;
            })) === null || ref === void 0 ? void 0 : ref.id) || "";
            _this.setState({
                mapping: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.mapping), {
                    stopCauseId: id,
                    stopCauseName: name
                })
            });
        };
        _this.handlePriorityChange = function(param) {
            var value = param.target.value;
            if (typeof value !== "number") {
                return;
            }
            _this.setState({
                mapping: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.mapping), {
                    regPriority: value
                })
            });
        };
        _this.handleSplit = function(_, checked) {
            _this.setState({
                mapping: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.mapping), {
                    split: checked
                })
            });
        };
        _this.handleLookChange = function(attribute) {
            return function(param) {
                var value = param.target.value;
                var valueAsNumber = Number(value);
                if (isNaN(valueAsNumber)) {
                    return;
                }
                var valueInMilliseconds = valueAsNumber * 1000;
                if (MAX_BUFFER_VALUE < valueInMilliseconds) {
                    return;
                }
                _this.setState({
                    mapping: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.mapping), (0,_define_property/* default */.Z)({}, attribute, valueInMilliseconds))
                });
            };
        };
        _this.handleLookBackChange = _this.handleLookChange("lookBack");
        _this.handleLookForwardChange = _this.handleLookChange("lookForward");
        _this.baseMap = {
            stopCauseName: undefined,
            stopCauseId: "",
            mappingTag: "",
            mappingValue: "",
            regPriority: 1,
            split: false,
            lookBack: 0,
            lookForward: 0
        };
        _this.state = {
            mapping: props.mapping ? props.mapping : _this.baseMap,
            modifyingThis: false
        };
        return _this;
    }
    var _proto = NewStopMapping.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        if (nextProps.loading === false && this.props.loading === true) {
            this.setState({
                mapping: this.baseMap
            });
        }
        return true;
    };
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, permission = _props.permission, loading = _props.loading, stopCauses = _props.stopCauses, stopEditing = _props.stopEditing, t = _props.t, originialMapping = _props.mapping;
        var _state = this.state, updatedMapping = _state.mapping;
        var lookForwardInSeconds = Math.floor(updatedMapping.lookForward / 1000);
        var lookBackInSeconds = Math.floor(updatedMapping.lookBack / 1000);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    component: "th",
                    scope: "row",
                    className: classes.widest,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.ZP, {
                        value: updatedMapping.mappingTag,
                        fullWidth: true,
                        onChange: this.handleTagChange,
                        placeholder: t([
                            "shared:new"
                        ], {
                            defaultValue: "New"
                        })
                    }, "new-mapping-tag")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.ZP, {
                        value: updatedMapping.mappingValue,
                        onChange: this.handleValueChange,
                        fullWidth: true,
                        placeholder: t([
                            "shared:new"
                        ], {
                            defaultValue: "New"
                        })
                    }, "new-mapping-value")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    className: classes.secondWidest,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        value: updatedMapping.stopCauseName,
                        variant: "filled",
                        onChange: this.handleStopCauseChange,
                        fullWidth: true,
                        disableUnderline: true,
                        displayEmpty: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: undefined,
                                disabled: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: classes.selectPlaceholder,
                                    children: t([
                                        "shared:none"
                                    ], {
                                        defaultValue: "None"
                                    })
                                })
                            }),
                            stopCauses.map(function(stopCause) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: stopCause.name,
                                    children: stopCause.name
                                }, "".concat(stopCause.id));
                            })
                        ]
                    }, "new-mapping-stop-cause")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        value: updatedMapping.regPriority,
                        variant: "filled",
                        onChange: this.handlePriorityChange,
                        fullWidth: true,
                        input: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.ZP, {
                            style: {
                                minWidth: 35
                            }
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                style: {
                                    marginLeft: 0
                                },
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    checked: updatedMapping.split
                                }),
                                onChange: this.handleSplit,
                                label: t([
                                    "stop:splitStop"
                                ], {
                                    defaultValue: "Split stop"
                                })
                            }),
                            [
                                1,
                                2,
                                3,
                                4,
                                5
                            ].map(function(rank) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: rank,
                                    children: rank
                                }, "".concat(updatedMapping.stopCauseName, "_").concat(rank));
                            })
                        ]
                    }, "new-mapping-priority")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.ZP, {
                        value: lookBackInSeconds,
                        onChange: this.handleLookBackChange,
                        fullWidth: true
                    }, "new-mapping-lookback")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.ZP, {
                        value: lookForwardInSeconds,
                        onChange: this.handleLookForwardChange,
                        fullWidth: true
                    }, "new-mapping-lookforward")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    children: this.props.mapping ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mutation_button/* MutationIconButton */.t, {
                        color: "primary",
                        loading: loading && this.state.modifyingThis,
                        onClick: this.updateStopMapping,
                        disabled: permission,
                        tooltipPlacement: "left",
                        tooltipMsg: t([
                            "shared:update"
                        ], {
                            defaultValue: "Update"
                        }),
                        tooltipMsgDisabled: t([
                            "device:noPermissionToChangeConfiguration"
                        ], {
                            defaultValue: "You don't have permission to change the sensor configuration"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {})
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mutation_button/* MutationIconButton */.t, {
                        color: "primary",
                        loading: loading && this.state.modifyingThis,
                        onClick: this.createStopMapping,
                        disabled: permission,
                        tooltipPlacement: "right",
                        tooltipMsg: t([
                            "device:createNewStopMapping"
                        ], {
                            defaultValue: "Create new stop cause mapping"
                        }),
                        tooltipMsgDisabled: t([
                            "device:noPermissionToChangeConfiguration"
                        ], {
                            defaultValue: "You don't have permission to change the sensor configuration"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    children: this.props.mapping && /*#__PURE__*/ (0,jsx_runtime.jsx)(mutation_button/* MutationIconButton */.t, {
                        color: "primary",
                        onClick: stopEditing,
                        disabled: permission,
                        tooltipPlacement: "right",
                        tooltipMsg: t([
                            "shared:discard"
                        ], {
                            defaultValue: "Discard"
                        }),
                        tooltipMsgDisabled: t([
                            "device:noPermissionToChangeConfiguration"
                        ], {
                            defaultValue: "You don't have permission to change the sensor configuration"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {})
                    })
                })
            ]
        }, "new-stop-mapping");
    };
    return NewStopMapping;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,with_styles/* withStyles */.D)(styles), (0,withTranslation/* withTranslation */.Z)([
    "shared",
    "device"
]));
/* harmony default export */ var modify_stop_mapping = (enhance(NewStopMapping));

;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/stop-mapping/mapping-table.tsx































var mapping_table_styles = function(theme) {
    return {
        root: {
            width: "100%",
            overflowX: "hidden"
        },
        widest: {
            width: "50%"
        },
        secondWidest: {
            width: "20%"
        },
        error: {
            color: red/* default.700 */.Z[700]
        },
        helpIcon: {
            fontSize: "1em",
            color: "gray",
            marginBottom: "-2px",
            marginLeft: theme.spacing(0.5),
            marginRight: theme.spacing(0.5)
        }
    };
};
var MappingTable = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MappingTable, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(MappingTable);
    function MappingTable(props) {
        (0,_class_call_check/* default */.Z)(this, MappingTable);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            deleting: [],
            error: false,
            editing: null
        };
        _this.editMapping = function(i) {
            return function() {
                return _this.setState({
                    editing: i
                });
            };
        };
        _this.stopEditing = function() {
            return _this.setState({
                editing: null
            });
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.deleteMapping = function(updateStopCauseMapping, i) {
            return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var stopMap, deleting;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            stopMap = _this1.toMappingInput(_this1.props.stopMappings[i]);
                            deleting = (0,_to_consumable_array/* default */.Z)(_this1.state.deleting);
                            deleting[i] = true;
                            _this1.setState({
                                deleting: deleting
                            });
                            return [
                                4,
                                updateStopCauseMapping({
                                    variables: {
                                        peripheralId: _this1.props.peripheralId,
                                        deleteStopCauseMapping: [
                                            stopMap
                                        ],
                                        createStopCauseMapping: []
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
        };
        _this.toMappingInput = function(mapping) {
            return {
                peripheralIdTarget: _this.props.peripheralId,
                peripheralIdEvent: mapping.mappingTag,
                value: mapping.mappingValue,
                stopCauseId: mapping.stopCauseId,
                regPriority: mapping.regPriority,
                lookBack: mapping.lookBack,
                lookForward: mapping.lookForward,
                split: mapping.split || false
            };
        };
        _this.setError = function(error) {
            return _this.setState({
                error: error
            });
        };
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleComplete = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!data) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                _this2.props.refetchQuery()
                            ];
                        case 1:
                            _state.sent();
                            _this2.setState({
                                deleting: _this2.clear
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.clear = Array.from(props.stopMappings, function(map) {
            return false;
        });
        _this.state.deleting = _this.clear;
        return _this;
    }
    var _proto = MappingTable.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, classes = _props.classes, stopMappings = _props.stopMappings, stopCauses = _props.stopCauses, t = _props.t, hasPeripheralFeatures = _props.hasPeripheralFeatures, peripheralId = _props.peripheralId;
        var ref = (0,_to_array/* default */.Z)(peripheralId.split("-")), uuid = ref[0], indexParts = ref.slice(1);
        var index = indexParts.join("-");
        var permission = !hasPeripheralFeatures(peripheralId, [
            "Devices.Configuration"
        ], "M");
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                this.state.error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "caption",
                    className: classes.error,
                    children: [
                        "*",
                        t([
                            "shared:emptyFieldsErrorMessage"
                        ], {
                            defaultValue: "Every field needs to be set"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                    size: "small",
                    style: {
                        tableLayout: "fixed"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        className: classes.widest,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                            title: t([
                                                "device:mappingTagExplanation"
                                            ], {
                                                defaultValue: "The tag received from the PLC"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "body2",
                                                children: [
                                                    t([
                                                        "shared:mappingTag"
                                                    ], {
                                                        defaultValue: "Mapping Tag"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                                        className: classes.helpIcon
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                            title: t([
                                                "device:mappingValueExplanation"
                                            ], {
                                                defaultValue: "The value from a tag mapping to the stop cause"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "body2",
                                                children: [
                                                    t([
                                                        "shared:value"
                                                    ], {
                                                        defaultValue: "Value"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                                        className: classes.helpIcon
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        className: classes.secondWidest,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                            title: t([
                                                "device:mappingStopCauseExplanation"
                                            ], {
                                                defaultValue: "The stop cause for which the mapping should associate with"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "body2",
                                                children: [
                                                    t([
                                                        "shared:stopCause"
                                                    ], {
                                                        defaultValue: "Stop cause"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                                        className: classes.helpIcon
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                            title: t([
                                                "device:mappingPriorityExplanation"
                                            ], {
                                                defaultValue: "The priority determines the order of overruling, so a higher mapping priority will overrule a lower prioritized mapping"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "body2",
                                                children: [
                                                    t([
                                                        "shared:priority"
                                                    ], {
                                                        defaultValue: "Priority"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                                        className: classes.helpIcon
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                            title: t([
                                                "device:lookBackExplanation"
                                            ], {
                                                defaultValue: "Specifies how far back the system should look for matching stops, from the time an event is received. The maximum value is 3600 seconds"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "body2",
                                                children: [
                                                    t([
                                                        "device:lookBack"
                                                    ], {
                                                        defaultValue: "Look back"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                                        className: classes.helpIcon
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                            title: t([
                                                "device:lookForwardExplanation"
                                            ], {
                                                defaultValue: "Specifies how far forward the system should look for matching stops, from the time an event is received. The maximum value is 3600 seconds"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "body2",
                                                children: [
                                                    t([
                                                        "shared:lookForward"
                                                    ], {
                                                        defaultValue: "Look forward"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                                        className: classes.helpIcon
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Mutation/* Mutation */.m, {
                            mutation: (device_update_stop_cause_mapping_default()),
                            onCompleted: this.handleComplete,
                            refetchQueries: [
                                {
                                    query: (stop_cause_mapping_default()),
                                    variables: {
                                        uuid: uuid,
                                        index: index
                                    }
                                }
                            ],
                            awaitRefetchQueries: true,
                            children: function(updateStopCauseMapping, param) {
                                var loading = param.loading;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modify_stop_mapping, {
                                            peripheralId: peripheralId,
                                            permission: permission,
                                            stopCauses: stopCauses,
                                            toMappingInput: _this.toMappingInput,
                                            updateStopCauseMapping: updateStopCauseMapping,
                                            loading: loading && !_this.state.deleting.find(function(load) {
                                                return load;
                                            }),
                                            setError: _this.setError
                                        }),
                                        stopMappings.map(function(mapping, i) {
                                            if (i === _this.state.editing) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(modify_stop_mapping, {
                                                    mapping: mapping,
                                                    stopEditing: _this.stopEditing,
                                                    peripheralId: peripheralId,
                                                    permission: permission,
                                                    stopCauses: stopCauses,
                                                    toMappingInput: _this.toMappingInput,
                                                    updateStopCauseMapping: updateStopCauseMapping,
                                                    loading: loading && !_this.state.deleting.find(function(load) {
                                                        return load;
                                                    }),
                                                    setError: _this.setError
                                                });
                                            }
                                            var lookForwardInSeconds = Math.floor(mapping.lookForward / 1000);
                                            var lookBackInSeconds = Math.floor(mapping.lookBack / 1000);
                                            var priorityTitle = mapping.split ? "".concat(mapping.regPriority, " (").concat(t([
                                                "stop:splitStop"
                                            ], {
                                                defaultValue: "Split stop"
                                            }), ")") : mapping.regPriority;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                                hover: true,
                                                onClick: _this.editMapping(i),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        component: "th",
                                                        scope: "row",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: mapping.mappingTag,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                noWrap: true,
                                                                variant: "body2",
                                                                children: mapping.mappingTag
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: mapping.mappingValue,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                noWrap: true,
                                                                variant: "body2",
                                                                children: mapping.mappingValue
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: mapping.stopCauseName !== undefined ? mapping.stopCauseName : "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                noWrap: true,
                                                                variant: "body2",
                                                                children: mapping.stopCauseName
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: priorityTitle,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                style: {
                                                                    overflow: "visible"
                                                                },
                                                                noWrap: true,
                                                                variant: "body2",
                                                                children: [
                                                                    mapping.regPriority,
                                                                    mapping.split ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flip/* default */.Z, {
                                                                        style: {
                                                                            verticalAlign: "middle",
                                                                            marginLeft: "0.5em"
                                                                        },
                                                                        fontSize: "small"
                                                                    }) : null
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: lookBackInSeconds,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                noWrap: true,
                                                                variant: "body2",
                                                                children: lookBackInSeconds
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: lookForwardInSeconds,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                noWrap: true,
                                                                variant: "body2",
                                                                children: lookForwardInSeconds
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mutation_button/* MutationIconButton */.t, {
                                                            color: "primary",
                                                            loadingColor: green/* default.500 */.Z[500],
                                                            onClick: _this.editMapping(i),
                                                            disabled: permission,
                                                            tooltipPlacement: "left",
                                                            tooltipMsg: t([
                                                                "shared:edit"
                                                            ], {
                                                                defaultValue: "Edit"
                                                            }),
                                                            tooltipMsgDisabled: t([
                                                                "device:noPermissionToChangeConfiguration"
                                                            ], {
                                                                defaultValue: "You don't have permission to change the sensor configuration"
                                                            }),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Edit/* default */.Z, {})
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mutation_button/* MutationIconButton */.t, {
                                                            color: "primary",
                                                            loading: loading && _this.state.deleting[i],
                                                            loadingColor: red/* default.500 */.Z[500],
                                                            onClick: _this.deleteMapping(updateStopCauseMapping, i),
                                                            disabled: permission,
                                                            tooltipPlacement: "right",
                                                            tooltipMsg: t([
                                                                "shared:delete"
                                                            ], {
                                                                defaultValue: "Delete"
                                                            }),
                                                            tooltipMsgDisabled: t([
                                                                "device:noPermissionToChangeConfiguration"
                                                            ], {
                                                                defaultValue: "You don't have permission to change the sensor configuration"
                                                            }),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {})
                                                        })
                                                    })
                                                ]
                                            }, "".concat(mapping.mappingTag, "_").concat(mapping.mappingValue));
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                })
            ]
        });
    };
    return MappingTable;
}(react.PureComponent);
var mapping_table_enhance = (0,Recompose_esm/* compose */.qC)(with_iam/* withIAM */.$, (0,with_styles/* withStyles */.D)(mapping_table_styles), (0,withTranslation/* withTranslation */.Z)([
    "shared",
    "device"
]));
/* harmony default export */ var mapping_table = (mapping_table_enhance(MappingTable));

;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/stop-mapping/stops-mapping-tab.tsx










var stops_mapping_tab_isShown = function(state) {
    var ref, ref1, ref2, ref3;
    return state.peripheralType === "SENSOR" && !!((ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.type) && (((ref2 = state.config) === null || ref2 === void 0 ? void 0 : ref2.sensor.type.startsWith("COUNTER")) || ((ref3 = state.config) === null || ref3 === void 0 ? void 0 : ref3.sensor.type) === "DISCRETE");
};
var stops_mapping_tab_TabProps = {
    isShown: stops_mapping_tab_isShown,
    label: function(t) {
        return t("device:stopsMapping", {
            defaultValue: "Stops mapping"
        });
    }
};
var StopMappingTab = function(param) {
    var invalidFormMessage = param.invalidFormMessage, classes = param.classes, t = param.t, peripheralId = param.peripheralId;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(""), searchValue = ref4[0], setSearchValue = ref4[1];
    var ref5 = (0,_to_array/* default */.Z)(peripheralId.split("-")), uuid = ref5[0], indexParts = ref5.slice(1);
    var index = indexParts.join("-");
    var header = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                children: t([
                    "device:plcMappingText"
                ], {
                    defaultValue: "Create unique mappings between PLC messages and stop causes"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "caption",
                display: "block",
                style: {
                    marginTop: "4px",
                    marginBottom: "16px",
                    maxWidth: "75%"
                },
                children: t([
                    "device:dragMouserOverToSeeExplanations"
                ], {
                    defaultValue: "Drag your mouse over the headers to see explanation. Clicking the + icon will immediately save the mapping, and clicking the delete icon will immediately delete the mapping."
                })
            })
        ]
    });
    var translatedValue = t([
        "sensor:stopsMappingsSearch"
    ], {
        defaultValue: "Search by tag, value and stop cause"
    });
    var searchField = /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_search/* default */.Z, {
        setSearch: setSearchValue,
        placeholder: translatedValue
    });
    var filterStopMappings = function(searchValue, stopCauseMappings) {
        return stopCauseMappings.filter(function(row) {
            var ref;
            return ((ref = row.stopCauseName) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(searchValue)) || row.mappingTag.toLowerCase().includes(searchValue) || row.mappingValue.toLowerCase().includes(searchValue);
        });
    };
    var ref6 = (0,client.useQuery)((stop_cause_mapping_default()), {
        ssr: false,
        fetchPolicy: "no-cache",
        errorPolicy: "all",
        variables: {
            uuid: uuid,
            index: index
        }
    }), refetch = ref6.refetch, data = ref6.data;
    var ref7;
    var stopCauseMappings = ((ref7 = data === null || data === void 0 ? void 0 : (ref = data.device) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.stopCauseMappings) !== null && ref7 !== void 0 ? ref7 : []).filter(helper_types/* isTruthy */.f);
    var ref8;
    var stopCauseCategories = ((ref8 = data === null || data === void 0 ? void 0 : (ref2 = data.device) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : ref3.stopCauseCategories) !== null && ref8 !== void 0 ? ref8 : []).filter(helper_types/* isTruthy */.f);
    var stopCauses = createStopCauses(stopCauseCategories);
    var stopMappings = stopCauseMappings.map(function(mapping) {
        var stopCauseName = stopCauses.find(function(stopCause) {
            return stopCause.id === mapping.stopCauseId;
        }) || {
            name: t([
                "device:deletedStopCause"
            ], {
                defaultValue: "Deleted Stop Cause "
            })
        };
        return {
            stopCauseId: mapping.stopCauseId,
            stopCauseName: stopCauseName.name,
            mappingTag: mapping.peripheralIdEvent,
            mappingValue: mapping.value,
            regPriority: mapping.regPriority || 1,
            lookForward: mapping.lookForward,
            lookBack: mapping.lookBack,
            split: mapping.split || false
        };
    });
    var filteredMaps = (0,react.useMemo)(function() {
        return filterStopMappings(searchValue, stopMappings);
    }, [
        searchValue,
        stopMappings
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            header,
            searchField,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mapping_table, {
                peripheralId: peripheralId,
                stopMappings: filteredMaps,
                stopCauses: stopCauses,
                refetchQuery: refetch
            }),
            invalidFormMessage
        ]
    });
};
var createStopCauses = function(stopCauseCategories) {
    var stopCauses = [];
    stopCauseCategories.map(function(category) {
        return category.stopCauses.filter(helper_types/* isTruthy */.f).map(function(cause) {
            stopCauses.push({
                name: "".concat(cause.name, " - ").concat(category.name),
                id: cause.id
            });
        });
    });
    return stopCauses;
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormGroup/FormGroup.js
var FormGroup = __webpack_require__(19152);
;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/tabs/stops.tsx







var stops_isShown = function(state) {
    var ref, ref1, ref2, ref3;
    return state.peripheralType === "SENSOR" && !!((ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.type) && (((ref2 = state.config) === null || ref2 === void 0 ? void 0 : ref2.sensor.type.startsWith("COUNTER")) || ((ref3 = state.config) === null || ref3 === void 0 ? void 0 : ref3.sensor.type) === "DISCRETE");
};
var stops_TabProps = {
    isShown: stops_isShown,
    isValid: function(state) {
        var ref;
        var sensor = (ref = state.config) === null || ref === void 0 ? void 0 : ref.sensor;
        return (sensor === null || sensor === void 0 ? void 0 : sensor.stopValueThreshold) !== undefined && (sensor === null || sensor === void 0 ? void 0 : sensor.stopValueThreshold) !== null && (sensor === null || sensor === void 0 ? void 0 : sensor.stopThreshold) !== null && (sensor === null || sensor === void 0 ? void 0 : sensor.stopThreshold) !== undefined && (sensor === null || sensor === void 0 ? void 0 : sensor.stopRegisterThreshold) !== null && (sensor === null || sensor === void 0 ? void 0 : sensor.stopRegisterThreshold) !== undefined && (sensor === null || sensor === void 0 ? void 0 : sensor.stopThreshold) >= 1..seconds && (sensor === null || sensor === void 0 ? void 0 : sensor.stopThreshold) <= (sensor === null || sensor === void 0 ? void 0 : sensor.stopRegisterThreshold) && (sensor === null || sensor === void 0 ? void 0 : sensor.stopValueThreshold) >= 0;
    },
    label: function(t) {
        return t("device:stopSetup", {
            defaultValue: "Stops"
        });
    }
};
var stops_TabPanel = function(param) {
    var handleChange = param.handleChange, state = param.state, classes = param.classes, t = param.t, invalidFormMessage = param.invalidFormMessage;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    if (!stops_isShown(state)) {
        return null;
    }
    var onStopThresholdChange = function(e) {
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                // Convert from seconds to milliseconds
                stopThreshold: val.trim().length ? parseInt(val, 10) * 1000 : undefined
            }
        });
    };
    var onStopValueThresholdChange = function(e) {
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                stopValueThreshold: val.trim().length ? parseFloat(val) : undefined
            }
        });
    };
    var onRegisterThresholdChange = function(e) {
        var val = e.target.value;
        if (val === "-") {
            val += "0";
        }
        handleChange({
            sensor: {
                // Convert from seconds to milliseconds
                stopRegisterThreshold: val.trim().length ? parseInt(val, 10) * 1000 : undefined
            }
        });
    };
    var changeFindStops = function(e, checked) {
        handleChange({
            sensor: {
                findStops: checked
            }
        });
    };
    var stopThresholdAsSecs = (state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensor) === null || ref1 === void 0 ? void 0 : ref1.stopThreshold) ? Math.floor(state.config.sensor.stopThreshold / 1000) : "";
    var stopRegisterThresholdAsSecs = (state === null || state === void 0 ? void 0 : (ref2 = state.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sensor) === null || ref3 === void 0 ? void 0 : ref3.stopRegisterThreshold) ? Math.floor((state === null || state === void 0 ? void 0 : (ref4 = state.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sensor) === null || ref5 === void 0 ? void 0 : ref5.stopRegisterThreshold) / 1000) : "";
    var ref18;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.tabPanel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                disabled: !(state === null || state === void 0 ? void 0 : (ref6 = state.config) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sensor) === null || ref7 === void 0 ? void 0 : ref7.findStops),
                type: "number",
                name: "stopThreshold",
                label: t([
                    "device:minimumStopDurationInSeconds"
                ], {
                    defaultValue: "Minimum stop duration in seconds"
                }),
                validators: [
                    "required",
                    "isPositive",
                    "minNumber:1"
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }),
                    t([
                        "shared:cannotBeLowerThanOne"
                    ], {
                        defaultValue: "the threshold cannot be lower than 1 second"
                    }), 
                ],
                value: stopThresholdAsSecs,
                helperText: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        t([
                            "device:configurationStopThresholdExplanation"
                        ], {
                            defaultValue: "All future stops will need to be at least {{stopThreshold}} seconds long before it is defined as a stop.",
                            stopThreshold: stopThresholdAsSecs
                        }),
                        t([
                            "device:configurationMinimumStopLengthExplanation"
                        ], {
                            defaultValue: "The minimum length of a stop is defined by the version of your Factbird"
                        }),
                        "."
                    ]
                }),
                onChange: onStopThresholdChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                disabled: !(state === null || state === void 0 ? void 0 : (ref8 = state.config) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sensor) === null || ref9 === void 0 ? void 0 : ref9.findStops),
                type: "number",
                name: "stopValueThreshold",
                label: t([
                    "device:stopValueThreshold"
                ], {
                    defaultValue: "Value threshold for when the sensor is thought of as stopped"
                }),
                validators: [
                    "required",
                    "isPositive"
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }), 
                ],
                helperText: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t([
                        "device:configurationStopValueThresholdExplanation"
                    ], {
                        defaultValue: "Producing less than {{stopValueThreshold}} pcs per minute will be considered a stop.",
                        stopValueThreshold: (ref18 = state === null || state === void 0 ? void 0 : (ref10 = state.config) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.sensor) === null || ref11 === void 0 ? void 0 : ref11.stopValueThreshold) !== null && ref18 !== void 0 ? ref18 : 0
                    })
                }),
                value: state === null || state === void 0 ? void 0 : (ref12 = state.config) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.sensor) === null || ref13 === void 0 ? void 0 : ref13.stopValueThreshold,
                onChange: onStopValueThresholdChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_validator/* default */.ZP, {
                className: classes.textFields,
                containerClass: classes.containerClass,
                disabled: !(state === null || state === void 0 ? void 0 : (ref14 = state.config) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.sensor) === null || ref15 === void 0 ? void 0 : ref15.findStops),
                type: "number",
                name: "stopRegisterThreshold",
                label: t([
                    "device:stopRegistrationThreshold"
                ], {
                    defaultValue: "Stop registration threshold in seconds"
                }),
                validators: [
                    "required",
                    "isPositive",
                    "minNumber:".concat(stopThresholdAsSecs)
                ],
                errorMessages: [
                    t([
                        "shared:fieldIsRequired"
                    ], {
                        defaultValue: "this field is required"
                    }),
                    t([
                        "shared:mustBePositive"
                    ], {
                        defaultValue: "must be a positive number"
                    }),
                    t([
                        "shared:cannotBeLowerThanMinStopDuration"
                    ], {
                        seconds: stopThresholdAsSecs,
                        defaultValue: "the threshold cannot be lower than the stop duration, which is {{ seconds }} seconds"
                    }), 
                ],
                // Convert from millis to seconds
                value: stopRegisterThresholdAsSecs,
                helperText: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t([
                        "device:configurationStopRegisterThresholdExplanation"
                    ], {
                        defaultValue: "You will only be prompted to register stops that are {{stopRegisterThreshold}} seconds or longer. Everything between {{stopThreshold}}s and {{stopRegisterThreshold}}s will be considered micro stops.",
                        stopRegisterThreshold: stopRegisterThresholdAsSecs,
                        stopThreshold: stopThresholdAsSecs
                    })
                }),
                onChange: onRegisterThresholdChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                style: {
                    marginTop: "12px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                        color: "primary",
                        onChange: changeFindStops,
                        checked: !!(state === null || state === void 0 ? void 0 : (ref16 = state.config) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.sensor) === null || ref17 === void 0 ? void 0 : ref17.findStops)
                    }),
                    label: t([
                        "shared:enableFindStops"
                    ], {
                        defaultValue: "Enable finding stops"
                    })
                })
            }),
            invalidFormMessage,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {})
        ]
    });
};

;// CONCATENATED MODULE: ./views/dialogs/sensor-settings/sensor-settings-dialog.tsx












































var sensor_settings_dialog_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    var _obj, _obj1;
    return {
        tabs: {
            '&[data-rwt-vertical="true"]': {
                display: "flex"
            },
            display: "inline-block"
        },
        tabList: {
            display: "flex",
            flexDirection: "column",
            flexShrink: 0,
            flexGrow: 0,
            borderRight: "1px solid #ddd",
            marginRight: "1rem",
            fontSize: "0.8rem"
        },
        tabPanel: (_obj = {
            padding: "20px",
            minHeight: "350px",
            width: "100%"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
            width: "70%"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
            width: "60%"
        }), _obj),
        dialogContainer: {
            display: "flex",
            flexDirection: "row"
        },
        textFields: {
            width: "100%"
        },
        selectFields: {
            width: "100%",
            textAlign: "left"
        },
        containerClass: {
            width: "100%",
            display: "block",
            textAlign: "center",
            marginLeft: "10px",
            paddingRight: "20px"
        },
        discreteContainer: {
            width: "100%",
            textAlign: "center",
            marginLeft: "10px",
            paddingRight: "20px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        },
        discreteAddButton: {
            flex: "0 0 auto",
            position: "relative",
            bottom: "10px"
        },
        containerClassTwoColumns: {
            width: "45%",
            display: "block",
            textAlign: "center",
            marginLeft: "10px",
            paddingRight: "20px"
        },
        dialogPaper: (0,_define_property/* default */.Z)({
            minHeight: "522px",
            maxHeight: "90vh"
        }, theme.breakpoints.down("md"), {
            minHeight: "100%",
            minWidth: "100%",
            margin: 0,
            borderRadius: 0
        }),
        centeredContainer: {
            display: "flex",
            justifyContent: "center",
            height: "100%",
            alignItems: "center"
        },
        checkboxField: {
            marginLeft: "0px"
        },
        dialogContent: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            padding: "0 0 24px 0px"
        }),
        createLineButton: {
            marginRight: "30px",
            marginLeft: "30px"
        },
        assignLineButton: {
            marginRight: "30px",
            marginLeft: "30px"
        },
        formControl: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2)
        },
        tab: (_obj1 = {
            alignItems: "start",
            border: 0,
            textAlign: "left",
            color: "black",
            padding: "0.8rem 2rem",
            margin: "0.2rem 0",
            width: "100%",
            transition: "background 0.3s cubic-bezier(0.22, 0.61, 0.36, 1)"
        }, (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.down("sm"), {
            padding: "0.8rem"
        }), (0,_define_property/* default */.Z)(_obj1, "&:hover", {
            outline: 0,
            backgroundColor: "#f4f4f4"
        }), (0,_define_property/* default */.Z)(_obj1, "borderLeft", "2px"), (0,_define_property/* default */.Z)(_obj1, "borderColor", "transparent"), (0,_define_property/* default */.Z)(_obj1, "borderStyle", "solid"), _obj1),
        invalidTab: {
            borderColor: theme.palette.error.main
        }
    };
});
var BaseTab = function(state, peripheral, t) {
    return function(param) {
        var label = param.label, isShown = param.isShown, isValid = param.isValid;
        // This lint is wrong, this callback returns a react component
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref = sensor_settings_dialog_useStyles(), classes = ref.classes, cx = ref.cx;
        if ((isShown === null || isShown === void 0 ? void 0 : isShown(state, peripheral)) === false) {
            return null;
        }
        var valid = !isValid || isValid(state, peripheral);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
            classes: {
                root: classes.tab
            },
            className: cx((0,_define_property/* default */.Z)({}, classes.invalidTab, !valid)),
            label: label(t)
        });
    };
};
var SensorSettingsDialog = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(false), hasChanges = ref5[0], setHasChanges = ref5[1];
    var ref6 = (0,react.useState)(null), config = ref6[0], setConfig = ref6[1];
    var ref7 = (0,react.useState)(false), discardDialogOpen = ref7[0], setDiscardDialogOpen = ref7[1];
    var ref8 = (0,react.useState)(false), triedToSave = ref8[0], setTriedToSave = ref8[1];
    var ref9 = (0,react.useState)(""), name = ref9[0], setName = ref9[1];
    var ref10 = (0,react.useState)(""), description = ref10[0], setDescription = ref10[1];
    var ref11 = (0,react.useState)(schema/* PeripheralType.SENSOR */.Ti.SENSOR), peripheralType = ref11[0], setPeripheralType = ref11[1];
    var collectedState = {
        hasChanges: hasChanges,
        config: config,
        discardDialogOpen: discardDialogOpen,
        triedToSave: triedToSave,
        name: name,
        description: description,
        peripheralType: peripheralType
    };
    var t = (0,use_translation/* useTranslation */.$)([
        "alarms",
        "device",
        "line",
        "shared",
        "sensor"
    ]).t;
    var classes = sensor_settings_dialog_useStyles().classes;
    var theme = (0,useTheme/* default */.Z)();
    var width = (0,use_width/* useWidth */.z)();
    var IAM = (0,use_iam/* useIAM */.e)();
    var formRef = (0,react.useRef)(null);
    var updateStateAfterFetchingData = function(data) {
        if (data === null || data === void 0 ? void 0 : data.peripheralByID) {
            setName(data.peripheralByID.name);
            setDescription(data.peripheralByID.description);
            setConfig(sensorConfigToUpdateItem(data));
            setPeripheralType(data.peripheralByID.peripheralType);
        }
    };
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,client.useLazyQuery)((sensor_settings_default()), {
        variables: {
            peripheralId: props.peripheralId || ""
        },
        fetchPolicy: "cache-and-network",
        onCompleted: updateStateAfterFetchingData
    }), 2), getSettings = ref12[0], ref13 = ref12[1], data = ref13.data, loading = ref13.loading, error = ref13.error;
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((device_update_peripheral_default()), {
        refetchQueries: props.refetchQueries
    }), 2), updateSensorMut = ref14[0], ref15 = ref14[1], loadingMut = ref15.loading;
    var handleChange = function(newConfig, meta) {
        var mergedConfig = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config, newConfig), {
            sensor: (config === null || config === void 0 ? void 0 : config.sensor) || (newConfig === null || newConfig === void 0 ? void 0 : newConfig.sensor) ? (0,_object_spread/* default */.Z)({}, config === null || config === void 0 ? void 0 : config.sensor, newConfig === null || newConfig === void 0 ? void 0 : newConfig.sensor) : null,
            camera: (config === null || config === void 0 ? void 0 : config.camera) || (newConfig === null || newConfig === void 0 ? void 0 : newConfig.camera) ? (0,_object_spread/* default */.Z)({}, config === null || config === void 0 ? void 0 : config.camera, newConfig === null || newConfig === void 0 ? void 0 : newConfig.camera) : null
        });
        setConfig(mergedConfig);
        if (meta) {
            if (typeof meta.name === "string") {
                setName(meta.name);
            }
            if (typeof meta.description === "string") {
                setDescription(meta.description);
            }
        }
        setHasChanges(true);
    };
    // Fetch data on dialog open
    (0,react.useEffect)(function() {
        if (props.dialogOpen && props.peripheralId !== null && typeof props.peripheralId !== "undefined" && props.peripheralId !== "") {
            setConfig(null);
            setHasChanges(false);
            getSettings({
                variables: {
                    peripheralId: props.peripheralId
                }
            });
        }
    }, [
        props.dialogOpen
    ]);
    // Update state when new data is fetched
    (0,react.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.peripheralByID) {
            setName(data.peripheralByID.name);
            setDescription(data.peripheralByID.description);
            setConfig(sensorConfigToUpdateItem(data));
            setHasChanges(false);
            setPeripheralType(data.peripheralByID.peripheralType);
        }
    }, [
        data
    ]);
    var tab = (0,use_url_query/* useURLQuery */.m)().tab;
    var hideLineTab = guards/* isSensor */.rq(data === null || data === void 0 ? void 0 : data.peripheralByID) ? (data === null || data === void 0 ? void 0 : data.peripheralByID) && (data === null || data === void 0 ? void 0 : data.peripheralByID.peripheralInformation) === undefined : true;
    var hideMissingAlarmsTab = peripheralType !== "SENSOR" || (config === null || config === void 0 ? void 0 : (ref = config.sensor) === null || ref === void 0 ? void 0 : ref.type) === schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS || !guards/* isSensor */.rq(data === null || data === void 0 ? void 0 : data.peripheralByID);
    var isEnergyMeter = (config === null || config === void 0 ? void 0 : (ref1 = config.sensor) === null || ref1 === void 0 ? void 0 : ref1.energyMeter) === true;
    var invalidFormMessage = null;
    var ref16, ref17, ref18;
    var enumTypes = {
        analogInputRanges: (ref16 = data === null || data === void 0 ? void 0 : (ref2 = data.analogInputRanges) === null || ref2 === void 0 ? void 0 : ref2.analogInputRanges) !== null && ref16 !== void 0 ? ref16 : [],
        units: (ref17 = data === null || data === void 0 ? void 0 : (ref3 = data.units) === null || ref3 === void 0 ? void 0 : ref3.units) !== null && ref17 !== void 0 ? ref17 : [],
        sensorTypes: (ref18 = data === null || data === void 0 ? void 0 : (ref4 = data.sensorTypes) === null || ref4 === void 0 ? void 0 : ref4.sensorTypes) !== null && ref18 !== void 0 ? ref18 : []
    };
    var tabProps = {
        state: collectedState,
        t: t,
        classes: classes
    };
    var tabPanelProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tabProps), {
        handleChange: handleChange,
        invalidFormMessage: invalidFormMessage
    });
    var DefaultTab = BaseTab(collectedState, data === null || data === void 0 ? void 0 : data.peripheralByID, t);
    var makeTabs = function(peripheralId) {
        return [
            {
                key: "basicInfo",
                label: t([
                    "device:basicInformation"
                ], {
                    defaultValue: "Basic information"
                }),
                tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultTab, (0,_object_spread/* default */.Z)({}, TabProps)),
                component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, (0,_object_spread/* default */.Z)({
                        enumTypes: enumTypes
                    }, tabPanelProps));
                }
            },
            {
                key: "camera",
                label: t([
                    "device:cameraSettings"
                ], {
                    defaultValue: "Camera"
                }),
                tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultTab, (0,_object_spread/* default */.Z)({}, camera_TabProps)),
                component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(camera_TabPanel, (0,_object_spread/* default */.Z)({}, tabPanelProps));
                }
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(guards/* isCamera */.Nr(data === null || data === void 0 ? void 0 : data.peripheralByID) ? [
            {
                key: "cameraAttachment",
                label: t([
                    "device:cameraSensors"
                ], {
                    defaultValue: "Attached sensors"
                }),
                tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultTab, (0,_object_spread/* default */.Z)({}, camera_attachment_TabProps)),
                component: function() {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(camera_attachment_TabPanel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tabPanelProps), {
                        peripheral: data === null || data === void 0 ? void 0 : data.peripheralByID
                    }));
                }
            }, 
        ] : []), (0,_to_consumable_array/* default */.Z)(guards/* isSensor */.rq(data === null || data === void 0 ? void 0 : data.peripheralByID) ? [
            {
                key: "sensor",
                label: t([
                    "device:sensorSetup"
                ], {
                    defaultValue: "Sensor"
                }),
                tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultTab, (0,_object_spread/* default */.Z)({}, sensor_TabProps)),
                component: function() {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(sensor_TabPanel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tabPanelProps), {
                        sensor: data === null || data === void 0 ? void 0 : data.peripheralByID,
                        enumTypes: enumTypes
                    }));
                }
            }, 
        ] : []), (0,_to_consumable_array/* default */.Z)(isEnergyMeter ? [] : [
            {
                key: "speeds",
                label: t([
                    "device:speeds"
                ], {
                    defaultValue: "Speeds"
                }),
                tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultTab, (0,_object_spread/* default */.Z)({}, speeds_TabProps)),
                component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(speeds_TabPanel, (0,_object_spread/* default */.Z)({}, tabPanelProps));
                }
            }, 
        ]), [
            {
                key: "data",
                label: t([
                    "device:dataSetup"
                ], {
                    defaultValue: "Data"
                }),
                tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultTab, (0,_object_spread/* default */.Z)({}, data_TabProps)),
                component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(data_TabPanel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tabPanelProps), {
                        enumTypes: enumTypes
                    }));
                }
            }, 
        ], (0,_to_consumable_array/* default */.Z)(isEnergyMeter ? [] : [
            {
                key: "stops",
                label: t([
                    "device:stopSetup"
                ], {
                    defaultValue: "Stops"
                }),
                tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultTab, (0,_object_spread/* default */.Z)({}, stops_TabProps)),
                component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(stops_TabPanel, (0,_object_spread/* default */.Z)({}, tabPanelProps));
                }
            },
            {
                key: "mapping",
                label: t([
                    "device:stopsMapping"
                ], {
                    defaultValue: "Stops mapping"
                }),
                tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultTab, (0,_object_spread/* default */.Z)({}, stops_mapping_tab_TabProps)),
                component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StopMappingTab, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tabPanelProps), {
                        peripheralId: peripheralId
                    }));
                }
            }, 
        ]), (0,_to_consumable_array/* default */.Z)(hideLineTab ? [] : [
            {
                key: "line",
                label: t([
                    "device:lineSetup"
                ], {
                    defaultValue: "Line"
                }),
                tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultTab, (0,_object_spread/* default */.Z)({}, line_TabProps)),
                component: function() {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(line_TabPanel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tabPanelProps), {
                        peripheral: data === null || data === void 0 ? void 0 : data.peripheralByID
                    }));
                }
            }, 
        ]), (0,_to_consumable_array/* default */.Z)(hideMissingAlarmsTab ? [] : [
            {
                key: "missingAlarms",
                label: t([
                    "device:missingDataAlarms"
                ], {
                    defaultValue: "Missing data alarms"
                }),
                tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultTab, (0,_object_spread/* default */.Z)({}, missing_alarms_TabProps)),
                component: function() {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(missing_alarms_TabPanel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tabPanelProps), {
                        stateConfigInput: config === null || config === void 0 ? void 0 : config.sensor
                    }));
                }
            }, 
        ]));
    };
    var tabsMeta = props.peripheralId ? makeTabs(props.peripheralId) : [];
    var selectedTab = Math.max(tabsMeta.findIndex(function(t) {
        return (t === null || t === void 0 ? void 0 : t.key) === tab;
    }), 0);
    var query = (0,router.useRouter)().query;
    var tabs = (0,react.useMemo)(function() {
        return tabsMeta.map(function(param) {
            var key = param.key, tab = param.tab;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                href: {
                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                        tab: key
                    })
                },
                children: tab
            }, key);
        });
    }, [
        tabsMeta
    ]);
    //////////////////////
    ///// Return Output
    if (!props.peripheralId) {
        return null;
    }
    var _selectedTab = tabsMeta[selectedTab], TabContent = _selectedTab.component;
    var sensorConfigToUpdateItem = function(config) {
        var peripheral = config.peripheralByID;
        if (guards/* isSensor */.rq(peripheral)) {
            var ref, ref1;
            var _$config = peripheral.config;
            var dataAlarm = peripheral.config.dataAlarm;
            var discreteConfig = peripheral.config.discreteConfig;
            var accumulatorConfig = peripheral.config.accumulatorConfig;
            return {
                sensor: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _$config), {
                    dataAlarm: dataAlarm,
                    discreteConfig: discreteConfig,
                    accumulatorConfig: accumulatorConfig,
                    sensorUnit: {
                        unit: (ref = peripheral.config.sensorUnit) === null || ref === void 0 ? void 0 : ref.unit,
                        label: ((ref1 = peripheral.config.sensorUnit) === null || ref1 === void 0 ? void 0 : ref1.label) || ""
                    }
                }),
                camera: null
            };
        } else if (guards/* isCamera */.Nr(peripheral)) {
            return {
                camera: {
                    retentionPeriodHours: 30..days / 1..hours
                },
                sensor: null
            };
        } else {
            throw new Error("Unable to determince sensor type in sensor settings dialog!");
        }
    };
    var handleReset = function() {
        setHasChanges(false);
        if (data === null || data === void 0 ? void 0 : data.peripheralByID) {
            setDiscardDialogOpen(false);
            setConfig(sensorConfigToUpdateItem(data));
        } else {
            setDiscardDialogOpen(false);
            setConfig(null);
        }
        props.handleDialogChange(false);
    };
    var handleCloseAndReset = function(discard) {
        return function() {
            if (hasChanges && !discard) {
                setDiscardDialogOpen(true);
            } else {
                handleReset();
            }
        };
    };
    var handleDiscardResponse = function(discard) {
        if (discard) {
            handleReset();
        } else {
            setDiscardDialogOpen(false);
        }
    };
    var handleClose = function() {
        handleCloseAndReset(false)();
    };
    var notImplemented = function() {
        return {};
    };
    var onDiscard = function() {
        return handleCloseAndReset(true)();
    };
    var onUpdateDeviceConf = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, input, ref4, sensor, camera, _ref, wiring, remainingConfig, newConfig, _defaultState, ref5, ref6, ref7, ref8, subscribers, newSubscriber;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            isFormValid()
                        ];
                    case 1:
                        if (!_state.sent()) return [
                            3,
                            3
                        ];
                        input = config;
                        ref4 = input || {}, sensor = ref4.sensor, camera = ref4.camera;
                        _ref = sensor || {}, wiring = _ref.wiring, remainingConfig = (0,_object_without_properties/* default */.Z)(_ref, [
                            "wiring"
                        ]);
                        newConfig = {
                            sensor: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, remainingConfig), {
                                wiring: (wiring === null || wiring === void 0 ? void 0 : wiring.desired) || (wiring === null || wiring === void 0 ? void 0 : wiring.reported)
                            }),
                            camera: camera
                        };
                        if ((ref = newConfig.sensor) === null || ref === void 0 ? void 0 : ref.accumulatorConfig) {
                            newConfig.sensor.accumulatorConfig = (0,_object_spread/* default */.Z)({}, newConfig.sensor.accumulatorConfig);
                        }
                        if ((ref1 = newConfig.sensor) === null || ref1 === void 0 ? void 0 : ref1.discreteConfig) {
                            newConfig.sensor.discreteConfig = (0,_object_spread/* default */.Z)({}, newConfig.sensor.discreteConfig);
                            ;
                            // https://github.com/BlackbirdHQ/meta/issues/1874
                            // Make sure that we default to a defaultState if nothing is set.
                            // The field is required in the UI, so we should never need to do this, but better err on the safe side.
                            newConfig.sensor.discreteConfig.defaultState = (_defaultState = newConfig.sensor.discreteConfig.defaultState) !== null && _defaultState !== void 0 ? _defaultState : schema/* DiscreteDeviceState.OFF */.zp.OFF;
                        }
                        if ((ref2 = newConfig.sensor) === null || ref2 === void 0 ? void 0 : ref2.dataAlarm) {
                            ;
                            subscribers = ((ref5 = newConfig.sensor) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.dataAlarm) === null || ref6 === void 0 ? void 0 : ref6.subscribers) ? (0,_to_consumable_array/* default */.Z)((ref7 = newConfig.sensor) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.dataAlarm) === null || ref8 === void 0 ? void 0 : ref8.subscribers) : [];
                            newSubscriber = subscribers.filter(function(subscriber) {
                                if (subscriber.value) {
                                    return subscriber;
                                }
                            });
                            newConfig.sensor.dataAlarm = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newConfig.sensor.dataAlarm), {
                                subscribers: (0,_to_consumable_array/* default */.Z)(newSubscriber)
                            });
                        }
                        if ((ref3 = newConfig.sensor) === null || ref3 === void 0 ? void 0 : ref3.sensorUnit) {
                            if (!newConfig.sensor.sensorUnit.label && !newConfig.sensor.sensorUnit.unit) {
                                newConfig.sensor.sensorUnit = null;
                            } else {
                                newConfig.sensor.sensorUnit = (0,_object_spread/* default */.Z)({}, newConfig.sensor.sensorUnit);
                            }
                        }
                        setTriedToSave(false);
                        if (!props.peripheralId) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            updateSensorMut({
                                variables: {
                                    peripheralId: props.peripheralId,
                                    meta: {
                                        name: name,
                                        description: description
                                    },
                                    config: newConfig
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        getSettings({
                            variables: {
                                peripheralId: props.peripheralId
                            }
                        });
                        handleReset();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        // For better user feedback, we tell the user that they are still missing fields, in case they didn't notice the
                        // red tab in the left-side.
                        setTriedToSave(true);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onUpdateDeviceConf() {
            return _ref.apply(this, arguments);
        };
    }();
    var isFormValid = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (ref = formRef.current) === null || ref === void 0 ? void 0 : ref.isFormValid(false)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent() || false
                        ];
                }
            });
        });
        return function isFormValid() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: props.dialogOpen,
        fullWidth: true,
        maxWidth: "xl",
        onClose: handleClose,
        classes: {
            paper: classes.dialogPaper
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* ValidatorForm */.WS, {
                ref: formRef,
                method: "post",
                instantValidate: true,
                onSubmit: notImplemented,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_header/* default */.Z, {
                        title: t([
                            "sensor:manageSensorSettings"
                        ], {
                            defaultValue: "Manage sensor settings"
                        }),
                        onClose: handleClose
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                        className: classes.dialogContent,
                        children: [
                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {}),
                            error && "Error",
                            config !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.dialogContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                                        indicatorColor: "primary",
                                        value: selectedTab,
                                        variant: (0,with_width/* isWidthDown */.Vf)("xl", width) ? "scrollable" : "fullWidth",
                                        orientation: "vertical",
                                        className: classes.tabList,
                                        children: tabs
                                    }),
                                    TabContent()
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                onClick: onDiscard,
                                color: "primary",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                        style: {
                                            marginRight: theme.spacing()
                                        }
                                    }),
                                    (0,with_width/* isWidthUp */.yJ)("md", width) ? t([
                                        "shared:discardChanges"
                                    ], {
                                        defaultValue: "Discard changes"
                                    }) : ""
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(mutation_button/* MutationButton */.j, {
                                color: "primary",
                                onClick: onUpdateDeviceConf,
                                withIcon: true,
                                disabled: loadingMut || !!((data === null || data === void 0 ? void 0 : data.peripheralByID) && !IAM.hasPeripheralFeatures(props.peripheralId, [
                                    "Devices.Configuration"
                                ], "M")),
                                tooltipMsgDisabled: loadingMut ? undefined : t([
                                    "device:noPermissionToChangeConfiguration"
                                ], {
                                    defaultValue: "You don't have permission to change the sensor configuration"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                        style: {
                                            marginRight: theme.spacing()
                                        }
                                    }),
                                    t([
                                        "shared:updateSensorConfiguration"
                                    ], {
                                        defaultValue: "Update sensor configuration"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(discard_changes_dialog/* default */.Z, {
                open: discardDialogOpen,
                handleResponse: handleDiscardResponse
            })
        ]
    });
};
/* harmony default export */ var sensor_settings_dialog = (SensorSettingsDialog);


/***/ })

}]);